import { jsx as d, jsxs as I, Fragment as ze } from "react/jsx-runtime";
import * as x from "react";
import ds, { useState as B, useEffect as U, useCallback as Te, useRef as G, forwardRef as bn, useLayoutEffect as pi, Children as Rn, isValidElement as Ct, useMemo as hi } from "react";
import * as us from "react-dom";
import ps from "video.js";
function hr(e) {
  var t, n, i = "";
  if (typeof e == "string" || typeof e == "number") i += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = hr(e[t])) && (i && (i += " "), i += n);
  } else for (n in e) e[n] && (i && (i += " "), i += n);
  return i;
}
function L() {
  for (var e, t, n = 0, i = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = hr(e)) && (i && (i += " "), i += t);
  return i;
}
const fr = (e = !1) => {
  const [t, n] = B(() => typeof window > "u" || e ? "" : window.location.hash || ""), i = (r) => {
    if (typeof window > "u") {
      console.warn("setHashHandler called in a non-browser environment. Hash will not be set.");
      return;
    }
    if (r === "" || r === "#") {
      const o = window.location.pathname + window.location.search;
      history.replaceState(null, "", o), n("");
      return;
    }
    const a = r.startsWith("#") ? r : `#${r}`;
    history.replaceState(null, "", a), n(a);
  };
  return U(() => {
    e && n(window.location.hash);
  }, []), [t, i];
}, mr = (e) => ({ scrollToItem: Te(
  (n) => {
    var i;
    n !== null && ((i = e == null ? void 0 : e.current) != null && i[n]) && e.current[n].scrollIntoView({ behavior: "smooth", inline: "center", block: "start" });
  },
  [e]
) });
function fi() {
  const [e, t] = B(!1);
  return U(() => {
    if (typeof document > "u")
      return;
    const n = document.documentElement, i = () => {
      t(n.getAttribute("dir") === "rtl");
    };
    i();
    const r = new MutationObserver((s) => {
      for (const a of s)
        a.type === "attributes" && a.attributeName === "dir" && i();
    });
    return r.observe(n, { attributes: !0 }), () => {
      r.disconnect();
    };
  }, []), e;
}
const hs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M12 2.586 21.414 12 12 21.414 2.586 12 12 2.586ZM5.414 12 12 18.586 18.586 12 12 5.414 5.414 12Z", clipRule: "evenodd" })), fs = (e) => /* @__PURE__ */ x.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("circle", { cx: 12, cy: 12, r: 12 }), /* @__PURE__ */ x.createElement("path", { d: "M16.8 9.21285L14.0129 12L16.8 14.787L14.787 16.8L12 14.0129L9.21285 16.8L7.19995 14.787L9.98705 12L7.19995 9.21285L9.21285 7.19995L12 9.98705L14.787 7.19995L16.8 9.21285Z", fill: "white" })), ms = (e) => /* @__PURE__ */ x.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("circle", { cx: 12, cy: 12, r: 12 }), /* @__PURE__ */ x.createElement("path", { d: "M10.6788 17.16L17.3577 6.83997H14.9857L10.221 14.1846L8.82701 11.6046H6.64233L10.1586 17.16H10.6788Z", fill: "white" })), gs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M10.8 2.8v14.6L5.5 12l-1.4 1.4 7.7 7.7 7.7-7.7-1.4-1.4-5.3 5.3V2.8h-2z" })), _s = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M21 11H6.4l5.3-5.3-1.4-1.4L2.6 12l7.7 7.7 1.4-1.4L6.4 13H21v-2z" })), vs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M22 8L12 18 2 8" })), ws = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M16 22L6 12 16 2" })), bs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M16.6 12L7.3 2.7l1.4-1.4 10 10 .7.7-.7.7-10 10-1.4-1.4 9.3-9.3z", clipRule: "evenodd" })), ys = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M2 16L12 6l10 10" })), xs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M2.6 13h14.6l-5.3 5.3 1.4 1.4L21 12l-7.7-7.7-1.4 1.4 5.3 5.3H2.6v2z" })), Es = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12.8 21.2V6.6L18 12l1.4-1.4-7.7-7.7L4 10.5l1.4 1.4 5.3-5.3v14.6h2z" })), Ss = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M2 2a1 1 0 00-1 1v15c0 .6.4 1 1 1h7a2 2 0 012 2 1 1 0 102 0 2 2 0 012-2h7c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1h-6a5 5 0 00-4 2 5 5 0 00-4-2H2zm11 15.5a4 4 0 012-.5h6V4h-5a3 3 0 00-3 3v10.5zm-2 0V7a3 3 0 00-3-3H3v13h6a4 4 0 012 .5z", clipRule: "evenodd" })), Ts = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M20 3h-1V1h-2v2H7V1H5v2H4a2 2 0 00-2 2v16c0 1.1.9 2 2 2h16a2 2 0 002-2V5a2 2 0 00-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z" })), Ns = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M20.5 6.4l-11 11L8.1 16l-4.6-4.6L4.9 10l4.6 4.6L19.1 5l1.4 1.4z", clipRule: "evenodd" })), Cs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12 15.7l6-6-1.4-1.4-4.6 4.6-4.6-4.6L6 9.7l6 6z" })), As = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M8.3 12l6 6 1.4-1.4-4.6-4.6 4.6-4.6L14.3 6l-6 6z" })), Ms = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M15.7 12l-6-6-1.4 1.4 4.6 4.6-4.6 4.6L9.7 18l6-6z" })), Is = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12 8.3l-6 6 1.4 1.4 4.6-4.6 4.6 4.6 1.4-1.4-6-6z" })), Rs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12 2a10 10 0 100 20 10 10 0 000-20z" })), ks = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M17.6 5L12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4 17.6 5z" })), Ls = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M0 0h20v20H0z" })), Ps = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M4 4v10h10" })), Os = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "m18.58 2.6 2.83 2.84a2 2 0 0 1 0 2.83l-7.44 7.44a2 2 0 0 1-2.83 0l-1.42-1.42 1.4-1.42 1.43 1.42 7.44-7.44-2.82-2.83-2.9 2.9-1.42-1.42 2.9-2.9a2 2 0 0 1 2.83 0ZM5.39 21.46l-2.83-2.82a2 2 0 0 1 0-2.83l7.48-7.48a2 2 0 0 1 2.83 0l1.42 1.42-1.41 1.41-1.42-1.42-7.48 7.48 2.82 2.83 2.9-2.9 1.42 1.41-2.9 2.9a2 2 0 0 1-2.83 0Z", clipRule: "evenodd" })), Ds = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M20 5.4L18.6 4 12 10.6 5.4 4 4 5.4l6.6 6.6L4 18.6 5.4 20l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L20 5.4z", clipRule: "evenodd" })), Vs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 80 80", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "m39.54 21.61.46-.01a9.1 9.1 0 0 1 9.12 8.57l.01.46v.34a9.09 9.09 0 0 1-8.67 9.02L40 40a9.1 9.1 0 0 1-9.14-9.03v-.34a9.09 9.09 0 0 1 8.68-9.02Zm.98-4.61H40a13.72 13.72 0 0 0-13.8 13.63v.34A13.7 13.7 0 0 0 39.48 44.6H40a13.72 13.72 0 0 0 13.8-13.13v-.85A13.7 13.7 0 0 0 40.52 17Zm17.33 45.5H63l-4.36-8.21a9.27 9.27 0 0 0-8.23-4.79H29.6a9.27 9.27 0 0 0-8.23 4.79L17 62.5h5.15l3.33-6.27a4.63 4.63 0 0 1 4.11-2.4h20.82a4.6 4.6 0 0 1 4.1 2.4l3.34 6.27Z", clipRule: "evenodd" })), $s = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M19.4 7.5h3.1V6h-3.1A2.3 2.3 0 0015 6H9.8V3.7h-6V6H1.5v1.5h2.3v2.3h6V7.5H15a2.3 2.3 0 001.4 1.4v5.5a3 3 0 00-2.1 2.1H1.5V18h12.9a3 3 0 005.7 0h2.4v-1.5h-2.4a3 3 0 00-2.1-2.1V8.9a2.3 2.3 0 001.4-1.4zm-11.1.8h-3v-3h3v3zm10.4 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" })), zs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.2L12 13.2 9.8 11H11zm-6 7h14v2H5v-2z" })), Hs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M7.2 9.5h9.6L12 14.3 7.2 9.5zm-.4-.4s0 0 0 0h0z" })), Bs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M12 22a10 10 0 100-20 10 10 0 000 20zm0-2a8 8 0 100-16 8 8 0 000 16z", clipRule: "evenodd" })), Fs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M22 6a2 2 0 00-2-2H4a2 2 0 00-2 2v12c0 1.1.9 2 2 2h16a2 2 0 002-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" })), Gs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M10 6v2H5v11h11v-5h2v6a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h6zm11-3v8h-2V6.4l-7.8 7.8-1.4-1.4L17.6 5H13V3h8z" })), Us = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M10.02 20L10 13H7v-3h3V8c0-2.7 1.67-4 4.08-4 1.15 0 2.14.09 2.43.12v2.83h-1.67c-1.3 0-1.56.62-1.56 1.53V10H17l-1 3h-2.72v7h-3.26z" })), qs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M22.6 11l-3-2.7V4.2L16.2.7H6.9v6H3.5A1.1 1.1 0 002.4 8V22a1.1 1.1 0 001.1 1.1H23V11.8a1.1 1.1 0 00-.4-.8zM7 21.8h-3V8.2h3v13.6zM15 2.1h.5L18 4.8v.5h-3v-3zm-6.7 0h5.2v4.5h4.5v3.4H8.4V2.3zm13.1 19.6H8.4V11.6h11.2v-1.3l2 1.7v9.8z" }), /* @__PURE__ */ x.createElement("path", { d: "M10.9 16.1h1.5v1.5h-1.5v-1.5zM13.9 16.1h1.5v1.5h-1.5v-1.5zM10.9 19.1h1.5v1.5h-1.5v-1.5zM13.9 19.1h1.5v1.5h-1.5v-1.5zM16.9 16.1h1.5v1.5h-1.5v-1.5zM16.9 19.1h1.5v1.5h-1.5v-1.5zM10.9 13.1h7.5v1.5h-7.5v-1.5z" })), Ws = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M4 1H3v22h18V6.6l-.3-.3-5-5-.3-.3H4Zm1 20V3h9v5h5v13H5ZM17.6 6 16 4.4V6h1.6Z", clipRule: "evenodd" })), Ys = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M4 1H3v22h18V6.6l-.3-.3-5-5-.3-.3H4zm1 20V3h9v5h5v13H5zM17.6 6L16 4.4V6h1.6zM11 8v6.7l-2.3-2.1L7.3 14l4 3.7.7.7.7-.7 4-3.7-1.4-1.4-2.3 2.1V8h-2z", clipRule: "evenodd" })), js = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M14.126 9H3V7h11.126A4.002 4.002 0 0 1 22 8a4 4 0 0 1-7.874 1ZM16 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-6.126 7H21v2H9.874A4.002 4.002 0 0 1 2 16a4 4 0 0 1 7.874-1ZM8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z", clipRule: "evenodd" })), Xs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12 2a10 10 0 100 20 10 10 0 000-20zm8 9h-2.8c-.2-2.2-.8-4.3-1.8-6.2a8 8 0 014.5 6.2zm-7.5-7a13 13 0 012.7 7H9c.2-2.6 1-5 2.5-7h1zm-3.8.7c-1 2-1.6 4-1.7 6.3H4a8 8 0 014.7-6.3zM4 13h3c0 2.4.6 4.5 1.5 6.2A8 8 0 014.1 13zm7.3 7A12 12 0 019 13h6.2c-.3 2.8-1.2 5.2-2.6 7h-1.2zm4-.8c1-1.8 1.6-3.9 1.8-6.2h2.7a8 8 0 01-4.4 6.2z" })), Zs = (e) => /* @__PURE__ */ x.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M16 2.66797C23.3635 2.66823 29.3338 8.63749 29.334 16.001L29.3291 16.3457C29.1464 23.5502 23.2484 29.3347 16 29.335L15.6562 29.3301C8.45147 29.1476 2.66602 23.2497 2.66602 16.001C2.66619 8.63744 8.63646 2.66815 16 2.66797ZM11.4668 16.75C11.4316 20.6051 12.3508 24.4886 14.3926 27.7256C14.9181 27.797 15.4549 27.8349 16 27.835C16.3641 27.8349 16.7243 27.8174 17.0801 27.7852C19.2714 24.5278 20.4099 20.6217 20.5713 16.75H11.4668ZM22.0742 16.75C21.9287 20.4557 20.9419 24.1863 19.0693 27.4297C23.8842 26.1395 27.4884 21.8909 27.8096 16.75H22.0742ZM4.19043 16.75C4.49969 21.7009 7.85341 25.8248 12.4014 27.2754C10.7035 24.0621 9.93291 20.3921 9.96484 16.75H4.19043ZM13.4238 4.45215C8.36404 5.57573 4.52339 9.93586 4.19043 15.25H10.0225C10.2928 11.3358 11.479 7.53296 13.4238 4.45215ZM16 4.16797C15.8077 4.16797 15.6159 4.17256 15.4258 4.18164C13.193 7.18909 11.8294 11.1529 11.5293 15.25H20.584C20.4874 11.1614 19.3007 7.212 17.1025 4.21973C16.7395 4.18617 16.3718 4.16798 16 4.16797ZM19.1543 4.5957C21.0089 7.65792 22.0031 11.4027 22.0879 15.25H27.8096C27.4894 10.1404 23.9259 5.91256 19.1543 4.5957Z", fill: "currentColor" })), Ks = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12.22 3a9.23 9.23 0 0 0-8.23 4.97 8.71 8.71 0 0 0 0 8.05A9.23 9.23 0 0 0 12.22 21c2.53 0 4.6-.82 6.08-2.17a8.68 8.68 0 0 0 2.7-6.6c0-.3-.01-.6-.04-.9h-7.74v1.76h5.73l-.24 1.2a5.64 5.64 0 0 1-2.48 3.62 7.26 7.26 0 0 1-4.01 1.13A7.09 7.09 0 0 1 5.16 12a7.09 7.09 0 0 1 7.05-7.04c1.42 0 2.74.39 3.86 1.16l1.48-1.45A8.93 8.93 0 0 0 12.22 3ZM2.2 7.06A11.23 11.23 0 0 1 12.2 1a10.9 10.9 0 0 1 7.51 2.87l.78.71-.75.74-2.92 2.85-.68.67-.7-.65a4.61 4.61 0 0 0-3.23-1.23A5.09 5.09 0 0 0 7.16 12c0 .56.1 1.08.27 1.57v.02a5.09 5.09 0 0 0 4.79 3.45c1.2 0 2.17-.31 2.91-.8.48-.31.86-.7 1.14-1.15h-5.05V9.33h11.46l.14.84c.11.65.18 1.34.18 2.05 0 3.3-1.2 6.14-3.36 8.1A10.85 10.85 0 0 1 12.22 23c-4.38 0-8.17-2.47-10.01-6.06a10.71 10.71 0 0 1 0-9.88Z", clipRule: "evenodd" })), Qs = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16z" })), Js = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12 5.44c2.14 0 2.39.01 3.23.05.51 0 1.01.1 1.49.27.35.13.66.34.92.6.26.26.47.58.6.92.17.48.27.98.27 1.49.04.84.05 1.1.05 3.23s0 2.4-.05 3.23c0 .51-.1 1.01-.27 1.49a2.64 2.64 0 01-1.52 1.52c-.48.17-.98.27-1.48.27-.85.04-1.1.05-3.24.05-2.13 0-2.39 0-3.23-.05-.5 0-1.01-.1-1.49-.27a2.47 2.47 0 01-.92-.6 2.47 2.47 0 01-.6-.92 4.42 4.42 0 01-.27-1.49c-.04-.84-.05-1.1-.05-3.23s.01-2.39.05-3.23c0-.51.1-1.01.27-1.49.13-.35.34-.66.6-.92.26-.26.58-.47.92-.6.48-.17.98-.27 1.49-.27.84-.04 1.1-.05 3.23-.05zM12 4c-2.17 0-2.45 0-3.3.05-.66.01-1.32.14-1.94.37a3.9 3.9 0 00-1.42.92c-.4.4-.72.89-.92 1.42a5.87 5.87 0 00-.37 1.94C4 9.56 4 9.83 4 12s0 2.45.05 3.3c.01.66.14 1.32.37 1.94.2.53.52 1.02.92 1.42.4.4.89.72 1.42.92.62.23 1.28.36 1.94.37.86.04 1.13.05 3.3.05s2.45 0 3.3-.05a5.87 5.87 0 001.94-.37 4.1 4.1 0 002.34-2.34c.24-.62.36-1.28.37-1.94.04-.86.05-1.13.05-3.3 0-2.18 0-2.45-.05-3.3a5.87 5.87 0 00-.37-1.94 3.9 3.9 0 00-.92-1.42 3.9 3.9 0 00-1.42-.92 5.87 5.87 0 00-1.94-.37C14.44 4 14.17 4 12 4zm0 3.9a4.1 4.1 0 100 8.2 4.1 4.1 0 000-8.2zm0 6.77a2.67 2.67 0 110-5.34 2.67 2.67 0 010 5.34zm5.23-6.94a.96.96 0 11-1.92 0 .96.96 0 011.92 0z", clipRule: "evenodd" })), ea = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M19.3 4H4.7c-.4 0-.7.3-.7.7v14.7c0 .3.3.6.7.6h14.7c.4 0 .7-.3.7-.7V4.7c-.1-.4-.4-.7-.8-.7zM8.7 17.6H6.4V10h2.4v7.6h-.1zM7.6 9c-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4-.1.7-.7 1.4-1.4 1.4zm10 8.6h-2.4v-3.7c0-.9 0-2-1.2-2s-1.4 1-1.4 2v3.8h-2.4V10h2.3v1c.3-.6 1.1-1.2 2.2-1.2 2.4 0 2.8 1.6 2.8 3.6v4.2h.1z" })), ta = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" })), na = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M5.298 16.359 7.657 14H2v5.657l1.86-1.86A9.99 9.99 0 0 0 12 22c4.83 0 8.87-3.44 9.8-8h-2.05c-.9 3.45-4.03 6-7.75 6a7.998 7.998 0 0 1-6.702-3.641ZM16.343 10H22V4.343l-1.86 1.86A9.99 9.99 0 0 0 12 2c-4.83 0-8.87 3.44-9.8 8h2.05c.9-3.45 4.03-6 7.75-6a8 8 0 0 1 6.703 3.641L16.343 10Z", clipRule: "evenodd" })), ia = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M5 9a7 7 0 1114 0c0 5.3-7 13-7 13S5 14.2 5 9zm7-5a5 5 0 00-5 5c0 2.8 3 7.2 5 9.9 2.1-2.7 5-7 5-9.9a5 5 0 00-5-5zm2.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" })), ra = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72 40", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M16.2 39h39.7L72 19.5 55.9 0H16.2L0 19.5 16.2 39zM55 37H17L2.6 19.4 17.1 2H55l14.5 17.6L55 36.9zM17 19.1v6.9h-2.2V10.8h4.3c1.2 0 2 .3 2.8 1 .6.8 1 1.7 1 3a4 4 0 01-.6 2.2c-.3.6-.8 1-1.4 1.3.3.1.6.4.9.7l.4 1.5.6 5.5h-2.2l-.5-5.3c-.1-.5-.2-.9-.5-1.1-.2-.2-.5-.4-1-.4H17zm0-6.4v4.4H19c.5 0 1-.1 1.2-.5.4-.4.5-1 .5-1.7 0-.8-.2-1.3-.5-1.7-.2-.3-.7-.5-1.2-.5H17zm13 13c-.5.3-1.2.5-2 .5s-1.4-.2-2-.6c-.6-.3-1.1-.9-1.4-1.6-.4-.6-.5-1.5-.5-2.4v-2c0-1 .1-1.8.5-2.5A3.7 3.7 0 0128 15c.8 0 1.4.2 2 .6.6.4 1.1.9 1.4 1.6.4.7.5 1.5.5 2.4v2.1c0 1-.1 1.8-.5 2.4-.3.7-.8 1.3-1.4 1.6zm-3.4-2.1c.4.4.8.6 1.4.6.6 0 1-.2 1.4-.6.3-.5.5-1.1.5-2v-2.2a3 3 0 00-.5-1.9c-.4-.4-.8-.6-1.4-.6-.6 0-1 .2-1.4.6a3 3 0 00-.5 1.9v2.3c0 .8.2 1.4.5 1.9zm13.5 1.7c-.6.6-1.5 1-2.5 1-1.2 0-2.2-.5-2.9-1.3a5 5 0 01-1-3.4v-2a5 5 0 011-3.4c.8-.9 1.7-1.3 3-1.3 1 0 1.9.3 2.5 1 .6.5 1 1.4 1.2 2.5l-2 .5c-.2-1.4-.8-2-1.8-2-.6 0-1 .2-1.4.6-.3.5-.5 1.1-.5 1.9v2.3c0 .8.2 1.4.5 1.9.4.4.8.6 1.4.6.5 0 .9-.1 1.2-.5.3-.3.5-.8.6-1.5l2 .5c-.2 1.1-.6 2-1.3 2.6zm4.9-6.5V26h-2V10.8h2V16c.2-.3.5-.5 1-.8a3 3 0 011.4-.3c1 0 1.7.3 2.2 1 .5.5.8 1.4.8 2.5V26h-2v-7.2c0-.6-.2-1.1-.5-1.5-.3-.3-.7-.5-1.2-.5s-1 .2-1.2.5A2 2 0 0045 19zm13.6-2.7c.6.8 1 2 1 3.3V21H54v.9c0 .8.2 1.4.5 1.9.4.4.8.6 1.3.6s.9-.1 1.2-.5c.3-.3.5-.7.6-1.3l1.8.4c-.1 1-.5 1.8-1.1 2.4-.7.6-1.5.9-2.5.9-1.2 0-2-.4-2.8-1.3-.7-.8-1-2-1-3.4v-2c0-1 .1-1.7.5-2.5.3-.6.8-1.2 1.3-1.6.6-.3 1.3-.5 2-.5 1.2 0 2 .4 2.8 1.2zm-1.4 1.3c-.4-.5-.8-.7-1.4-.7-.5 0-1 .2-1.2.7-.4.4-.5 1-.5 1.8v.3h3.5v-.4a3 3 0 00-.4-1.7z", clipRule: "evenodd" })), sa = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M9.1 22L2 19.8v-16l6.9 2.2 7-4L22 4.3v16.2L16 18l-6.9 4zM4 6.5v11.9l4 1.3V7.7L4 6.4zm10-1.1l-4 2.3v11.7l4-2.3V5.3zM16 4V16l4 1.6V5.7L16 4z" })), aa = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M19 2v2h-2v3a3 3 0 013 3v11a1 1 0 01-1 1H5a1 1 0 01-1-1V10a3 3 0 013-3V4H5V2h14zm-2 7H7a1 1 0 00-1 1v10h12V10a1 1 0 00-1-1zm-4 2v2h2v2h-2v2h-2v-2H9v-2h2v-2h2zm2-7H9v3h6V4z" })), oa = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M4 11h16v2H4v-2z" })), la = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M15.5 1h-8A2.5 2.5 0 005 3.5v17C5 21.9 6.1 23 7.5 23h8c1.4 0 2.5-1.1 2.5-2.5v-17C18 2.1 16.9 1 15.5 1zm-4 21a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm4.5-4H7V4h9v14z" })), ca = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M15.132 16.192L6.47 24.854l1.06 1.061 8.662-8.662 8.663 8.662 1.06-1.06-8.662-8.663 8.662-8.662-1.06-1.06-8.663 8.662L7.53 6.47 6.47 7.53l8.662 8.662z" })), da = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M29 8.75H3v-1.5h26v1.5zm0 7.5H3v-1.5h26v1.5zm0 7.5H3v-1.5h26v1.5z" })), ua = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M22.167 13.333a7.833 7.833 0 11-15.667 0 7.833 7.833 0 0115.667 0zm-2.568 7.708a9.333 9.333 0 111.168-.945l6.121 6.733-1.11 1.009L19.6 21.04z" })), pa = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M4 11a7 7 0 0 0 7-7h2a7 7 0 0 0 7 7v2a7 7 0 0 0-7 7h-2a7 7 0 0 0-7-7v-2Zm4.127 1A9.04 9.04 0 0 1 12 15.873 9.04 9.04 0 0 1 15.873 12 9.04 9.04 0 0 1 12 8.127 9.04 9.04 0 0 1 8.127 12Z", clipRule: "evenodd" })), ha = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M4 17.8V6.2l8-1.7v15l-8-1.7ZM2 4.6l10-2.2 2-.4v4h8.5v12H14v4l-2-.4-10-2.2V4.6Zm12 5.8V16h6.5v-6l-3.4 2.3-.7.5-.6-.6-1.8-1.8ZM19.8 8h-5.4l2.2 2.2L19.8 8ZM7 12c0-.7.2-1.2.4-1.6L8 10c.1 0 .3 0 .6.4a3.4 3.4 0 0 1 0 3.2L8 14c-.1 0-.3 0-.6-.4-.2-.4-.4-1-.4-1.6Zm1-4c-1 0-1.8.6-2.2 1.3a5 5 0 0 0 0 5.4C6.2 15.4 7 16 8 16c1 0 1.8-.6 2.2-1.3a5 5 0 0 0 0-5.4A2.7 2.7 0 0 0 8 8Z", clipRule: "evenodd" })), fa = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12.2 3a.7.7 0 00-.5.2h-.1a6.3 6.3 0 00-7.8 4.2c-.3 1-.4 2-.2 3l-1 1a2.1 2.1 0 00.9 3.4c.3.1.6.2 1 .1a2.1 2.1 0 001.8 1.6 2.1 2.1 0 002 2c0 .4.3 1 .6 1.3.8.8 2 .8 2.8.2l.4.4a2.2 2.2 0 003.7-1.3 2.1 2.1 0 001.9-2 2.1 2.1 0 001.9-1.6 2.1 2.1 0 002.4-2 2.1 2.1 0 00-.7-1.6l-.8-.8.2-.7a6 6 0 00-2.8-6.6 6 6 0 00-3-.8h-1.7-1zm3 5l3.4 3.4 1.7 1.6a.6.6 0 01-.5 1l-.4-.1-1.6-1.7a.8.8 0 00-1.1 0 .7.7 0 000 1.1l1.2 1.3a.6.6 0 01-.4 1h-.4a.8.8 0 00-1.2.5c0 .2 0 .3.2.5a.6.6 0 01-.5 1c-.1 0-.3 0-.4-.2a.8.8 0 00-1.2.6l.1.5a.6.6 0 01-.5 1c-.1 0-.3 0-.4-.2l-.4-.3.1-.2a2.1 2.1 0 00-1.4-3.6 2.1 2.1 0 00-2-2 2.1 2.1 0 00-1.4-1.8h-1a2.1 2.1 0 00-2-1.7 4.7 4.7 0 013-4.9c.6-.2 1.2-.3 1.9-.3L8.5 5.6a2.3 2.3 0 001 4.2c.7 0 1.3 0 1.8-.5L13.2 8h2zM9.4 6.7l3.1-2.3h2.3a4.5 4.5 0 014.5 5.3L16 6.6a.7.7 0 00-.6-.2H13c-.1 0-.3 0-.4.2L10.4 8a.8.8 0 01-1.3-.4.8.8 0 01.3-.9zm-3.4 8a.6.6 0 010-.9l1-1a.6.6 0 01.9 0 .6.6 0 010 1l-1 .9a.6.6 0 01-.9 0zm-.5-3.4a.6.6 0 010 .9l-1 1a.6.6 0 01-1-.3.6.6 0 01.2-.6l1-1a.6.6 0 01.8 0zm5.4 7.3a.6.6 0 01-1-.2.6.6 0 01.1-.6l1-1a.6.6 0 011 .2.6.6 0 01-.2.7l-1 1zm-2-2a.6.6 0 01-1.1-.4c0-.2 0-.3.2-.4l1-1a.6.6 0 011 .2.6.6 0 01-.2.7l-1 1z" })), ma = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M18.8 12h-6a1.5 1.5 0 00-1.6 1.5V18H3v-7.5H1.5v12H3v-3h18v3h1.5v-6.8a3.8 3.8 0 00-3.8-3.7zm2.2 6h-8.3v-4.5h6a2.3 2.3 0 012.3 2.3V18z" }), /* @__PURE__ */ x.createElement("path", { d: "M7.1 12.8a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.3zm0-1.6a2.6 2.6 0 100 5.3 2.6 2.6 0 000-5.3zM15.8 4.5h-3v-3h-1.6v3h-3V6h3v3h1.6V6h3V4.5z" })), ga = (e) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M51 28C51 15.2975 40.7025 5 28 5C15.2975 5 5 15.2975 5 28C5 40.7025 15.2975 51 28 51V56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56V51C40.7025 51 51 40.7025 51 28Z" }), /* @__PURE__ */ x.createElement("path", { d: "M25.3333 19.75C25.3333 18.2312 24.1394 17 22.6667 17C21.1939 17 20 18.2312 20 19.75V36.25C20 37.7688 21.1939 39 22.6667 39C24.1394 39 25.3333 37.7688 25.3333 36.25V19.75Z" }), /* @__PURE__ */ x.createElement("path", { d: "M33.3333 17C34.8061 17 36 18.2312 36 19.75V36.25C36 37.7688 34.8061 39 33.3333 39C31.8606 39 30.6667 37.7688 30.6667 36.25V19.75C30.6667 18.2312 31.8606 17 33.3333 17Z" })), _a = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M6.5 5a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6zm8 3a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6zM4.3 9.3c.2-.2.4-.3.7-.3h5a1 1 0 011 1l-1 11c0 .6-.5 1-1 1H6a1 1 0 01-1-1L4 10c0-.2 0-.5.3-.7zM6 11l.8 9h1.2l.8-9H6.1zM14 9a1 1 0 00-1 1l1 11c0 .6.5 1 1 1h3c.5 0 1-.4 1-1l1-11a1 1 0 00-1-1h-5zm2 11l-.9-9h2.8l-.8 9h-1.2z", clipRule: "evenodd" })), va = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M6.5 5L7 7.6 5.8 8.8C5.4 7.6 5 6.3 5 5h1.5zm9.9 12c.9.3 1.7.4 2.6.5V19c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2zM7.5 3H4a1 1 0 00-1 1 17 17 0 0017 17c.6 0 1-.4 1-1v-3.5c0-.5-.4-1-1-1a11.4 11.4 0 01-3.9-.6 1 1 0 00-.7.3l-2.2 2.2a15.1 15.1 0 01-6.6-6.6l2.2-2.2c.3-.3.4-.7.3-1-.4-1.1-.6-2.3-.6-3.6 0-.5-.4-1-1-1z" })), wa = (e) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M51 28C51 15.2975 40.7025 5 28 5C15.2975 5 5 15.2975 5 28C5 40.7025 15.2975 51 28 51V56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56V51C40.7025 51 51 40.7025 51 28Z" }), /* @__PURE__ */ x.createElement("path", { d: "M37.8269 28.6792C37.7136 28.8855 37.5505 29.0569 37.3542 29.176L23.9374 37.3179C23.7411 37.4371 23.5183 37.4999 23.2915 37.5C23.0647 37.5 22.8419 37.4373 22.6456 37.3181C22.4491 37.1988 22.2861 37.0274 22.1727 36.8209C22.0595 36.6144 21.9998 36.3803 22 36.1419V19.8592C22 18.8146 23.0753 18.161 23.9374 18.6843L37.3542 26.8251C37.5505 26.9443 37.7136 27.1156 37.8269 27.3219C37.9402 27.5283 38 27.7623 38 28.0006C38 28.2388 37.9402 28.4729 37.8269 28.6792Z" })), ba = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M11.3 3.6h1.4l.2.1v16.6l-.2.1h-1.4l-.2-.1V3.6l.2-.1z" }), /* @__PURE__ */ x.createElement("path", { d: "M4.1 11.1H20c.1 0 .2 0 .2.2v1.4l-.2.2H4c-.1 0-.2 0-.2-.2v-1.4l.2-.2z" })), ya = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M14 12c0 .74-.4 1.38-1 1.72V22h-2v-8.28c-.6-.35-1-.98-1-1.72 0-1.1.9-2 2-2s2 .9 2 2Zm-2-6c-3.31 0-6 2.69-6 6 0 1.74.75 3.31 1.94 4.4l1.42-1.42A3.956 3.956 0 0 1 8 12c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.19-.53 2.25-1.36 2.98l1.42 1.42A5.957 5.957 0 0 0 18 12c0-3.31-2.69-6-6-6Zm0-4C6.48 2 2 6.48 2 12c0 2.85 1.2 5.41 3.11 7.24l1.42-1.42A7.986 7.986 0 0 1 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 2.29-.98 4.36-2.53 5.82l1.42 1.42C20.8 17.41 22 14.85 22 12c0-5.52-4.48-10-10-10Z" })), xa = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21zm4.4 13.7l-1.2 1.2L12 13l-3.2 3.3-1.2-1.2L11 12 7.6 8.8l1.2-1.2L12 11l3.2-3.3 1.2 1.2L13 12l3.3 3.2z" })), Ea = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M10 18a8 8 0 004.9-1.7l4.4 4.4 1.4-1.4-4.4-4.4A8 8 0 1010 18zm0-14a6 6 0 110 12 6 6 0 010-12z" })), Sa = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M22.167 13.333a7.833 7.833 0 1 1-15.667 0 7.833 7.833 0 0 1 15.667 0Zm-2.568 7.708a9.333 9.333 0 1 1 1.168-.945l6.121 6.733-1.11 1.009L19.6 21.04Z", clipRule: "evenodd" })), Ta = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74ZM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16Zm0-11.47L17.74 9 12 13.47 6.26 9 12 4.53Z" })), Na = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M26 21h-4.5v2h8v-8h-2v4.6l-10.3-9.3-.7-.7-.7.7-5.3 5.3-7.8-7.3-1.4 1.4 8.5 8 .7.7.7-.7 5.3-5.3L26 21Z", clipRule: "evenodd" })), Ca = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "m25.6 16.9-3.3 3.3 1.4 1.4 5-5 .7-.7-.7-.7-5-5-1.4 1.5 3.2 3.2H3v2h22.6Z", clipRule: "evenodd" })), Aa = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M26 10h-4.5V8h8v8h-2v-4.6l-10.3 9.3-.7.7-.7-.7-5.3-5.3-7.8 7.3-1.4-1.4 8.5-8 .7-.7.7.7 5.3 5.3L26 10Z", clipRule: "evenodd" })), Ma = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16z" }), /* @__PURE__ */ x.createElement("path", { d: "M13 7h-2v6h6v-2h-4V7z" })), Ia = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M17.1761 4H19.9362L13.9061 10.7774L21 20H15.4456L11.0951 14.4066L6.11723 20H3.35544L9.80517 12.7508L3 4H8.69545L12.6279 9.11262L17.1761 4ZM16.2073 18.3754H17.7368L7.86441 5.53928H6.2232L16.2073 18.3754Z" })), Ra = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M8 7l4-4 4 4h-3v8h-2V7H8zM3 19c0 1.1.9 2 2 2h14a2 2 0 002-2v-5h-2v5H5v-5H3v5z", clipRule: "evenodd" })), ka = (e) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M20.85 8.7s-.15-1.27-.75-1.8c-.68-.75-1.43-.75-1.8-.75C15.75 6 12 6 12 6s-3.75 0-6.3.15c-.38.07-1.13.07-1.8.75-.52.52-.75 1.8-.75 1.8S3 10.13 3 11.63v1.34a34 34 0 00.15 2.93s.15 1.28.75 1.8c.68.75 1.57.68 1.95.75 1.43.15 6.15.15 6.15.15s3.75 0 6.3-.23c.38-.07 1.13-.07 1.8-.75.52-.52.75-1.8.75-1.8S21 14.4 21 12.9v-1.35c0-1.43-.15-2.85-.15-2.85zm-10.73 5.93V9.6L15 12.15l-4.88 2.47z" })), Ci = {
  additional: hs,
  "alert-error": fs,
  "alert-success": ms,
  "arrow-down": gs,
  "arrow-left": _s,
  "arrow-light-down": vs,
  "arrow-light-left": ws,
  "arrow-light-right": bs,
  "arrow-light-up": ys,
  "arrow-right": xs,
  "arrow-up": Es,
  book: Ss,
  calendar: Ts,
  checkmark: Ns,
  "chevron-down": Cs,
  "chevron-left": As,
  "chevron-right": Ms,
  "chevron-up": Is,
  circle: Rs,
  close: ks,
  "color-indicator": Ls,
  connected: Ps,
  "copy-link": Os,
  cross: Ds,
  "default-avatar": Vs,
  diagnostics: $s,
  download: zs,
  dropdown: Hs,
  dummy: Bs,
  email: Fs,
  "external-link": Gs,
  facebook: Us,
  fax: qs,
  "file-download": Ys,
  file: Ws,
  filter: js,
  "globe-mobile": Zs,
  globe: Xs,
  "google-cal": Ks,
  info: Qs,
  instagram: Js,
  linkedin: ea,
  list: ta,
  loading: na,
  location: ia,
  logo: ra,
  map: sa,
  medicine: aa,
  minus: oa,
  "mobile-close": ca,
  "mobile-menu": da,
  "mobile-search": ua,
  mobile: la,
  "molecular-item": pa,
  outlook: ha,
  partnership: fa,
  pause: ga,
  patient: ma,
  people: _a,
  phone: va,
  play: wa,
  plus: ba,
  podcasts: ya,
  remove: xa,
  "search-mobile": Sa,
  search: Ea,
  series: Ta,
  "stock-down": Na,
  "stock-equal": Ca,
  "stock-up": Aa,
  time: Ma,
  twitter: Ia,
  upload: Ra,
  youtube: ka
}, La = [
  "arrow-left",
  "arrow-light-left",
  "arrow-light-right",
  "arrow-right",
  "chevron-left",
  "chevron-right",
  "diagnostics",
  "external-link",
  "file-download",
  "file",
  "list",
  "stock-down",
  "stock-equal",
  "stock-up",
  "loading"
], Pa = "icon", Ft = {
  "icon-container": "icon-container",
  icon: Pa,
  "icon--rtl": "icon--rtl",
  "icon-container--inline": "icon-container--inline"
}, F = ({
  icon: e,
  height: t,
  width: n,
  color: i,
  decorative: r = !0,
  display: s,
  onClick: a
}) => {
  const o = fi();
  if (!Object.keys(Ci).includes(e))
    return null;
  const c = o ? La.includes(e) : !1, l = Ci[e], u = {
    "--custom-icon-color": i
  };
  return /* @__PURE__ */ d("span", { className: L(Ft["icon-container"], s === "inline" && Ft["icon-container--inline"]), children: /* @__PURE__ */ d(
    l,
    {
      className: L(Ft.icon, c && Ft["icon--rtl"]),
      width: n,
      height: t,
      "aria-hidden": r,
      style: i ? u : void 0,
      onClick: a
    }
  ) });
}, Oa = "accordion", Da = "accordion__header", Va = "accordion__icon", $a = "accordion__panel", za = "accordion__item", Qe = {
  accordion: Oa,
  accordion__header: Da,
  "accordion__header-text": "accordion__header-text",
  accordion__icon: Va,
  accordion__panel: $a,
  accordion__item: za,
  "accordion__item--active": "accordion__item--active",
  "accordion__item--closing": "accordion__item--closing"
}, Ih = ({
  initiallyOpen: e,
  sections: t,
  headlineLevel: n = "h4",
  children: i,
  slot: r,
  onPanelToggle: s
}) => {
  const [a, o] = B(null), [c, l] = B(null), u = G([]), p = G([]), [h, g] = fr(), { scrollToItem: _ } = mr(p);
  U(() => {
    const v = h.substring(1), w = (t == null ? void 0 : t.findIndex((A) => A.id === v)) ?? null, T = e && e >= 0 && e < ((t == null ? void 0 : t.length) ?? 0) ? e : null, N = w !== null && w >= 0 ? w : T ?? null;
    o(N), w !== null && p.current[w] && _(w);
  }, []);
  const b = (v) => {
    var A, R;
    const w = a === v, T = w ? null : v;
    o(w ? null : v), l(w ? v : null), g(T !== null && ((A = t == null ? void 0 : t[T]) == null ? void 0 : A.id) || "");
    const N = (R = u.current) == null ? void 0 : R[v];
    N && (N.style.maxHeight = w ? "0px" : `${N.scrollHeight}px`, N.style.opacity = w ? "0" : "1");
  }, E = (v, w) => {
    var N;
    b(w);
    const T = ((N = t == null ? void 0 : t[w]) == null ? void 0 : N.headline) || "";
    s == null || s(v, T);
  }, y = (v, w) => {
    var N;
    if (v.propertyName !== "max-height")
      return;
    const T = (N = u.current) == null ? void 0 : N[w];
    c === w && T && T.style.maxHeight === "0px" && l(null);
  }, m = (v, w) => {
    var R;
    if (!t || t.length === 0)
      return;
    const { key: T } = v, N = t.length, A = {
      ArrowDown: (S, k) => (S + 1) % k,
      ArrowUp: (S, k) => (S - 1 + k) % k,
      Home: () => 0,
      End: (S, k) => k - 1
    };
    if (A[T]) {
      v.preventDefault();
      const S = A[T](w, N);
      (R = p.current[S]) == null || R.focus();
    } else (T === "Enter" || T === " ") && (v.preventDefault(), E(v, w));
  }, f = `${n}`;
  return /* @__PURE__ */ d("div", { className: Qe.accordion, slot: r, children: t == null ? void 0 : t.map((v, w) => {
    var T;
    return /* @__PURE__ */ I(
      "div",
      {
        className: L(
          Qe.accordion__item,
          a === w && Qe["accordion__item--active"],
          c === w && Qe["accordion__item--closing"]
        ),
        onTransitionEnd: (N) => y(N, w),
        children: [
          /* @__PURE__ */ d(f, { children: /* @__PURE__ */ I(
            "button",
            {
              className: Qe.accordion__header,
              id: `accordion-header-${v.id}`,
              type: "button",
              "aria-expanded": a === w,
              "aria-controls": `accordion-panel-${v.id}`,
              tabIndex: 0,
              onClick: (N) => E(N, w),
              onKeyDown: (N) => m(N, w),
              ref: (N) => {
                p.current[w] = N;
              },
              children: [
                /* @__PURE__ */ d("span", { className: Qe["accordion__header-text"], children: v.headline }),
                /* @__PURE__ */ d("span", { className: Qe.accordion__icon, children: /* @__PURE__ */ d(F, { icon: a === w ? "minus" : "plus", height: "24px", decorative: !0 }) })
              ]
            }
          ) }),
          /* @__PURE__ */ d(
            "div",
            {
              className: Qe.accordion__panel,
              id: `accordion-panel-${v.id}`,
              role: "region",
              "aria-labelledby": `accordion-header-${v.id}`,
              "aria-hidden": a !== w,
              style: {
                maxHeight: a === w ? `${(T = u.current[w]) == null ? void 0 : T.scrollHeight}px` : "0px",
                opacity: a === w ? 1 : 0
              },
              ref: (N) => {
                u.current[w] = N;
              },
              children: i == null ? void 0 : i[w]
            }
          )
        ]
      },
      v.id
    );
  }) });
}, Ha = 16, Ie = (e) => e / Ha;
var ne = /* @__PURE__ */ ((e) => (e[e.SMALL = 320] = "SMALL", e[e.MEDIUM = 768] = "MEDIUM", e[e.LARGE = 1024] = "LARGE", e[e.X_LARGE = 1440] = "X_LARGE", e[e.XX_LARGE = 1672] = "XX_LARGE", e))(ne || {});
const Ba = "button", Fa = "button__content", Ga = "button__text", te = {
  button: Ba,
  "button--loading": "button--loading",
  "button__icon-container": "button__icon-container",
  "button__icon-container--loading": "button__icon-container--loading",
  button__content: Fa,
  "button__content--loading": "button__content--loading",
  "button__loading-spinner": "button__loading-spinner",
  button__text: Ga,
  "button--left-aligned": "button--left-aligned",
  "button--primary": "button--primary",
  "button--disabled": "button--disabled",
  "button--secondary": "button--secondary",
  "button--tertiary": "button--tertiary",
  "button--success": "button--success",
  "button--error": "button--error",
  "button--bottom-fixed": "button--bottom-fixed",
  "button-wrapper": "button-wrapper",
  "button-wrapper--no-margin": "button-wrapper--no-margin"
};
var yn = /* @__PURE__ */ ((e) => (e.SELF = "_self", e.BLANK = "_blank", e))(yn || {}), $t = /* @__PURE__ */ ((e) => (e.BUTTON = "button", e.SUBMIT = "submit", e.RESET = "reset", e))($t || {}), ln = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.CENTER = "center", e))(ln || {}), Me = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.TERTIARY = "tertiary", e.SUCCESS = "success", e.ERROR = "error", e.BOTTOM_FIXED = "bottom-fixed", e))(Me || {});
const Ua = 24, qa = "loading", St = ({
  appearance: e = Me.PRIMARY,
  alignment: t = ln.CENTER,
  disabled: n,
  download: i,
  text: r,
  type: s = $t.BUTTON,
  target: a = yn.SELF,
  leftIcon: o,
  rightIcon: c,
  href: l,
  hasMarginTop: u = !0,
  isModalTrigger: p,
  isLoading: h,
  slot: g,
  onModalTrigger: _,
  onClick: b,
  ...E
}) => {
  const y = (w, T) => {
    const N = L(te["button__icon-container"], T && te["button__icon-container--loading"]);
    return (
      // There's always text in the button, the icons are decorative: aria-hidden={true}
      /* @__PURE__ */ d("div", { className: N, "aria-hidden": !0, children: /* @__PURE__ */ d(F, { icon: w, height: `${Ie(Ua)}rem` }) })
    );
  }, m = L(
    te.button,
    n && te["button--disabled"],
    h && te["button--loading"],
    t === ln.LEFT && te["button--left-aligned"],
    e === Me.PRIMARY && te["button--primary"],
    e === Me.SECONDARY && te["button--secondary"],
    e === Me.TERTIARY && te["button--tertiary"],
    e === Me.SUCCESS && te["button--success"],
    e === Me.ERROR && te["button--error"],
    e === Me.BOTTOM_FIXED && te["button--bottom-fixed"]
  ), f = (w) => {
    p && _ && (w.preventDefault(), _()), b && b(w);
  }, v = /* @__PURE__ */ I(ze, { children: [
    /* @__PURE__ */ I("span", { className: L(te.button__content, h && te["button__content--loading"]), children: [
      o && y(o),
      /* @__PURE__ */ d("div", { className: te.button__text, "data-content": r, children: r }),
      c && y(c)
    ] }),
    h && /* @__PURE__ */ d("span", { className: te["button__loading-spinner"], children: y(qa, h) })
  ] });
  return /* @__PURE__ */ d("div", { className: L(te["button-wrapper"], !u && te["button-wrapper--no-margin"]), slot: g, children: l ? /* @__PURE__ */ d(
    "a",
    {
      className: m,
      onClick: f,
      href: n ? void 0 : l,
      target: a,
      download: i,
      ...E,
      children: v
    }
  ) : /* @__PURE__ */ d(
    "button",
    {
      className: m,
      onClick: f,
      type: s,
      disabled: n,
      ...E,
      children: v
    }
  ) });
}, Ai = {
  "roche-add-to-calendar": "roche-add-to-calendar",
  "roche-add-to-calendar__headline": "roche-add-to-calendar__headline"
}, Gt = (e) => e ? new Date(e).toISOString() : "", Mi = (e) => e.replace(/-|:|\.\d{3}/g, ""), Rh = ({
  heading: e,
  eventTitle: t,
  description: n,
  startDate: i,
  endDate: r,
  icsLabel: s,
  googleCalendarLabel: a,
  outlookOnlineLabel: o,
  onCalendarLinkClick: c
}) => {
  const l = Gt(i), u = Gt(r), p = Mi(Gt(i)), h = Mi(Gt(r)), g = [
    {
      title: t,
      text: s,
      href: `data:text/calendar,${encodeURIComponent(
        `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${t}
DESCRIPTION:${n}
DTSTART:${p}
DTEND:${h}
END:VEVENT
END:VCALENDAR`
      )}`,
      icon: "file"
    },
    {
      text: a,
      href: `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=${p}%2F${h}&text=${encodeURIComponent(
        t
      )}&details=${encodeURIComponent(n)}`,
      icon: "google-cal"
    },
    {
      text: o,
      href: `https://outlook.live.com/calendar/0/deeplink/compose?rru=addevent&path=%2Fcalendar%2Faction%2Fcompose&startdt=${l}&enddt=${u}&subject=${t}&body=${n}`,
      icon: "outlook"
    }
  ];
  return /* @__PURE__ */ I("div", { className: Ai["roche-add-to-calendar"], children: [
    /* @__PURE__ */ d("h3", { className: Ai["roche-add-to-calendar__headline"], children: e }),
    g.map((_, b) => /* @__PURE__ */ d(
      St,
      {
        hasMarginTop: !1,
        appearance: Me.SECONDARY,
        alignment: ln.LEFT,
        download: _.title,
        text: _.text,
        href: _.href,
        leftIcon: _.icon,
        target: yn.BLANK,
        onClick: (E) => c(E, _.text, _.href)
      },
      b
    ))
  ] });
}, Wa = (e) => {
  const [t, n] = B(!1);
  return U(() => {
    const i = new IntersectionObserver(([r]) => n(r.isIntersecting));
    return e.current && i.observe(e.current), () => {
      i.disconnect();
    };
  }, [e]), t;
}, gr = (e) => {
  const [, t] = B(!1), n = G(!1);
  return U(() => {
    const i = new IntersectionObserver(([r]) => {
      r.isIntersecting && !n.current && (n.current = !0, t(!0));
    });
    return e.current && i.observe(e.current), () => {
      i.disconnect();
    };
  }, [e]), n.current;
}, be = {
  "animated-words": "animated-words",
  "animated-words__headline": "animated-words__headline",
  "animated-words__text-container": "animated-words__text-container",
  "animated-words__words-container": "animated-words__words-container",
  "animated-words__word": "animated-words__word",
  "animated-words__word--active": "animated-words__word--active",
  "animated-words__word--previous": "animated-words__word--previous",
  "animated-words__word--next": "animated-words__word--next",
  "animated-words__word--red": "animated-words__word--red",
  "animated-words__word--orange": "animated-words__word--orange",
  "animated-words__word--purple": "animated-words__word--purple",
  "animated-words__word--brand": "animated-words__word--brand",
  "animated-words__word--effect": "animated-words__word--effect",
  "animated-words--animated": "animated-words--animated"
}, Ya = 1400, ja = ["red", "orange", "purple", "brand"], kh = ({ headline: e, words: t }) => {
  const n = G(null), [i, r] = B(0), s = Wa(n), a = t ? t.trim().split(`
`) : [], o = a.length <= 3 && a.length > 1 ? [...a, ...a] : a, c = a.length > 1, l = (u) => {
    const p = u % a.length === a.length - 1 ? "animated-words__word--effect" : `animated-words__word--${ja[u % a.length % a.length]}`;
    if (!c)
      return L(be["animated-words__word"], be[p], {
        [be["animated-words__word--active"]]: !0
      });
    const h = o.length, g = u === i, _ = u === (i - 1 + h) % h, b = u === (i + 1 + h) % h;
    return L(be["animated-words__word"], be[p], {
      [be["animated-words__word--active"]]: g,
      [be["animated-words__word--previous"]]: _,
      [be["animated-words__word--next"]]: b
    });
  };
  return U(() => {
    if (c && s) {
      const u = setInterval(() => {
        r((p) => (p + 1) % o.length);
      }, Ya);
      return () => clearInterval(u);
    }
  }, [a, s]), /* @__PURE__ */ I(
    "h2",
    {
      ref: n,
      className: L(be["animated-words"], {
        [be["animated-words--animated"]]: c
      }),
      "aria-label": `${e} ${t.replaceAll(`
`, ", ")}`,
      children: [
        /* @__PURE__ */ d("span", { className: be["animated-words__headline"], children: e }),
        /* @__PURE__ */ d("div", { className: be["animated-words__text-container"], children: o.map((u, p) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
          /* @__PURE__ */ d("span", { className: l(p), children: u }, p)
        )) })
      ]
    }
  );
}, Xa = "avatar", Za = "avatar__fallback", Ka = "avatar__icon", kn = {
  avatar: Xa,
  avatar__fallback: Za,
  avatar__icon: Ka
}, Lh = ({ children: e }) => /* @__PURE__ */ d("div", { className: kn.avatar, children: e ?? /* @__PURE__ */ d("div", { className: kn.avatar__fallback, children: /* @__PURE__ */ d("div", { className: kn.avatar__icon, children: /* @__PURE__ */ d(F, { icon: "default-avatar", height: "100%", decorative: !0 }) }) }) });
var xn = /* @__PURE__ */ ((e) => (e.SELF = "_self", e.BLANK = "_blank", e))(xn || {});
const Qa = "headline", Ja = "headline__overline", Ut = {
  headline: Qa,
  headline__overline: Ja,
  "headline--1": "headline--1",
  "headline--2": "headline--2",
  "headline--3": "headline--3",
  "headline--4": "headline--4",
  "headline--5": "headline--5",
  "headline--6": "headline--6",
  "headline--pipeline": "headline--pipeline"
};
var Xn = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PIPELINE = "pipeline", e))(Xn || {});
const _r = ({
  overline: e,
  headline: t,
  level: n,
  semanticLevel: i,
  appearance: r = Xn.DEFAULT,
  children: s,
  slot: a,
  ...o
}) => {
  const c = `h${i ?? n}`;
  return /* @__PURE__ */ I(
    c,
    {
      slot: a,
      className: L(
        Ut.headline,
        Ut[`headline--${n}`],
        r !== Xn.DEFAULT && Ut[`headline--${r}`]
      ),
      ...o,
      children: [
        e && /* @__PURE__ */ d("span", { className: Ut.headline__overline, children: e }),
        t || s
      ]
    }
  );
}, eo = "overline", to = "overline__text", Ii = {
  overline: eo,
  overline__text: to
}, no = ({ overlineText: e, slot: t }) => /* @__PURE__ */ d("div", { className: Ii.overline, slot: t, children: /* @__PURE__ */ d("p", { className: Ii.overline__text, children: e }) }), ht = {
  "text-link": "text-link",
  "text-link__link": "text-link__link",
  "text-link__icon-container": "text-link__icon-container",
  "text-link__text": "text-link__text",
  "text-link--footnote": "text-link--footnote",
  "text-link--contact-person": "text-link--contact-person",
  "text-link--footer-social": "text-link--footer-social",
  "text-link--footer-column": "text-link--footer-column",
  "text-link--footer-quick": "text-link--footer-quick",
  "text-link--footer-service": "text-link--footer-service",
  "text-link--breadcrumbs": "text-link--breadcrumbs",
  "text-link--news-page": "text-link--news-page",
  "icon-container": "icon-container"
};
var yt = /* @__PURE__ */ ((e) => (e.CONTACT_PERSON = "contact-person", e.FOOTER = "footer", e.FOOTER_QUICK = "footer-quick", e.FOOTER_COLUMN = "footer-column", e.FOOTER_SOCIAL = "footer-social", e.FOOTER_SERVICE = "footer-service", e.BREADCRUMBS = "breadcrumbs", e.NEWS_PAGE = "news-page", e))(yt || {}), io = /* @__PURE__ */ ((e) => (e.FOOTNOTE = "footnote", e))(io || {});
const Lt = ({
  href: e,
  text: t,
  slot: n,
  target: i,
  leftIcon: r,
  rightIcon: s,
  label: a,
  type: o,
  size: c,
  onButtonClick: l,
  buttonType: u = $t.BUTTON,
  onTextLinkClick: p
}) => {
  const h = e ? "a" : "button", g = e ? { href: e, target: i } : {}, _ = (b) => {
    const E = o === yt.NEWS_PAGE;
    return /* @__PURE__ */ d("span", { className: ht["text-link__icon-container"], children: /* @__PURE__ */ d(F, { icon: b, height: E ? "14px" : "24px" }) });
  };
  return /* @__PURE__ */ d(
    "span",
    {
      className: L(ht["text-link"], o && ht[`text-link--${o}`], c && ht[` text-link--${c}`]),
      slot: n,
      children: /* @__PURE__ */ I(
        h,
        {
          className: ht["text-link__link"],
          ...g,
          "aria-label": a,
          onClick: h === "a" ? p : l,
          type: h === "button" ? u : void 0,
          children: [
            r && _(r),
            /* @__PURE__ */ d("span", { className: ht["text-link__text"], children: t }),
            s && _(s)
          ]
        }
      )
    }
  );
}, Ri = {
  "roche-back-to-branch": "roche-back-to-branch",
  "roche-back-to-branch__content": "roche-back-to-branch__content"
}, Ph = ({
  overlineText: e,
  headline: t,
  linkText: n,
  link: i,
  icon: r,
  slot: s
}) => /* @__PURE__ */ I("section", { className: Ri["roche-back-to-branch"], slot: s, children: [
  /* @__PURE__ */ I("div", { className: Ri["roche-back-to-branch__content"], children: [
    e && /* @__PURE__ */ d(no, { overlineText: e }),
    /* @__PURE__ */ d(_r, { headline: t, level: "5" })
  ] }),
  /* @__PURE__ */ d(Lt, { rightIcon: r, href: i, text: n, target: xn.SELF })
] }), ro = "breadcrumbs", so = "breadcrumbs__item", ao = "breadcrumbs__text", oo = "breadcrumbs__icon", At = {
  breadcrumbs: ro,
  "breadcrumbs__item-list": "breadcrumbs__item-list",
  breadcrumbs__item: so,
  breadcrumbs__text: ao,
  breadcrumbs__icon: oo
}, lo = ({ items: e, ariaLabel: t, slot: n, onBreadcrumbClick: i }) => {
  const r = (s, a) => /* @__PURE__ */ I(ds.Fragment, { children: [
    a > 0 && /* @__PURE__ */ d("span", { className: At.breadcrumbs__icon, children: /* @__PURE__ */ d(F, { icon: "chevron-right", height: "14px" }) }),
    /* @__PURE__ */ d("li", { className: At.breadcrumbs__item, children: s.href ? /* @__PURE__ */ d(
      Lt,
      {
        href: s.href,
        text: s.text,
        target: xn.SELF,
        type: yt.BREADCRUMBS,
        onTextLinkClick: () => i(yt.BREADCRUMBS, s.text, s.href)
      }
    ) : /* @__PURE__ */ d("p", { className: At.breadcrumbs__text, children: s.text }) })
  ] }, `breadcrumb-${a}`);
  return /* @__PURE__ */ d("nav", { className: At.breadcrumbs, "aria-label": t, slot: n, children: /* @__PURE__ */ d("ol", { className: At["breadcrumbs__item-list"], children: e == null ? void 0 : e.map((s, a) => r(s, a)) }) });
}, ft = {
  "contact-person": "contact-person",
  "contact-person__avatar": "contact-person__avatar",
  "contact-person__name": "contact-person__name",
  "contact-person__job-title": "contact-person__job-title",
  "contact-person__phone-number": "contact-person__phone-number",
  "contact-person__email-address": "contact-person__email-address"
};
var Qt = /* @__PURE__ */ ((e) => (e.VARIANT_A = "contact-person--variant-a", e.VARIANT_A_WITHOUT_IMAGE = "contact-person--variant-a-without-image", e.VARIANT_B = "contact-person--variant-b", e))(Qt || {});
const Oh = ({
  layout: e = Qt.VARIANT_A,
  name: t,
  jobTitle: n,
  phoneNumber: i,
  emailAddress: r,
  children: s,
  slot: a
}) => {
  const o = e !== Qt.VARIANT_B, c = e !== Qt.VARIANT_A_WITHOUT_IMAGE && s;
  return /* @__PURE__ */ I("div", { className: ft["contact-person"], slot: a, children: [
    c && /* @__PURE__ */ d("div", { className: ft["contact-person__avatar"], children: s }),
    /* @__PURE__ */ d("h3", { className: ft["contact-person__name"], children: t }),
    /* @__PURE__ */ d("p", { className: ft["contact-person__job-title"], children: n }),
    o && i && /* @__PURE__ */ d("div", { className: ft["contact-person__phone-number"], children: /* @__PURE__ */ d(
      Lt,
      {
        href: `tel:${i}`,
        text: i,
        leftIcon: "phone",
        type: yt.CONTACT_PERSON
      },
      "phone-number"
    ) }),
    o && r && /* @__PURE__ */ d("div", { className: ft["contact-person__email-address"], children: /* @__PURE__ */ d(
      Lt,
      {
        href: `mailto:${r}`,
        text: r,
        leftIcon: "email",
        type: yt.CONTACT_PERSON
      },
      "email-address"
    ) })
  ] });
}, co = "container", ot = {
  container: co,
  "container--full-width": "container--full-width",
  "container--colored": "container--colored",
  "container--theme-aware": "container--theme-aware",
  "container--aware-gradient-top-left": "container--aware-gradient-top-left",
  "container--aware-gradient-bottom-right": "container--aware-gradient-bottom-right",
  "container--neutral-gradient-top-left": "container--neutral-gradient-top-left",
  "container--blue-gradient-top-left": "container--blue-gradient-top-left",
  "container--blue-gradient-bottom-right": "container--blue-gradient-bottom-right",
  "container--neutral-gradient-bottom-right": "container--neutral-gradient-bottom-right",
  "container--neutral-gradient-neutral-100-neutral-400": "container--neutral-gradient-neutral-100-neutral-400",
  "container--neutral-100": "container--neutral-100",
  "container--neutral-200": "container--neutral-200",
  "container--grey-50": "container--grey-50",
  "container--grey-100": "container--grey-100",
  "container--grey-300": "container--grey-300",
  "container--white": "container--white",
  "container--split-gradient-radial": "container--split-gradient-radial",
  "container__gradient-helper": "container__gradient-helper",
  "container--split-gradient-linear": "container--split-gradient-linear",
  "container--brand-gradient": "container--brand-gradient",
  "brand-gradient-animation": "brand-gradient-animation",
  "container--extended-background": "container--extended-background",
  "container--full-height": "container--full-height"
};
var Zn = /* @__PURE__ */ ((e) => (e.TRANSPARENT = "transparent", e.THEME_AWARE = "theme-aware", e.NEUTRAL_GRADIENT_TOP_LEFT = "neutral-gradient-top-left", e.NEUTRAL_GRADIENT_BOTTOM_RIGHT = "neutral-gradient-bottom-right", e.NEUTRAL_GRADIENT_NEUTRAL_100_NEUTRAL_400 = "neutral-gradient-neutral-100-neutral-400", e.NEUTRAL_100 = "neutral-100", e.NEUTRAL_200 = "neutral-200", e.GREY_50 = "grey-50", e.GREY_100 = "grey-100", e.GREY_300 = "grey-300", e.WHITE = "white", e.AWARE_SOFT_TOP_LEFT = "aware-gradient-top-left", e.AWARE_SOFT_BOTTOM_RIGHT = "aware-gradient-bottom-right", e.BLUE_GRADIENT_TOP_LEFT = "blue-gradient-top-left", e.BLUE_GRADIENT_BOTTOM_RIGHT = "blue-gradient-bottom-right", e.SPLIT_GRADIENT = "split-gradient-radial", e.GRADIENT_WHITE_TO_GRAY_4 = "split-gradient-linear", e.BRAND_GRADIENT = "brand-gradient", e))(Zn || {});
const uo = ({
  color: e = Zn.TRANSPARENT,
  fullWidth: t,
  fullHeight: n,
  extendBackgroundToTop: i,
  children: r
}) => {
  const s = L(
    ot.container,
    e !== Zn.TRANSPARENT && ot["container--colored"],
    ot[`container--${e}`],
    t && ot["container--full-width"],
    n && ot["container--full-height"],
    i && ot["container--extended-background"]
  );
  return /* @__PURE__ */ I("div", { className: s, children: [
    /* @__PURE__ */ d("div", { className: ot["container__gradient-helper"] }),
    r
  ] });
}, Tt = (e, t) => {
  U(() => {
    if (!t) return;
    const n = (i) => {
      i.key === "Escape" && (i.stopPropagation(), e());
    };
    return window.addEventListener("keydown", n), () => {
      window.removeEventListener("keydown", n);
    };
  }, [t, e]);
};
let Kn = 0;
const ki = () => {
  const { documentElement: e } = document;
  Kn > 0 ? e.style.overflow = "hidden" : e.style.overflow = "";
}, En = (e) => {
  U(() => (e && (Kn++, ki()), () => {
    e && (Kn--, ki());
  }), [e]);
}, po = "dialog", ho = "dialog__panel", fo = "dialog__content", mo = "dialog__footer", go = "dialog__head", ve = {
  dialog: po,
  dialog__panel: ho,
  dialog__content: fo,
  dialog__footer: mo,
  "dialog__head--no-padding-top": "dialog__head--no-padding-top",
  "dialog__head--no-padding-bottom": "dialog__head--no-padding-bottom",
  "dialog--center": "dialog--center",
  dialog__head: go,
  "dialog__content--no-padding-top": "dialog__content--no-padding-top",
  "dialog__content--no-padding-bottom": "dialog__content--no-padding-bottom",
  "dialog__footer--no-padding-top": "dialog__footer--no-padding-top",
  "dialog__footer--no-padding-bottom": "dialog__footer--no-padding-bottom",
  "dialog--top": "dialog--top"
};
var Qn = /* @__PURE__ */ ((e) => (e.CENTER = "center", e.TOP = "top", e))(Qn || {});
const _o = ({ children: e, className: t, slot: n }) => /* @__PURE__ */ d("div", { className: L(ve.dialog__panel, t), slot: n, children: e }), vo = ({ children: e, className: t, slot: n, noPaddingTop: i, noPaddingBottom: r }) => /* @__PURE__ */ d(
  "div",
  {
    className: L(
      ve.dialog__head,
      i && ve["dialog__head--no-padding-top"],
      r && ve["dialog__head--no-padding-bottom"],
      t
    ),
    slot: n,
    children: e
  }
), wo = ({ children: e, className: t, slot: n, noPaddingTop: i, noPaddingBottom: r }) => /* @__PURE__ */ d(
  "div",
  {
    className: L(
      ve.dialog__content,
      i && ve["dialog__content--no-padding-top"],
      r && ve["dialog__content--no-padding-bottom"],
      t
    ),
    slot: n,
    children: e
  }
), bo = ({ children: e, className: t, slot: n, noPaddingTop: i, noPaddingBottom: r }) => /* @__PURE__ */ d(
  "div",
  {
    className: L(
      ve.dialog__footer,
      i && ve["dialog__footer--no-padding-top"],
      r && ve["dialog__footer--no-padding-bottom"],
      t
    ),
    slot: n,
    children: e
  }
), yo = bn(
  ({ variant: e, isOpen: t = !1, onCancel: n, enableEscapeKey: i = !1, children: r, ...s }, a) => {
    Tt(n || (() => {
    }), i), En(t);
    const o = L(
      ve.dialog,
      e === Qn.CENTER && ve["dialog--center"],
      e === Qn.TOP && ve["dialog--top"]
    );
    return /* @__PURE__ */ d("dialog", { ref: a, className: o, ...s, children: r });
  }
), Dh = Object.assign(yo, { Panel: _o, Head: vo, Content: wo, Footer: bo }), xo = "drawer", Eo = "drawer__container", So = "drawer__header", To = "drawer__content", Fe = {
  drawer: xo,
  "drawer--bottom": "drawer--bottom",
  "drawer--top": "drawer--top",
  "drawer--left": "drawer--left",
  "drawer--right": "drawer--right",
  "drawer--full-size": "drawer--full-size",
  "drawer--open": "drawer--open",
  "drawer--closing": "drawer--closing",
  drawer__container: Eo,
  drawer__header: So,
  "drawer__close-button": "drawer__close-button",
  drawer__content: To
};
var vr = /* @__PURE__ */ ((e) => (e.BOTTOM = "bottom", e.LEFT = "left", e.RIGHT = "right", e.TOP = "top", e))(vr || {});
const Vh = bn(
  ({
    open: e,
    closing: t = !1,
    direction: n = vr.BOTTOM,
    fullSize: i = !1,
    dialogLabel: r,
    closeButtonLabel: s = "Close",
    onClose: a,
    children: o,
    ...c
  }, l) => {
    Tt(a, e), En(e);
    const u = L(
      Fe.drawer,
      Fe[`drawer--${n}`],
      i && Fe["drawer--full-size"],
      e && Fe["drawer--open"],
      t && Fe["drawer--closing"]
    );
    return /* @__PURE__ */ d(
      "dialog",
      {
        ref: l,
        className: u,
        "aria-modal": "true",
        "aria-label": r,
        onCancel: (p) => p.preventDefault(),
        ...c,
        children: /* @__PURE__ */ I("div", { className: Fe.drawer__container, children: [
          /* @__PURE__ */ d("div", { className: Fe.drawer__header, children: /* @__PURE__ */ d(
            "button",
            {
              type: "button",
              className: Fe["drawer__close-button"],
              onClick: a,
              "aria-label": s,
              children: /* @__PURE__ */ d(F, { icon: "mobile-close", height: "32px", decorative: !0 })
            }
          ) }),
          /* @__PURE__ */ d("div", { className: Fe.drawer__content, children: o })
        ] })
      }
    );
  }
), wr = () => typeof navigator > "u" ? !1 : /^((?!chrome|android).)*safari/i.test(navigator.userAgent), No = () => typeof navigator > "u" ? !1 : /^((?!edg|opr|brave|vivaldi).)*chrome/i.test(navigator.userAgent);
function mi(e, t) {
  return !e || !t ? t : t.replace(/\s*\*$/, "").trimEnd() + " *";
}
function Sn() {
  return typeof window < "u";
}
function Nt(e) {
  return br(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function we(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Be(e) {
  var t;
  return (t = (br(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function br(e) {
  return Sn() ? e instanceof Node || e instanceof we(e).Node : !1;
}
function de(e) {
  return Sn() ? e instanceof Element || e instanceof we(e).Element : !1;
}
function He(e) {
  return Sn() ? e instanceof HTMLElement || e instanceof we(e).HTMLElement : !1;
}
function Li(e) {
  return !Sn() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof we(e).ShadowRoot;
}
const Co = /* @__PURE__ */ new Set(["inline", "contents"]);
function zt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: i,
    display: r
  } = Ce(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + i + n) && !Co.has(r);
}
const Ao = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Mo(e) {
  return Ao.has(Nt(e));
}
const Io = [":popover-open", ":modal"];
function Tn(e) {
  return Io.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Ro = ["transform", "translate", "scale", "rotate", "perspective"], ko = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Lo = ["paint", "layout", "strict", "content"];
function gi(e) {
  const t = _i(), n = de(e) ? Ce(e) : e;
  return Ro.some((i) => n[i] ? n[i] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ko.some((i) => (n.willChange || "").includes(i)) || Lo.some((i) => (n.contain || "").includes(i));
}
function Po(e) {
  let t = rt(e);
  for (; He(t) && !xt(t); ) {
    if (gi(t))
      return t;
    if (Tn(t))
      return null;
    t = rt(t);
  }
  return null;
}
function _i() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Oo = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function xt(e) {
  return Oo.has(Nt(e));
}
function Ce(e) {
  return we(e).getComputedStyle(e);
}
function Nn(e) {
  return de(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function rt(e) {
  if (Nt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Li(e) && e.host || // Fallback.
    Be(e)
  );
  return Li(t) ? t.host : t;
}
function yr(e) {
  const t = rt(e);
  return xt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : He(t) && zt(t) ? t : yr(t);
}
function Pt(e, t, n) {
  var i;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = yr(e), s = r === ((i = e.ownerDocument) == null ? void 0 : i.body), a = we(r);
  if (s) {
    const o = Jn(a);
    return t.concat(a, a.visualViewport || [], zt(r) ? r : [], o && n ? Pt(o) : []);
  }
  return t.concat(r, Pt(r, [], n));
}
function Jn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const Et = Math.min, dt = Math.max, cn = Math.round, qt = Math.floor, $e = (e) => ({
  x: e,
  y: e
}), Do = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Vo = {
  start: "end",
  end: "start"
};
function ei(e, t, n) {
  return dt(e, Et(t, n));
}
function ut(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function st(e) {
  return e.split("-")[0];
}
function Ht(e) {
  return e.split("-")[1];
}
function vi(e) {
  return e === "x" ? "y" : "x";
}
function wi(e) {
  return e === "y" ? "height" : "width";
}
const $o = /* @__PURE__ */ new Set(["top", "bottom"]);
function Xe(e) {
  return $o.has(st(e)) ? "y" : "x";
}
function bi(e) {
  return vi(Xe(e));
}
function zo(e, t, n) {
  n === void 0 && (n = !1);
  const i = Ht(e), r = bi(e), s = wi(r);
  let a = r === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (a = dn(a)), [a, dn(a)];
}
function Ho(e) {
  const t = dn(e);
  return [ti(e), t, ti(t)];
}
function ti(e) {
  return e.replace(/start|end/g, (t) => Vo[t]);
}
const Pi = ["left", "right"], Oi = ["right", "left"], Bo = ["top", "bottom"], Fo = ["bottom", "top"];
function Go(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Oi : Pi : t ? Pi : Oi;
    case "left":
    case "right":
      return t ? Bo : Fo;
    default:
      return [];
  }
}
function Uo(e, t, n, i) {
  const r = Ht(e);
  let s = Go(st(e), n === "start", i);
  return r && (s = s.map((a) => a + "-" + r), t && (s = s.concat(s.map(ti)))), s;
}
function dn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Do[t]);
}
function qo(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function xr(e) {
  return typeof e != "number" ? qo(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function un(e) {
  const {
    x: t,
    y: n,
    width: i,
    height: r
  } = e;
  return {
    width: i,
    height: r,
    top: n,
    left: t,
    right: t + i,
    bottom: n + r,
    x: t,
    y: n
  };
}
var Wo = typeof document < "u", Yo = function() {
}, pn = Wo ? pi : Yo;
const jo = {
  ...x
}, Xo = jo.useInsertionEffect, Zo = Xo || ((e) => e());
function Ko(e) {
  const t = x.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Zo(() => {
    t.current = e;
  }), x.useCallback(function() {
    for (var n = arguments.length, i = new Array(n), r = 0; r < n; r++)
      i[r] = arguments[r];
    return t.current == null ? void 0 : t.current(...i);
  }, []);
}
function Di(e, t, n) {
  let {
    reference: i,
    floating: r
  } = e;
  const s = Xe(t), a = bi(t), o = wi(a), c = st(t), l = s === "y", u = i.x + i.width / 2 - r.width / 2, p = i.y + i.height / 2 - r.height / 2, h = i[o] / 2 - r[o] / 2;
  let g;
  switch (c) {
    case "top":
      g = {
        x: u,
        y: i.y - r.height
      };
      break;
    case "bottom":
      g = {
        x: u,
        y: i.y + i.height
      };
      break;
    case "right":
      g = {
        x: i.x + i.width,
        y: p
      };
      break;
    case "left":
      g = {
        x: i.x - r.width,
        y: p
      };
      break;
    default:
      g = {
        x: i.x,
        y: i.y
      };
  }
  switch (Ht(t)) {
    case "start":
      g[a] -= h * (n && l ? -1 : 1);
      break;
    case "end":
      g[a] += h * (n && l ? -1 : 1);
      break;
  }
  return g;
}
const Qo = async (e, t, n) => {
  const {
    placement: i = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: a
  } = n, o = s.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let l = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: u,
    y: p
  } = Di(l, i, c), h = i, g = {}, _ = 0;
  for (let b = 0; b < o.length; b++) {
    const {
      name: E,
      fn: y
    } = o[b], {
      x: m,
      y: f,
      data: v,
      reset: w
    } = await y({
      x: u,
      y: p,
      initialPlacement: i,
      placement: h,
      strategy: r,
      middlewareData: g,
      rects: l,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = m ?? u, p = f ?? p, g = {
      ...g,
      [E]: {
        ...g[E],
        ...v
      }
    }, w && _ <= 50 && (_++, typeof w == "object" && (w.placement && (h = w.placement), w.rects && (l = w.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : w.rects), {
      x: u,
      y: p
    } = Di(l, h, c)), b = -1);
  }
  return {
    x: u,
    y: p,
    placement: h,
    strategy: r,
    middlewareData: g
  };
};
async function Er(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: i,
    y: r,
    platform: s,
    rects: a,
    elements: o,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: p = "floating",
    altBoundary: h = !1,
    padding: g = 0
  } = ut(t, e), _ = xr(g), E = o[h ? p === "floating" ? "reference" : "floating" : p], y = un(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(E))) == null || n ? E : E.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(o.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), m = p === "floating" ? {
    x: i,
    y: r,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, f = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(o.floating)), v = await (s.isElement == null ? void 0 : s.isElement(f)) ? await (s.getScale == null ? void 0 : s.getScale(f)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = un(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: m,
    offsetParent: f,
    strategy: c
  }) : m);
  return {
    top: (y.top - w.top + _.top) / v.y,
    bottom: (w.bottom - y.bottom + _.bottom) / v.y,
    left: (y.left - w.left + _.left) / v.x,
    right: (w.right - y.right + _.right) / v.x
  };
}
const Jo = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: i,
      placement: r,
      rects: s,
      platform: a,
      elements: o,
      middlewareData: c
    } = t, {
      element: l,
      padding: u = 0
    } = ut(e, t) || {};
    if (l == null)
      return {};
    const p = xr(u), h = {
      x: n,
      y: i
    }, g = bi(r), _ = wi(g), b = await a.getDimensions(l), E = g === "y", y = E ? "top" : "left", m = E ? "bottom" : "right", f = E ? "clientHeight" : "clientWidth", v = s.reference[_] + s.reference[g] - h[g] - s.floating[_], w = h[g] - s.reference[g], T = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l));
    let N = T ? T[f] : 0;
    (!N || !await (a.isElement == null ? void 0 : a.isElement(T))) && (N = o.floating[f] || s.floating[_]);
    const A = v / 2 - w / 2, R = N / 2 - b[_] / 2 - 1, S = Et(p[y], R), k = Et(p[m], R), P = S, D = N - b[_] - k, V = N / 2 - b[_] / 2 + A, z = ei(P, V, D), O = !c.arrow && Ht(r) != null && V !== z && s.reference[_] / 2 - (V < P ? S : k) - b[_] / 2 < 0, C = O ? V < P ? V - P : V - D : 0;
    return {
      [g]: h[g] + C,
      data: {
        [g]: z,
        centerOffset: V - z - C,
        ...O && {
          alignmentOffset: C
        }
      },
      reset: O
    };
  }
}), el = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, i;
      const {
        placement: r,
        middlewareData: s,
        rects: a,
        initialPlacement: o,
        platform: c,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: p = !0,
        fallbackPlacements: h,
        fallbackStrategy: g = "bestFit",
        fallbackAxisSideDirection: _ = "none",
        flipAlignment: b = !0,
        ...E
      } = ut(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const y = st(r), m = Xe(o), f = st(o) === o, v = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), w = h || (f || !b ? [dn(o)] : Ho(o)), T = _ !== "none";
      !h && T && w.push(...Uo(o, b, _, v));
      const N = [o, ...w], A = await Er(t, E), R = [];
      let S = ((i = s.flip) == null ? void 0 : i.overflows) || [];
      if (u && R.push(A[y]), p) {
        const V = zo(r, a, v);
        R.push(A[V[0]], A[V[1]]);
      }
      if (S = [...S, {
        placement: r,
        overflows: R
      }], !R.every((V) => V <= 0)) {
        var k, P;
        const V = (((k = s.flip) == null ? void 0 : k.index) || 0) + 1, z = N[V];
        if (z && (!(p === "alignment" ? m !== Xe(z) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        S.every((M) => Xe(M.placement) === m ? M.overflows[0] > 0 : !0)))
          return {
            data: {
              index: V,
              overflows: S
            },
            reset: {
              placement: z
            }
          };
        let O = (P = S.filter((C) => C.overflows[0] <= 0).sort((C, M) => C.overflows[1] - M.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!O)
          switch (g) {
            case "bestFit": {
              var D;
              const C = (D = S.filter((M) => {
                if (T) {
                  const $ = Xe(M.placement);
                  return $ === m || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  $ === "y";
                }
                return !0;
              }).map((M) => [M.placement, M.overflows.filter(($) => $ > 0).reduce(($, q) => $ + q, 0)]).sort((M, $) => M[1] - $[1])[0]) == null ? void 0 : D[0];
              C && (O = C);
              break;
            }
            case "initialPlacement":
              O = o;
              break;
          }
        if (r !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
}, Sr = /* @__PURE__ */ new Set(["left", "top"]);
async function tl(e, t) {
  const {
    placement: n,
    platform: i,
    elements: r
  } = e, s = await (i.isRTL == null ? void 0 : i.isRTL(r.floating)), a = st(n), o = Ht(n), c = Xe(n) === "y", l = Sr.has(a) ? -1 : 1, u = s && c ? -1 : 1, p = ut(t, e);
  let {
    mainAxis: h,
    crossAxis: g,
    alignmentAxis: _
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return o && typeof _ == "number" && (g = o === "end" ? _ * -1 : _), c ? {
    x: g * u,
    y: h * l
  } : {
    x: h * l,
    y: g * u
  };
}
const nl = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, i;
      const {
        x: r,
        y: s,
        placement: a,
        middlewareData: o
      } = t, c = await tl(t, e);
      return a === ((n = o.offset) == null ? void 0 : n.placement) && (i = o.arrow) != null && i.alignmentOffset ? {} : {
        x: r + c.x,
        y: s + c.y,
        data: {
          ...c,
          placement: a
        }
      };
    }
  };
}, il = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: i,
        placement: r
      } = t, {
        mainAxis: s = !0,
        crossAxis: a = !1,
        limiter: o = {
          fn: (E) => {
            let {
              x: y,
              y: m
            } = E;
            return {
              x: y,
              y: m
            };
          }
        },
        ...c
      } = ut(e, t), l = {
        x: n,
        y: i
      }, u = await Er(t, c), p = Xe(st(r)), h = vi(p);
      let g = l[h], _ = l[p];
      if (s) {
        const E = h === "y" ? "top" : "left", y = h === "y" ? "bottom" : "right", m = g + u[E], f = g - u[y];
        g = ei(m, g, f);
      }
      if (a) {
        const E = p === "y" ? "top" : "left", y = p === "y" ? "bottom" : "right", m = _ + u[E], f = _ - u[y];
        _ = ei(m, _, f);
      }
      const b = o.fn({
        ...t,
        [h]: g,
        [p]: _
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - i,
          enabled: {
            [h]: s,
            [p]: a
          }
        }
      };
    }
  };
}, rl = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: i,
        placement: r,
        rects: s,
        middlewareData: a
      } = t, {
        offset: o = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = ut(e, t), u = {
        x: n,
        y: i
      }, p = Xe(r), h = vi(p);
      let g = u[h], _ = u[p];
      const b = ut(o, t), E = typeof b == "number" ? {
        mainAxis: b,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...b
      };
      if (c) {
        const f = h === "y" ? "height" : "width", v = s.reference[h] - s.floating[f] + E.mainAxis, w = s.reference[h] + s.reference[f] - E.mainAxis;
        g < v ? g = v : g > w && (g = w);
      }
      if (l) {
        var y, m;
        const f = h === "y" ? "width" : "height", v = Sr.has(st(r)), w = s.reference[p] - s.floating[f] + (v && ((y = a.offset) == null ? void 0 : y[p]) || 0) + (v ? 0 : E.crossAxis), T = s.reference[p] + s.reference[f] + (v ? 0 : ((m = a.offset) == null ? void 0 : m[p]) || 0) - (v ? E.crossAxis : 0);
        _ < w ? _ = w : _ > T && (_ = T);
      }
      return {
        [h]: g,
        [p]: _
      };
    }
  };
};
function Tr(e) {
  const t = Ce(e);
  let n = parseFloat(t.width) || 0, i = parseFloat(t.height) || 0;
  const r = He(e), s = r ? e.offsetWidth : n, a = r ? e.offsetHeight : i, o = cn(n) !== s || cn(i) !== a;
  return o && (n = s, i = a), {
    width: n,
    height: i,
    $: o
  };
}
function yi(e) {
  return de(e) ? e : e.contextElement;
}
function bt(e) {
  const t = yi(e);
  if (!He(t))
    return $e(1);
  const n = t.getBoundingClientRect(), {
    width: i,
    height: r,
    $: s
  } = Tr(t);
  let a = (s ? cn(n.width) : n.width) / i, o = (s ? cn(n.height) : n.height) / r;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const sl = /* @__PURE__ */ $e(0);
function Nr(e) {
  const t = we(e);
  return !_i() || !t.visualViewport ? sl : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function al(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== we(e) ? !1 : t;
}
function pt(e, t, n, i) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), s = yi(e);
  let a = $e(1);
  t && (i ? de(i) && (a = bt(i)) : a = bt(e));
  const o = al(s, n, i) ? Nr(s) : $e(0);
  let c = (r.left + o.x) / a.x, l = (r.top + o.y) / a.y, u = r.width / a.x, p = r.height / a.y;
  if (s) {
    const h = we(s), g = i && de(i) ? we(i) : i;
    let _ = h, b = Jn(_);
    for (; b && i && g !== _; ) {
      const E = bt(b), y = b.getBoundingClientRect(), m = Ce(b), f = y.left + (b.clientLeft + parseFloat(m.paddingLeft)) * E.x, v = y.top + (b.clientTop + parseFloat(m.paddingTop)) * E.y;
      c *= E.x, l *= E.y, u *= E.x, p *= E.y, c += f, l += v, _ = we(b), b = Jn(_);
    }
  }
  return un({
    width: u,
    height: p,
    x: c,
    y: l
  });
}
function Cn(e, t) {
  const n = Nn(e).scrollLeft;
  return t ? t.left + n : pt(Be(e)).left + n;
}
function Cr(e, t) {
  const n = e.getBoundingClientRect(), i = n.left + t.scrollLeft - Cn(e, n), r = n.top + t.scrollTop;
  return {
    x: i,
    y: r
  };
}
function ol(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: i,
    strategy: r
  } = e;
  const s = r === "fixed", a = Be(i), o = t ? Tn(t.floating) : !1;
  if (i === a || o && s)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = $e(1);
  const u = $e(0), p = He(i);
  if ((p || !p && !s) && ((Nt(i) !== "body" || zt(a)) && (c = Nn(i)), He(i))) {
    const g = pt(i);
    l = bt(i), u.x = g.x + i.clientLeft, u.y = g.y + i.clientTop;
  }
  const h = a && !p && !s ? Cr(a, c) : $e(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + u.x + h.x,
    y: n.y * l.y - c.scrollTop * l.y + u.y + h.y
  };
}
function ll(e) {
  return Array.from(e.getClientRects());
}
function cl(e) {
  const t = Be(e), n = Nn(e), i = e.ownerDocument.body, r = dt(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth), s = dt(t.scrollHeight, t.clientHeight, i.scrollHeight, i.clientHeight);
  let a = -n.scrollLeft + Cn(e);
  const o = -n.scrollTop;
  return Ce(i).direction === "rtl" && (a += dt(t.clientWidth, i.clientWidth) - r), {
    width: r,
    height: s,
    x: a,
    y: o
  };
}
const Vi = 25;
function dl(e, t) {
  const n = we(e), i = Be(e), r = n.visualViewport;
  let s = i.clientWidth, a = i.clientHeight, o = 0, c = 0;
  if (r) {
    s = r.width, a = r.height;
    const u = _i();
    (!u || u && t === "fixed") && (o = r.offsetLeft, c = r.offsetTop);
  }
  const l = Cn(i);
  if (l <= 0) {
    const u = i.ownerDocument, p = u.body, h = getComputedStyle(p), g = u.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, _ = Math.abs(i.clientWidth - p.clientWidth - g);
    _ <= Vi && (s -= _);
  } else l <= Vi && (s += l);
  return {
    width: s,
    height: a,
    x: o,
    y: c
  };
}
const ul = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function pl(e, t) {
  const n = pt(e, !0, t === "fixed"), i = n.top + e.clientTop, r = n.left + e.clientLeft, s = He(e) ? bt(e) : $e(1), a = e.clientWidth * s.x, o = e.clientHeight * s.y, c = r * s.x, l = i * s.y;
  return {
    width: a,
    height: o,
    x: c,
    y: l
  };
}
function $i(e, t, n) {
  let i;
  if (t === "viewport")
    i = dl(e, n);
  else if (t === "document")
    i = cl(Be(e));
  else if (de(t))
    i = pl(t, n);
  else {
    const r = Nr(e);
    i = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return un(i);
}
function Ar(e, t) {
  const n = rt(e);
  return n === t || !de(n) || xt(n) ? !1 : Ce(n).position === "fixed" || Ar(n, t);
}
function hl(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let i = Pt(e, [], !1).filter((o) => de(o) && Nt(o) !== "body"), r = null;
  const s = Ce(e).position === "fixed";
  let a = s ? rt(e) : e;
  for (; de(a) && !xt(a); ) {
    const o = Ce(a), c = gi(a);
    !c && o.position === "fixed" && (r = null), (s ? !c && !r : !c && o.position === "static" && !!r && ul.has(r.position) || zt(a) && !c && Ar(e, a)) ? i = i.filter((u) => u !== a) : r = o, a = rt(a);
  }
  return t.set(e, i), i;
}
function fl(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: i,
    strategy: r
  } = e;
  const a = [...n === "clippingAncestors" ? Tn(t) ? [] : hl(t, this._c) : [].concat(n), i], o = a[0], c = a.reduce((l, u) => {
    const p = $i(t, u, r);
    return l.top = dt(p.top, l.top), l.right = Et(p.right, l.right), l.bottom = Et(p.bottom, l.bottom), l.left = dt(p.left, l.left), l;
  }, $i(t, o, r));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function ml(e) {
  const {
    width: t,
    height: n
  } = Tr(e);
  return {
    width: t,
    height: n
  };
}
function gl(e, t, n) {
  const i = He(t), r = Be(t), s = n === "fixed", a = pt(e, !0, s, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = $e(0);
  function l() {
    c.x = Cn(r);
  }
  if (i || !i && !s)
    if ((Nt(t) !== "body" || zt(r)) && (o = Nn(t)), i) {
      const g = pt(t, !0, s, t);
      c.x = g.x + t.clientLeft, c.y = g.y + t.clientTop;
    } else r && l();
  s && !i && r && l();
  const u = r && !i && !s ? Cr(r, o) : $e(0), p = a.left + o.scrollLeft - c.x - u.x, h = a.top + o.scrollTop - c.y - u.y;
  return {
    x: p,
    y: h,
    width: a.width,
    height: a.height
  };
}
function Ln(e) {
  return Ce(e).position === "static";
}
function zi(e, t) {
  if (!He(e) || Ce(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Be(e) === n && (n = n.ownerDocument.body), n;
}
function Mr(e, t) {
  const n = we(e);
  if (Tn(e))
    return n;
  if (!He(e)) {
    let r = rt(e);
    for (; r && !xt(r); ) {
      if (de(r) && !Ln(r))
        return r;
      r = rt(r);
    }
    return n;
  }
  let i = zi(e, t);
  for (; i && Mo(i) && Ln(i); )
    i = zi(i, t);
  return i && xt(i) && Ln(i) && !gi(i) ? n : i || Po(e) || n;
}
const _l = async function(e) {
  const t = this.getOffsetParent || Mr, n = this.getDimensions, i = await n(e.floating);
  return {
    reference: gl(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function vl(e) {
  return Ce(e).direction === "rtl";
}
const wl = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ol,
  getDocumentElement: Be,
  getClippingRect: fl,
  getOffsetParent: Mr,
  getElementRects: _l,
  getClientRects: ll,
  getDimensions: ml,
  getScale: bt,
  isElement: de,
  isRTL: vl
};
function Ir(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function bl(e, t) {
  let n = null, i;
  const r = Be(e);
  function s() {
    var o;
    clearTimeout(i), (o = n) == null || o.disconnect(), n = null;
  }
  function a(o, c) {
    o === void 0 && (o = !1), c === void 0 && (c = 1), s();
    const l = e.getBoundingClientRect(), {
      left: u,
      top: p,
      width: h,
      height: g
    } = l;
    if (o || t(), !h || !g)
      return;
    const _ = qt(p), b = qt(r.clientWidth - (u + h)), E = qt(r.clientHeight - (p + g)), y = qt(u), f = {
      rootMargin: -_ + "px " + -b + "px " + -E + "px " + -y + "px",
      threshold: dt(0, Et(1, c)) || 1
    };
    let v = !0;
    function w(T) {
      const N = T[0].intersectionRatio;
      if (N !== c) {
        if (!v)
          return a();
        N ? a(!1, N) : i = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      N === 1 && !Ir(l, e.getBoundingClientRect()) && a(), v = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...f,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, f);
    }
    n.observe(e);
  }
  return a(!0), s;
}
function Rr(e, t, n, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = i, l = yi(e), u = r || s ? [...l ? Pt(l) : [], ...Pt(t)] : [];
  u.forEach((y) => {
    r && y.addEventListener("scroll", n, {
      passive: !0
    }), s && y.addEventListener("resize", n);
  });
  const p = l && o ? bl(l, n) : null;
  let h = -1, g = null;
  a && (g = new ResizeObserver((y) => {
    let [m] = y;
    m && m.target === l && g && (g.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var f;
      (f = g) == null || f.observe(t);
    })), n();
  }), l && !c && g.observe(l), g.observe(t));
  let _, b = c ? pt(e) : null;
  c && E();
  function E() {
    const y = pt(e);
    b && !Ir(b, y) && n(), b = y, _ = requestAnimationFrame(E);
  }
  return n(), () => {
    var y;
    u.forEach((m) => {
      r && m.removeEventListener("scroll", n), s && m.removeEventListener("resize", n);
    }), p == null || p(), (y = g) == null || y.disconnect(), g = null, c && cancelAnimationFrame(_);
  };
}
const yl = nl, xl = il, El = el, Hi = Jo, Sl = rl, Tl = (e, t, n) => {
  const i = /* @__PURE__ */ new Map(), r = {
    platform: wl,
    ...n
  }, s = {
    ...r.platform,
    _c: i
  };
  return Qo(e, t, {
    ...r,
    platform: s
  });
};
var Nl = typeof document < "u", Cl = function() {
}, Jt = Nl ? pi : Cl;
function hn(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, i, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (i = n; i-- !== 0; )
        if (!hn(e[i], t[i]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (i = n; i-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[i]))
        return !1;
    for (i = n; i-- !== 0; ) {
      const s = r[i];
      if (!(s === "_owner" && e.$$typeof) && !hn(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function kr(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Bi(e, t) {
  const n = kr(e);
  return Math.round(t * n) / n;
}
function Pn(e) {
  const t = x.useRef(e);
  return Jt(() => {
    t.current = e;
  }), t;
}
function Al(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: i = [],
    platform: r,
    elements: {
      reference: s,
      floating: a
    } = {},
    transform: o = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, p] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, g] = x.useState(i);
  hn(h, i) || g(i);
  const [_, b] = x.useState(null), [E, y] = x.useState(null), m = x.useCallback((M) => {
    M !== T.current && (T.current = M, b(M));
  }, []), f = x.useCallback((M) => {
    M !== N.current && (N.current = M, y(M));
  }, []), v = s || _, w = a || E, T = x.useRef(null), N = x.useRef(null), A = x.useRef(u), R = c != null, S = Pn(c), k = Pn(r), P = Pn(l), D = x.useCallback(() => {
    if (!T.current || !N.current)
      return;
    const M = {
      placement: t,
      strategy: n,
      middleware: h
    };
    k.current && (M.platform = k.current), Tl(T.current, N.current, M).then(($) => {
      const q = {
        ...$,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: P.current !== !1
      };
      V.current && !hn(A.current, q) && (A.current = q, us.flushSync(() => {
        p(q);
      }));
    });
  }, [h, t, n, k, P]);
  Jt(() => {
    l === !1 && A.current.isPositioned && (A.current.isPositioned = !1, p((M) => ({
      ...M,
      isPositioned: !1
    })));
  }, [l]);
  const V = x.useRef(!1);
  Jt(() => (V.current = !0, () => {
    V.current = !1;
  }), []), Jt(() => {
    if (v && (T.current = v), w && (N.current = w), v && w) {
      if (S.current)
        return S.current(v, w, D);
      D();
    }
  }, [v, w, D, S, R]);
  const z = x.useMemo(() => ({
    reference: T,
    floating: N,
    setReference: m,
    setFloating: f
  }), [m, f]), O = x.useMemo(() => ({
    reference: v,
    floating: w
  }), [v, w]), C = x.useMemo(() => {
    const M = {
      position: n,
      left: 0,
      top: 0
    };
    if (!O.floating)
      return M;
    const $ = Bi(O.floating, u.x), q = Bi(O.floating, u.y);
    return o ? {
      ...M,
      transform: "translate(" + $ + "px, " + q + "px)",
      ...kr(O.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: $,
      top: q
    };
  }, [n, o, O.floating, u.x, u.y]);
  return x.useMemo(() => ({
    ...u,
    update: D,
    refs: z,
    elements: O,
    floatingStyles: C
  }), [u, D, z, O, C]);
}
const Ml = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: i,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return i && t(i) ? i.current != null ? Hi({
        element: i.current,
        padding: r
      }).fn(n) : {} : i ? Hi({
        element: i,
        padding: r
      }).fn(n) : {};
    }
  };
}, Lr = (e, t) => ({
  ...yl(e),
  options: [e, t]
}), Pr = (e, t) => ({
  ...xl(e),
  options: [e, t]
}), Il = (e, t) => ({
  ...Sl(e),
  options: [e, t]
}), Rl = (e, t) => ({
  ...El(e),
  options: [e, t]
}), kl = (e, t) => ({
  ...Ml(e),
  options: [e, t]
}), Ll = {
  ...x
};
let Fi = !1, Pl = 0;
const Gi = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + Pl++
);
function Ol() {
  const [e, t] = x.useState(() => Fi ? Gi() : void 0);
  return pn(() => {
    e == null && t(Gi());
  }, []), x.useEffect(() => {
    Fi = !0;
  }, []), e;
}
const Dl = Ll.useId, Or = Dl || Ol;
let Ot;
process.env.NODE_ENV !== "production" && (Ot = /* @__PURE__ */ new Set());
function Vl() {
  for (var e, t = arguments.length, n = new Array(t), i = 0; i < t; i++)
    n[i] = arguments[i];
  const r = "Floating UI: " + n.join(" ");
  if (!((e = Ot) != null && e.has(r))) {
    var s;
    (s = Ot) == null || s.add(r), console.warn(r);
  }
}
function $l() {
  for (var e, t = arguments.length, n = new Array(t), i = 0; i < t; i++)
    n[i] = arguments[i];
  const r = "Floating UI: " + n.join(" ");
  if (!((e = Ot) != null && e.has(r))) {
    var s;
    (s = Ot) == null || s.add(r), console.error(r);
  }
}
const zl = /* @__PURE__ */ x.forwardRef(function(t, n) {
  const {
    context: {
      placement: i,
      elements: {
        floating: r
      },
      middlewareData: {
        arrow: s,
        shift: a
      }
    },
    width: o = 14,
    height: c = 7,
    tipRadius: l = 0,
    strokeWidth: u = 0,
    staticOffset: p,
    stroke: h,
    d: g,
    style: {
      transform: _,
      ...b
    } = {},
    ...E
  } = t;
  process.env.NODE_ENV !== "production" && (n || Vl("The `ref` prop is required for `FloatingArrow`."));
  const y = Or(), [m, f] = x.useState(!1);
  if (pn(() => {
    if (!r) return;
    Ce(r).direction === "rtl" && f(!0);
  }, [r]), !r)
    return null;
  const [v, w] = i.split("-"), T = v === "top" || v === "bottom";
  let N = p;
  (T && a != null && a.x || !T && a != null && a.y) && (N = null);
  const A = u * 2, R = A / 2, S = o / 2 * (l / -8 + 1), k = c / 2 * l / 4, P = !!g, D = N && w === "end" ? "bottom" : "top";
  let V = N && w === "end" ? "right" : "left";
  N && m && (V = w === "end" ? "left" : "right");
  const z = (s == null ? void 0 : s.x) != null ? N || s.x : "", O = (s == null ? void 0 : s.y) != null ? N || s.y : "", C = g || "M0,0" + (" H" + o) + (" L" + (o - S) + "," + (c - k)) + (" Q" + o / 2 + "," + c + " " + S + "," + (c - k)) + " Z", M = {
    top: P ? "rotate(180deg)" : "",
    left: P ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: P ? "" : "rotate(180deg)",
    right: P ? "rotate(-90deg)" : "rotate(90deg)"
  }[v];
  return /* @__PURE__ */ I("svg", {
    ...E,
    "aria-hidden": !0,
    ref: n,
    width: P ? o : o + A,
    height: o,
    viewBox: "0 0 " + o + " " + (c > o ? c : o),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [V]: z,
      [D]: O,
      [v]: T || P ? "100%" : "calc(100% - " + A / 2 + "px)",
      transform: [M, _].filter(($) => !!$).join(" "),
      ...b
    },
    children: [A > 0 && /* @__PURE__ */ d("path", {
      clipPath: "url(#" + y + ")",
      fill: "none",
      stroke: h,
      strokeWidth: A + (g ? 0 : 1),
      d: C
    }), /* @__PURE__ */ d("path", {
      stroke: A && !g ? E.fill : "none",
      d: C
    }), /* @__PURE__ */ d("clipPath", {
      id: y,
      children: /* @__PURE__ */ d("rect", {
        x: -R,
        y: R * (P ? -1 : 1),
        width: o + A,
        height: o
      })
    })]
  });
});
function Hl() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var i;
      (i = e.get(t)) == null || i.forEach((r) => r(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var i;
      (i = e.get(t)) == null || i.delete(n);
    }
  };
}
const Bl = /* @__PURE__ */ x.createContext(null), Fl = /* @__PURE__ */ x.createContext(null), Gl = () => {
  var e;
  return ((e = x.useContext(Bl)) == null ? void 0 : e.id) || null;
}, Ul = () => x.useContext(Fl);
function ql(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: i
  } = e, r = Or(), s = x.useRef({}), [a] = x.useState(() => Hl()), o = Gl() != null;
  if (process.env.NODE_ENV !== "production") {
    const g = i.reference;
    g && !de(g) && $l("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [c, l] = x.useState(i.reference), u = Ko((g, _, b) => {
    s.current.openEvent = g ? _ : void 0, a.emit("openchange", {
      open: g,
      event: _,
      reason: b,
      nested: o
    }), n == null || n(g, _, b);
  }), p = x.useMemo(() => ({
    setPositionReference: l
  }), []), h = x.useMemo(() => ({
    reference: c || i.reference || null,
    floating: i.floating || null,
    domReference: i.reference
  }), [c, i.reference, i.floating]);
  return x.useMemo(() => ({
    dataRef: s,
    open: t,
    onOpenChange: u,
    elements: h,
    events: a,
    floatingId: r,
    refs: p
  }), [t, u, h, a, r, p]);
}
function Dr(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = ql({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), i = e.rootContext || n, r = i.elements, [s, a] = x.useState(null), [o, c] = x.useState(null), u = (r == null ? void 0 : r.domReference) || s, p = x.useRef(null), h = Ul();
  pn(() => {
    u && (p.current = u);
  }, [u]);
  const g = Al({
    ...e,
    elements: {
      ...r,
      ...o && {
        reference: o
      }
    }
  }), _ = x.useCallback((f) => {
    const v = de(f) ? {
      getBoundingClientRect: () => f.getBoundingClientRect(),
      getClientRects: () => f.getClientRects(),
      contextElement: f
    } : f;
    c(v), g.refs.setReference(v);
  }, [g.refs]), b = x.useCallback((f) => {
    (de(f) || f === null) && (p.current = f, a(f)), (de(g.refs.reference.current) || g.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    f !== null && !de(f)) && g.refs.setReference(f);
  }, [g.refs]), E = x.useMemo(() => ({
    ...g.refs,
    setReference: b,
    setPositionReference: _,
    domReference: p
  }), [g.refs, b, _]), y = x.useMemo(() => ({
    ...g.elements,
    domReference: u
  }), [g.elements, u]), m = x.useMemo(() => ({
    ...g,
    ...i,
    refs: E,
    elements: y,
    nodeId: t
  }), [g, E, y, t, i]);
  return pn(() => {
    i.dataRef.current.floatingContext = m;
    const f = h == null ? void 0 : h.nodesRef.current.find((v) => v.id === t);
    f && (f.context = m);
  }), x.useMemo(() => ({
    ...g,
    context: m,
    refs: E,
    elements: y
  }), [g, E, y, m]);
}
const Wl = 20, Yl = 8, Vr = ({
  placement: e = "bottom",
  tooltipOffset: t = Wl,
  shiftPadding: n = Yl
}) => {
  const [i, r] = B(!1), s = G(null), { refs: a, floatingStyles: o, context: c } = Dr({
    placement: e,
    open: i,
    onOpenChange: r,
    middleware: [Lr(t), Rl(), Pr({ padding: n }), kl({ element: s })],
    whileElementsMounted: Rr
  });
  return {
    refs: a,
    floatingStyles: o,
    context: c,
    arrowRef: s,
    open: i,
    setOpen: r
  };
}, Wt = {
  "tooltip-content": "tooltip-content",
  "tooltip-content--open": "tooltip-content--open",
  "tooltip-content__text": "tooltip-content__text",
  "tooltip-content__arrow": "tooltip-content__arrow"
}, $r = ({
  children: e,
  floatingStyles: t,
  arrowRef: n,
  open: i,
  context: r,
  refs: s,
  ...a
}) => /* @__PURE__ */ I(
  "div",
  {
    ref: s.setFloating,
    style: t,
    role: "status",
    className: L(Wt["tooltip-content"], i && Wt["tooltip-content--open"]),
    ...a,
    children: [
      /* @__PURE__ */ d("div", { className: Wt["tooltip-content__text"], children: e }),
      /* @__PURE__ */ d(zl, { className: Wt["tooltip-content__arrow"], ref: n, context: r })
    ]
  }
), jl = "tooltip", Xl = "tooltip__icon", On = {
  tooltip: jl,
  tooltip__icon: Xl,
  "tooltip__icon--active": "tooltip__icon--active"
}, Zl = 18, xi = ({ children: e, height: t = Zl, ariaLabel: n }) => {
  const { refs: i, floatingStyles: r, arrowRef: s, context: a, open: o, setOpen: c } = Vr({ placement: "bottom" });
  Tt(() => c(!1), o);
  const l = () => c((h) => !h), u = () => c(!0), p = () => c(!1);
  return /* @__PURE__ */ I("div", { className: On.tooltip, children: [
    /* @__PURE__ */ d(
      "button",
      {
        ref: i.setReference,
        type: "button",
        className: L(On.tooltip__icon, o && On["tooltip__icon--active"]),
        "aria-label": n,
        onClick: l,
        onMouseEnter: u,
        onMouseLeave: p,
        onBlur: () => c(!1),
        children: /* @__PURE__ */ d(F, { icon: "info", height: `${Ie(t)}rem` })
      }
    ),
    /* @__PURE__ */ d(
      $r,
      {
        floatingStyles: r,
        arrowRef: s,
        open: o,
        context: a,
        refs: i,
        children: e
      }
    )
  ] });
}, ye = {
  "roche-dropdown": "roche-dropdown",
  "roche-dropdown__label-wrapper": "roche-dropdown__label-wrapper",
  "roche-dropdown__label": "roche-dropdown__label",
  "roche-dropdown__select": "roche-dropdown__select",
  "roche-dropdown__select--placeholder": "roche-dropdown__select--placeholder",
  "roche-dropdown__container": "roche-dropdown__container",
  "roche-dropdown__icon": "roche-dropdown__icon",
  "roche-dropdown--disabled": "roche-dropdown--disabled",
  "roche-dropdown__error": "roche-dropdown__error",
  "roche-dropdown--error": "roche-dropdown--error",
  "roche-dropdown__error-text": "roche-dropdown__error-text",
  "roche-dropdown--chrome-safari": "roche-dropdown--chrome-safari"
}, $h = ({
  id: e,
  name: t,
  label: n,
  tooltip: i,
  tooltipAriaLabel: r,
  options: s,
  value: a,
  placeholder: o,
  error: c,
  hasError: l = !1,
  required: u = !1,
  disabled: p = !1,
  slot: h,
  onChange: g,
  onBlur: _
}) => {
  const b = `${e}-error`, E = (v) => {
    g && g(v.target.value);
  }, y = L(
    ye["roche-dropdown"],
    p && [ye["roche-dropdown--disabled"]],
    (c || l) && [ye["roche-dropdown--error"]]
  ), m = L(
    ye["roche-dropdown__select"],
    !a && o && [ye["roche-dropdown__select--placeholder"]],
    // Browser detection to fix RTL alignment issue --> To be removed as soon as these browsers fix alignment issue on their side
    (No() || wr()) && [ye["roche-dropdown--chrome-safari"]]
  ), f = !!(c || l);
  return /* @__PURE__ */ I("div", { className: y, slot: h, children: [
    n && /* @__PURE__ */ I("div", { className: ye["roche-dropdown__label-wrapper"], children: [
      /* @__PURE__ */ d("label", { htmlFor: e, className: ye["roche-dropdown__label"], children: mi(u, n) }),
      i && /* @__PURE__ */ d(xi, { ariaLabel: r, children: i })
    ] }),
    /* @__PURE__ */ I("div", { className: ye["roche-dropdown__container"], children: [
      /* @__PURE__ */ I(
        "select",
        {
          id: e,
          name: t,
          value: a || "",
          required: u,
          disabled: p,
          onChange: E,
          onBlur: _,
          className: m,
          "aria-invalid": f,
          "aria-describedby": f ? b : void 0,
          children: [
            /* @__PURE__ */ d("option", { value: "", disabled: !0, children: o }),
            s.map((v, w) => /* @__PURE__ */ d("option", { value: v.value || v.label, children: v.label }, v.value || v.label || w))
          ]
        }
      ),
      /* @__PURE__ */ d("div", { className: ye["roche-dropdown__icon"], children: /* @__PURE__ */ d(F, { icon: "chevron-down", width: "16px", decorative: !0 }) })
    ] }),
    /* @__PURE__ */ d("div", { className: ye["roche-dropdown__error"], children: c && /* @__PURE__ */ I(ze, { children: [
      /* @__PURE__ */ d(F, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ d("p", { id: b, role: "alert", className: ye["roche-dropdown__error-text"], children: c })
    ] }) })
  ] });
}, Ui = (e) => {
  let t = e.toLowerCase();
  return t = t.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), t = t.replace(/[^a-z0-9\s-]/g, ""), t = t.replace(/\s+/g, "-"), t = t.replace(/^-+|-+$/g, ""), t.match(/^\d/) && (t = `_${t}`), t;
}, Kl = "grid", Ql = "grid__column", Jl = "grid__columns", xe = {
  grid: Kl,
  "grid--hide-in-print-view": "grid--hide-in-print-view",
  "grid--no-padding": "grid--no-padding",
  "grid--extend-background-to-top": "grid--extend-background-to-top",
  "grid--has-breadcrumbs": "grid--has-breadcrumbs",
  "grid--has-staging-hero": "grid--has-staging-hero",
  "grid--move-to-back": "grid--move-to-back",
  "grid--overflow-visible": "grid--overflow-visible",
  "grid--equal-columns": "grid--equal-columns",
  grid__column: Ql,
  grid__columns: Jl,
  "grid__columns--multiple-rows": "grid__columns--multiple-rows"
}, ec = {
  "roche-grid-1-4-1-6": "1-4-1-6",
  "roche-grid-12": "12",
  "roche-grid-3-1-5-3": "3-1-5-3",
  "roche-grid-3-1-8": "3-1-8",
  "roche-grid-3-3-3-3": "3-3-3-3",
  "roche-grid-4-4-4": "4-4-4",
  "roche-grid-4-8": "4-8",
  "roche-grid-5-1-6": "5-1-6",
  "roche-grid-5-7": "5-7",
  "roche-grid-6-1-4-1": "6-1-4-1",
  "roche-grid-6-6": "6-6",
  "roche-grid-7-5": "7-5",
  "roche-grid-8-4": "8-4",
  "roche-grid-8": "8",
  "roche-grid-6": "6",
  "roche-grid-6-1-5": "6-1-5",
  "roche-grid-8-1-3": "8-1-3",
  "roche-grid-7-1-4": "7-1-4"
}, tc = {
  1: ["full"],
  2: ["left", "right"],
  3: ["left", "center", "right"],
  4: ["left", "center-left", "center-right", "right"]
}, zr = (e, t, n) => ({
  span: parseInt(e, 10),
  slotName: tc[n.length][t]
}), nc = (e) => e.split("-").map(zr), ic = (e) => e.split("-").reverse().map(zr), qi = (e) => e === "roche-staging-hero", Wi = (e) => e === "roche-story-staging-hero", rc = (e) => e === "roche-stage-home", sc = (e) => e.type === lo || e.type === "roche-breadcrumbs", ac = (e) => e === "hero--variant-b", wt = ({
  layout: e,
  fullWidth: t,
  backgroundColor: n,
  hideInPrintView: i,
  isRightToLeft: r,
  noPadding: s,
  fullHeight: a,
  stagingHero: o,
  multipleRows: c,
  overflowVisible: l,
  children: u
}) => {
  const p = ec[e] || e, h = "columns is-centered is-variable is-0-mobile is-3-tablet is-4-desktop", g = Rn.toArray(u), _ = g.some((w) => Ct(w) && sc(w)), b = g.some(
    (w) => {
      var T;
      return Ct(w) && rc((T = w.props.blok) == null ? void 0 : T.component);
    }
  ), E = g.some(
    (w) => {
      var T, N;
      return Ct(w) && (qi((T = w.props.blok) == null ? void 0 : T.component) || Wi((N = w.props.blok) == null ? void 0 : N.component));
    }
  ), y = g.some(
    (w) => {
      var T, N, A, R;
      return Ct(w) && (qi((T = w.props.blok) == null ? void 0 : T.component) || Wi((N = w.props.blok) == null ? void 0 : N.component)) && ac(((A = w.props.blok) == null ? void 0 : A.variant) ?? ((R = w.props.blok) == null ? void 0 : R.layout)) || o;
    }
  ), m = (w) => {
    const T = w.split("-");
    return T.every((N) => N === T[0]);
  }, f = L(
    xe.grid,
    b && xe["grid--extend-background-to-top"],
    i && xe["grid--hide-in-print-view"],
    (s || E || b) && xe["grid--no-padding"],
    l && xe["grid--overflow-visible"],
    _ && xe["grid--has-breadcrumbs"],
    (E || o) && xe["grid--has-staging-hero"],
    y && xe["grid--move-to-back"],
    m(p) && xe["grid--equal-columns"]
  );
  if (!Rn)
    return null;
  const v = r ? ic(p).reverse() : nc(p);
  return /* @__PURE__ */ d("div", { className: f, children: /* @__PURE__ */ d(
    uo,
    {
      fullWidth: t,
      color: n,
      fullHeight: a,
      extendBackgroundToTop: b,
      children: /* @__PURE__ */ d(
        "div",
        {
          className: `${L(
            xe.grid__columns,
            h,
            c && xe["grid__columns--multiple-rows"]
          )}`,
          children: v.map(({ span: w, slotName: T }, N) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
            /* @__PURE__ */ d("div", { className: `${xe.grid__column} column is-${w} is-offset-0`, children: Rn.map(u, (A) => {
              if (Ct(A) && A.props.slot === T)
                return A;
            }) }, N)
          ))
        }
      )
    }
  ) });
}, oc = "footer", lc = "footer__copyright", le = {
  footer: oc,
  "footer__first-row": "footer__first-row",
  "footer__columns-container": "footer__columns-container",
  "footer__second-row": "footer__second-row",
  "footer__third-row": "footer__third-row",
  "footer__quick-links": "footer__quick-links",
  "footer__column-title": "footer__column-title",
  "footer__stock-price": "footer__stock-price",
  "footer__quick-links-nav": "footer__quick-links-nav",
  "footer__social-links-nav": "footer__social-links-nav",
  footer__copyright: lc,
  "footer__social-links": "footer__social-links",
  "footer__service-links": "footer__service-links",
  "footer__legal-text": "footer__legal-text",
  "footer--with-extra-columns": "footer--with-extra-columns"
}, cc = 3, dc = (e, t, n) => n && t ? e === 0 ? "right" : e === 1 ? "center" : "left" : t && !n ? e === 0 ? "left" : e === 1 ? "center" : "right" : n ? e === 0 ? "right" : "left" : e === 0 ? "left" : "right", zh = ({
  quickLinksTitle: e,
  quickLinks: t,
  footerColumns: n,
  stockPrice: i,
  socialLinksTitle: r,
  socialLinks: s,
  serviceLinksTitle: a,
  serviceLinks: o,
  year: c,
  date: l,
  copyright: u,
  text: p,
  isRightToLeft: h
}) => {
  const _ = !!((n == null ? void 0 : n.length) === cc && i) ? n == null ? void 0 : n.slice(0, 2) : n == null ? void 0 : n.slice(0, 3), b = (_ == null ? void 0 : _.length) === 1, E = !!(((_ == null ? void 0 : _.length) || 0) > 1 && i || ((_ == null ? void 0 : _.length) || 0) > 2), y = b ? "8-4" : E ? "4-4-4" : "6-6";
  return /* @__PURE__ */ d("footer", { className: L(le.footer, E && le["footer--with-extra-columns"]), children: /* @__PURE__ */ I(wt, { layout: "12", noPadding: !0, children: [
    /* @__PURE__ */ d("div", { className: le["footer__first-row"], slot: "full", children: /* @__PURE__ */ I(wt, { layout: "3-1-8", fullWidth: !0, isRightToLeft: h, children: [
      /* @__PURE__ */ d(
        "nav",
        {
          className: le["footer__quick-links-nav"],
          "aria-label": e,
          slot: h ? "right" : "left",
          children: /* @__PURE__ */ d("ul", { className: le["footer__quick-links"], children: t })
        }
      ),
      /* @__PURE__ */ d("div", { slot: "center" }),
      /* @__PURE__ */ d("div", { className: le["footer__columns-container"], slot: h ? "left" : "right", children: /* @__PURE__ */ I(wt, { layout: y, fullWidth: !0, isRightToLeft: h, children: [
        _ == null ? void 0 : _.map((m, f) => /* @__PURE__ */ I(
          "nav",
          {
            "aria-labelledby": Ui(m.columnTitle),
            slot: dc(f, E, h),
            children: [
              /* @__PURE__ */ d("h3", { className: le["footer__column-title"], id: Ui(m.columnTitle), children: m.columnTitle }),
              /* @__PURE__ */ d("ul", { className: le["footer__column-links"], children: m.links })
            ]
          },
          f
        )),
        i && /* @__PURE__ */ d("div", { className: le["footer__stock-price"], slot: "right", children: i })
      ] }) })
    ] }) }),
    /* @__PURE__ */ d("div", { className: le["footer__second-row"], slot: "full", children: /* @__PURE__ */ I(wt, { layout: "4-8", fullWidth: !0, isRightToLeft: h, children: [
      /* @__PURE__ */ d(
        "nav",
        {
          className: le["footer__social-links-nav"],
          "aria-label": r,
          slot: h ? "right" : "left",
          children: /* @__PURE__ */ d("ul", { className: le["footer__social-links"], children: s })
        }
      ),
      /* @__PURE__ */ d("nav", { "aria-label": a, slot: h ? "left" : "right", children: /* @__PURE__ */ d("ul", { className: le["footer__service-links"], children: o }) })
    ] }) }),
    /* @__PURE__ */ d("div", { className: le["footer__third-row"], slot: "full", children: /* @__PURE__ */ I(wt, { layout: "4-8", fullWidth: !0, isRightToLeft: h, children: [
      /* @__PURE__ */ I("div", { className: le.footer__copyright, slot: h ? "right" : "left", children: [
        "© ",
        /* @__PURE__ */ d("time", { children: c }),
        "  ",
        u,
        "  ",
        /* @__PURE__ */ d("time", { children: l })
      ] }),
      /* @__PURE__ */ d("div", { className: le["footer__legal-text"], slot: h ? "left" : "right", children: p })
    ] }) })
  ] }) });
}, uc = "message", pc = "message__content", hc = "message__type", Mt = {
  message: uc,
  message__content: pc,
  message__type: hc,
  "message__close-button": "message__close-button",
  "message--closed": "message--closed",
  "message--success": "message--success",
  "message--error": "message--error",
  "message--info": "message--info"
}, Yt = "24px", fc = ({ type: e, message: t, showCloseButton: n, labels: i }) => {
  const [r, s] = B(!1), a = e === "error" ? "alert" : "status", o = {
    info: "info",
    error: "alert-error",
    success: "alert-success"
  }, c = () => {
    s(!0);
  };
  return /* @__PURE__ */ I(
    "div",
    {
      className: L(Mt.message, Mt[`message--${e}`], r && Mt["message--closed"]),
      role: a,
      children: [
        /* @__PURE__ */ I("div", { className: Mt.message__content, children: [
          /* @__PURE__ */ d(F, { icon: o[e], width: Yt, height: Yt, decorative: !0 }),
          /* @__PURE__ */ d("span", { className: "message__type", children: (i == null ? void 0 : i[`${e}Title`]) || e }),
          /* @__PURE__ */ d("p", { children: t })
        ] }),
        n && /* @__PURE__ */ d(
          "button",
          {
            className: Mt["message__close-button"],
            "aria-label": i == null ? void 0 : i.closeButton,
            onClick: c,
            type: "button",
            children: /* @__PURE__ */ d(F, { icon: "close", width: Yt, height: Yt, decorative: !0 })
          }
        )
      ]
    }
  );
}, mt = {
  "form-wrapper": "form-wrapper",
  "form-wrapper--one-trust-container": "form-wrapper--one-trust-container",
  "form-wrapper--title": "form-wrapper--title",
  "form-wrapper--submit-button": "form-wrapper--submit-button",
  "form-wrapper--message": "form-wrapper--message"
}, Hh = ({
  action: e,
  needsConsentText: t,
  needsConsent: n,
  onConsentRequest: i,
  consentRequestButtonText: r,
  submitButton: s,
  message: a,
  messageType: o,
  children: c,
  successComponent: l
}) => {
  const { onSubmit: u, text: p, disabled: h, loading: g, icon: _, appearance: b } = s;
  return /* @__PURE__ */ I("form", { className: mt["form-wrapper"], onSubmit: u, action: e, children: [
    c,
    n && /* @__PURE__ */ I("div", { className: mt["form-wrapper--one-trust-container"], children: [
      /* @__PURE__ */ I("div", { className: mt["form-wrapper--title"], children: [
        t,
        " *"
      ] }),
      /* @__PURE__ */ d(Lt, { onButtonClick: i, text: r, leftIcon: "chevron-right" })
    ] }),
    /* @__PURE__ */ I("div", { className: mt["form-wrapper--submit-button"], children: [
      /* @__PURE__ */ d(
        St,
        {
          text: p,
          type: $t.SUBMIT,
          appearance: b,
          rightIcon: _,
          disabled: h,
          isLoading: g
        }
      ),
      /* @__PURE__ */ d("div", { className: mt["form-wrapper--message"], children: a && /* @__PURE__ */ d(fc, { type: o, message: a }) }),
      l && /* @__PURE__ */ d("div", { className: mt["form-wrapper--message"], children: l })
    ] })
  ] });
}, Hr = () => {
  const [e, t] = B(typeof window < "u" ? window.scrollY : 0);
  return pi(() => {
    if (typeof window > "u") return;
    const n = () => {
      t(window.scrollY);
    };
    return window.addEventListener("scroll", n), () => {
      window.removeEventListener("scroll", n);
    };
  }, []), e;
}, mc = () => {
  const e = Hr(), [t, n] = B(null), [i, r] = B(e);
  return U(() => {
    e > i ? n("down") : e < i && n("up"), r(e);
  }, [e, i]), t;
}, Br = (e, t, n, i) => {
  U(() => {
    if (!t) return;
    const r = (a) => {
      if (!t) return;
      const o = a.target, c = e.current, l = i.current;
      c != null && c.contains(o) || l != null && l.contains(o) || n();
    }, s = (a) => {
      const o = a.target, c = e.current, l = i.current;
      c != null && c.contains(o) || l != null && l.contains(o) || wr() || n();
    };
    return document.addEventListener("mousedown", r), document.addEventListener("focusin", s), () => {
      document.removeEventListener("mousedown", r), document.removeEventListener("focusin", s);
    };
  }, [t, n]);
}, Yi = (e) => e == null ? void 0 : e.replace(/^\/+|\/+$/g, ""), Ne = (e, t) => Yi(e) === Yi(t), Fr = (e, t) => {
  if (!t) return null;
  const n = (i, r = []) => i.reduce((s, a, o) => {
    if (s)
      return s;
    const c = [...r, o];
    return a.url === t ? c : a.nestedLinks ? n(a.nestedLinks, c) : null;
  }, null);
  return n(e);
}, gc = (e) => e.join("-"), ni = (e) => e.split("-"), ji = (e) => {
  const t = ni(e);
  return t.pop(), t.join("-");
}, Gr = (e = [], t) => !(e != null && e.length) || !t ? !1 : e.some((n) => Ne(n.url, t) ? !0 : n.nestedLinks ? Gr(n.nestedLinks, t) : !1), _c = (e, t) => t === "" ? e.length > 0 && !e.includes("s-") : e === t || e.startsWith(`${t}-`), Xi = (e, t) => {
  for (const n of Array.from(e))
    _c(n, t) && e.delete(n);
};
function vc(e, t) {
  const [n, i] = B([e]);
  return U(() => {
    if (!t) return;
    const r = Fr(e.nestedLinks || [], t);
    if (!r) return;
    const s = r.reduce(
      (a, o) => {
        var u;
        const c = a[a.length - 1], l = (u = c == null ? void 0 : c.nestedLinks) == null ? void 0 : u[o];
        return l ? [...a, l] : a;
      },
      [e]
    );
    i(s);
  }, [e, t]), [n, i];
}
function wc(e) {
  const t = Te((i, r) => {
    if (!i)
      return;
    const s = Array.from(i.querySelectorAll("a, button")), a = s.indexOf(document.activeElement), o = r === "next" ? a + 1 : a - 1, c = s[o];
    c && c.focus();
  }, []);
  return { handleKeyDown: Te(
    (i, r) => {
      var c, l, u, p, h, g;
      const s = ((c = e.current) == null ? void 0 : c[r]) || null, a = (l = e.current) == null ? void 0 : l[r - 1], o = (u = e.current) == null ? void 0 : u[r + 1];
      switch (i.key) {
        case "ArrowRight":
          i.preventDefault(), (p = o == null ? void 0 : o.querySelector("a, button")) == null || p.focus();
          break;
        case "ArrowLeft":
          i.preventDefault(), (h = a == null ? void 0 : a.querySelector('a[aria-expanded="true"], button[aria-expanded="true"]')) == null || h.focus();
          break;
        case "Escape":
          i.preventDefault(), (g = a == null ? void 0 : a.querySelector("button")) == null || g.focus();
          break;
        case "ArrowDown":
          i.preventDefault(), t(s, "next");
          break;
        case "ArrowUp":
          i.preventDefault(), t(s, "prev");
          break;
      }
    },
    [e, t]
  ) };
}
const Ge = {
  "submenu-columns": "submenu-columns",
  "nav-block": "nav-block",
  "nav-block__item": "nav-block__item",
  "nav-block__item--active": "nav-block__item--active",
  "nav-block__item--open": "nav-block__item--open",
  "nav-block__item--link": "nav-block__item--link",
  "nav-block__title": "nav-block__title",
  "nav-block__title--active": "nav-block__title--active"
}, bc = ({
  root: e,
  currentPage: t,
  updateFlyoutPosition: n
}) => {
  const i = G([]), [r, s] = vc(e, t), { handleKeyDown: a } = wc(i), o = (l, u) => {
    var h;
    if (n == null || n(), ((h = r[u]) == null ? void 0 : h.url) === l.url) {
      s(r.slice(0, u));
      return;
    }
    const p = r.slice(0, u);
    p[u] = l, s(p), setTimeout(() => c(u), 0);
  }, c = (l) => {
    var u, p;
    (p = (u = i.current[l]) == null ? void 0 : u.querySelector("a, button")) == null || p.focus();
  };
  return /* @__PURE__ */ d("div", { className: Ge["submenu-columns"], role: "group", "aria-label": e.text, children: r.map((l, u) => {
    var p;
    return l.nestedLinks ? /* @__PURE__ */ I(
      "ul",
      {
        id: `submenu-${l.url}`,
        className: Ge["nav-block"],
        ref: (h) => {
          i.current[u] = h;
        },
        onKeyDown: (h) => a(h, u),
        children: [
          /* @__PURE__ */ d("li", { children: /* @__PURE__ */ I(
            "a",
            {
              href: l.url,
              className: L(
                Ge["nav-block__title"],
                Ne(l.url, t) && Ge["nav-block__title--active"]
              ),
              "aria-current": Ne(l.url, t) ? "page" : void 0,
              onClick: l.onClick,
              children: [
                l.text,
                /* @__PURE__ */ d(F, { icon: "arrow-right", height: "24px", decorative: !0 })
              ]
            }
          ) }),
          (p = l.nestedLinks) == null ? void 0 : p.map((h) => {
            var g, _;
            return /* @__PURE__ */ d("li", { children: h.nestedLinks ? /* @__PURE__ */ I(
              "button",
              {
                type: "button",
                className: L(
                  Ge["nav-block__item"],
                  ((g = r[u + 1]) == null ? void 0 : g.url) === h.url && Ge["nav-block__item--open"]
                ),
                onClick: () => o(h, u + 1),
                "aria-expanded": ((_ = r[u + 1]) == null ? void 0 : _.url) === h.url,
                "aria-controls": h.url ? `submenu-${h.url}` : void 0,
                children: [
                  h.text,
                  /* @__PURE__ */ d(F, { icon: "chevron-right", height: "24px", decorative: !0 })
                ]
              }
            ) : /* @__PURE__ */ d(
              "a",
              {
                href: h.url,
                "aria-current": Ne(h.url, t) ? "page" : void 0,
                className: L(
                  Ge["nav-block__item"],
                  Ge["nav-block__item--link"],
                  Ne(h.url, t) && Ge["nav-block__item--active"]
                ),
                onClick: l.onClick,
                children: h.text
              }
            ) }, h.url);
          })
        ]
      },
      l.url || u
    ) : null;
  }) });
}, Ae = {
  "main-navigation-item": "main-navigation-item",
  "main-navigation-item--active": "main-navigation-item--active",
  "main-navigation-item--open": "main-navigation-item--open",
  "main-navigation-item__submenu": "main-navigation-item__submenu",
  "main-navigation-item--separator": "main-navigation-item--separator",
  "main-navigation-item__button": "main-navigation-item__button",
  "main-navigation-item__link": "main-navigation-item__link"
}, yc = ({ link: e, currentPage: t }) => {
  const n = G(null), [i, r] = B(!1), { refs: s, floatingStyles: a, update: o } = Dr({
    placement: "bottom-start",
    middleware: [
      Lr({ mainAxis: 12, crossAxis: -16 }),
      Pr({
        crossAxis: !0,
        padding: 8,
        limiter: Il({ offset: 8 })
      })
    ],
    whileElementsMounted: Rr
  }), c = () => {
    r(!1), requestAnimationFrame(() => {
      var E;
      (E = n.current) == null || E.focus();
    });
  };
  Tt(c, i), Br(s.floating, i, c, s.domReference);
  const l = () => {
    requestAnimationFrame(() => o());
  }, u = () => {
    r((E) => !E);
  }, { nestedLinks: p, text: h, url: g } = e;
  if (!e.url)
    return /* @__PURE__ */ d(
      "li",
      {
        className: L(Ae["main-navigation-item"], Ae["main-navigation-item--separator"]),
        "aria-hidden": "true"
      }
    );
  const _ = Ne(g, t);
  if (!(p != null && p.length))
    return /* @__PURE__ */ d(
      "li",
      {
        className: L(
          Ae["main-navigation-item"],
          _ && Ae["main-navigation-item--active"],
          i && Ae["main-navigation-item--open"]
        ),
        children: /* @__PURE__ */ d(
          "a",
          {
            className: Ae["main-navigation-item__link"],
            href: g,
            "aria-current": _ ? "page" : void 0,
            onClick: e.onClick,
            children: h
          }
        )
      }
    );
  const b = _ || Gr(p, t);
  return /* @__PURE__ */ I(
    "li",
    {
      className: L(
        Ae["main-navigation-item"],
        i && Ae["main-navigation-item--open"],
        b && Ae["main-navigation-item--active"]
      ),
      children: [
        /* @__PURE__ */ d(
          "button",
          {
            ref: (E) => {
              s.setReference(E), n.current = E;
            },
            className: Ae["main-navigation-item__button"],
            "aria-expanded": i ? "true" : "false",
            "aria-controls": `submenu-${e.url}`,
            onClick: u,
            type: "button",
            children: h
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            id: `submenu-${e.url}`,
            ref: s.setFloating,
            style: a,
            className: Ae["main-navigation-item__submenu"],
            role: "region",
            "aria-label": `${h} submenu`,
            children: /* @__PURE__ */ d(bc, { root: e, currentPage: t, updateFlyoutPosition: l })
          }
        )
      ]
    }
  );
}, xc = {
  "main-navigation": "main-navigation"
}, Ec = ({ nav: e, primaryNavLabel: t, currentPage: n }) => /* @__PURE__ */ d("nav", { "aria-label": t, children: /* @__PURE__ */ d("ul", { className: xc["main-navigation"], children: e == null ? void 0 : e.map((i, r) => (
  // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
  /* @__PURE__ */ d(yc, { link: i, currentPage: n }, r)
)) }) }), Ue = {
  "language-switch-dropdown": "language-switch-dropdown",
  "language-switch-dropdown__chevron-icon": "language-switch-dropdown__chevron-icon",
  "language-switch-dropdown__open": "language-switch-dropdown__open",
  "language-switch-dropdown__list": "language-switch-dropdown__list",
  "language-switch-dropdown__button": "language-switch-dropdown__button",
  "language-switch-dropdown__list-item": "language-switch-dropdown__list-item",
  "language-switch-dropdown__link": "language-switch-dropdown__link",
  "language-switch-dropdown__link--selected": "language-switch-dropdown__link--selected"
}, gt = {
  "language-switch-inline": "language-switch-inline",
  "language-switch-inline__list": "language-switch-inline__list",
  "language-switch-inline__list-item": "language-switch-inline__list-item",
  "language-switch-inline__link": "language-switch-inline__link",
  "language-switch-inline__link--selected": "language-switch-inline__link--selected"
};
var An = /* @__PURE__ */ ((e) => (e.DROPDOWN = "dropdown", e.INLINE_LIST = "inline-list", e))(An || {});
const Ur = ({
  alternates: e,
  currentLocale: t,
  currentPage: n,
  translatedLocale: i,
  translatedAriaLabel: r,
  layout: s,
  onClick: a
}) => {
  const [o, c] = B(!1), l = G(null), u = G(null), p = G(null);
  Tt(() => c(!1), o), Br(l, o, () => c(!1), u);
  const h = (y) => {
    c((m) => {
      const f = !m;
      return l.current = f ? y.current : null, f;
    });
  }, g = (y) => {
    c(!0), l.current = y.current;
  }, _ = () => {
    c(!1), l.current = null;
  }, b = (y) => /* @__PURE__ */ d("div", { className: gt["language-switch-inline"], children: /* @__PURE__ */ d("ul", { className: gt["language-switch-inline__list"], children: y.map((m, f) => {
    const v = m.url === n;
    return i[m.locale] && // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
    /* @__PURE__ */ d("li", { className: gt["language-switch-inline__list-item"], children: v ? /* @__PURE__ */ d(
      "span",
      {
        className: L(
          gt["language-switch-inline__link"],
          v && gt["language-switch-inline__link--selected"]
        ),
        "aria-current": "page",
        "aria-disabled": !0,
        children: i[m.locale]
      }
    ) : /* @__PURE__ */ d(
      "a",
      {
        className: gt["language-switch-inline__link"],
        href: m.url,
        "aria-disabled": !1,
        onClick: () => a(m.locale, m.url),
        children: i[m.locale]
      }
    ) }, f);
  }) }) }), E = (y, m) => /* @__PURE__ */ I(
    "div",
    {
      className: L(
        Ue["language-switch-dropdown"],
        o && Ue["language-switch-dropdown__open"]
      ),
      children: [
        /* @__PURE__ */ I(
          "button",
          {
            ref: u,
            className: Ue["language-switch-dropdown__button"],
            id: "language-switch-button",
            "aria-expanded": o,
            "aria-controls": "language-switch-list",
            "aria-label": r,
            onClick: () => h(p),
            onMouseEnter: () => g(p),
            onMouseLeave: _,
            type: "button",
            children: [
              m.toUpperCase(),
              /* @__PURE__ */ d("span", { className: Ue["language-switch-dropdown__chevron-icon"], children: /* @__PURE__ */ d(F, { icon: "chevron-down", width: "18px" }) })
            ]
          }
        ),
        /* @__PURE__ */ d(
          "ul",
          {
            ref: p,
            className: Ue["language-switch-dropdown__list"],
            id: "language-switch-list",
            "aria-hidden": !o,
            onMouseEnter: () => g(p),
            onMouseLeave: _,
            inert: o ? null : "",
            children: y.map((f, v) => {
              const w = f.url === n;
              return i[f.locale] && // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
              /* @__PURE__ */ d("li", { className: Ue["language-switch-dropdown__list-item"], children: w ? /* @__PURE__ */ d(
                "span",
                {
                  className: L(
                    Ue["language-switch-dropdown__link"],
                    w && Ue["language-switch-dropdown__link--selected"]
                  ),
                  "aria-current": "page",
                  "aria-disabled": !0,
                  children: i[f.locale]
                }
              ) : /* @__PURE__ */ d(
                "a",
                {
                  href: f.url,
                  onClick: () => a(f.locale, f.url),
                  className: Ue["language-switch-dropdown__link"],
                  "aria-disabled": !1,
                  children: i[f.locale]
                }
              ) }, v);
            })
          }
        )
      ]
    }
  );
  return s === An.DROPDOWN ? E(e, t) : b(e);
}, pe = {
  "meta-navigation": "meta-navigation",
  "meta-navigation__items": "meta-navigation__items",
  "meta-navigation__item-icon": "meta-navigation__item-icon",
  "meta-navigation__item": "meta-navigation__item",
  "meta-navigation__item--icon": "meta-navigation__item--icon",
  "meta-navigation__item--active": "meta-navigation__item--active",
  "meta-navigation__item-link": "meta-navigation__item-link",
  "meta-navigation__separator": "meta-navigation__separator"
}, Sc = ({
  nav: e,
  secondaryNavLabel: t,
  searchLink: n,
  worldWideLink: i,
  currentPage: r,
  languageSwitchConfig: s
}) => {
  const a = ((s == null ? void 0 : s.alternates) ?? []).length > 0, o = !!(a || i || n), c = () => i != null && i.url ? /* @__PURE__ */ d(
    "a",
    {
      href: i.url,
      className: L(pe["meta-navigation__item"], pe["meta-navigation__item--icon"]),
      onClick: i.onClick,
      "aria-label": i.label,
      children: l()
    }
  ) : /* @__PURE__ */ d(
    "button",
    {
      className: L(pe["meta-navigation__item"], pe["meta-navigation__item--icon"]),
      type: "button",
      onClick: i == null ? void 0 : i.onClick,
      "aria-label": i == null ? void 0 : i.label,
      children: l()
    }
  ), l = () => /* @__PURE__ */ d("span", { className: pe["meta-navigation__item-icon"], children: /* @__PURE__ */ d(F, { icon: "globe", height: "20px", decorative: !0 }) });
  return /* @__PURE__ */ I("nav", { className: pe["meta-navigation"], "aria-label": t, children: [
    /* @__PURE__ */ d("ul", { className: pe["meta-navigation__items"], children: e == null ? void 0 : e.map((u, p) => /* @__PURE__ */ d(
      "li",
      {
        className: L(
          pe["meta-navigation__item"],
          Ne(u.url, r) && pe["meta-navigation__item--active"]
        ),
        children: /* @__PURE__ */ d(
          "a",
          {
            className: pe["meta-navigation__item-link"],
            href: u.url,
            onClick: u.onClick,
            "aria-current": Ne(u.url, r) ? "page" : void 0,
            children: u.text ?? ""
          }
        )
      },
      p
    )) }),
    o && /* @__PURE__ */ d("div", { className: pe["meta-navigation__separator"] }),
    a && s && /* @__PURE__ */ d(
      Ur,
      {
        currentLocale: s.currentLocale,
        currentPage: r,
        alternates: s.alternates,
        translatedLocale: s.translations.translatedLocale,
        translatedAriaLabel: s.translations.translatedAriaLabel,
        layout: An.DROPDOWN,
        onClick: s.handleClickTracking
      }
    ),
    i && c(),
    (n == null ? void 0 : n.url) && /* @__PURE__ */ d(
      "a",
      {
        className: L(
          pe["meta-navigation__item"],
          pe["meta-navigation__item--icon"],
          Ne(n == null ? void 0 : n.url, r) && pe["meta-navigation__item--active"]
        ),
        href: n.url,
        onClick: n == null ? void 0 : n.onClick,
        "aria-label": n == null ? void 0 : n.label,
        "aria-current": Ne(n.url, r) ? "page" : void 0,
        children: /* @__PURE__ */ d("span", { className: pe["meta-navigation__item-icon"], children: /* @__PURE__ */ d(F, { icon: "search", height: "20px", decorative: !0 }) })
      }
    )
  ] });
}, qr = () => {
  const [e, t] = B(!1);
  return U(() => {
    const n = window.matchMedia("(prefers-reduced-motion: reduce)");
    t(n.matches);
    const i = () => {
      t(n.matches);
    };
    return n.addEventListener("change", i), () => n.removeEventListener("change", i);
  }, []), e;
}, Tc = (e) => {
  const [t, n] = B(!1), i = Te(() => {
    const s = e.current;
    if (!s)
      return;
    s.style.overflow = "hidden", s.style.transition = "none", s.style.maxHeight = "0px", s.style.opacity = "0", n(!0);
    const a = s.scrollHeight;
    requestAnimationFrame(() => {
      s.style.transition = "max-height 300ms cubic-bezier(0.4, 0, 0.2, 1), opacity 300ms ease-out", s.style.maxHeight = `${a}px`, s.style.opacity = "1";
      const o = (c) => {
        c.propertyName === "max-height" && (s.style.maxHeight = "none", s.style.overflow = "visible", s.removeEventListener("transitionend", o), n(!1));
      };
      s.addEventListener("transitionend", o);
    });
  }, [e]), r = Te(() => {
    const s = e.current;
    if (!s)
      return;
    const a = s.scrollHeight;
    s.style.maxHeight = `${a}px`, s.style.overflow = "hidden", s.style.transition = "max-height 300ms cubic-bezier(0.4, 0, 0.2, 1), opacity 300ms ease-out", s.style.opacity = "1", requestAnimationFrame(() => {
      s.style.maxHeight = "0px", s.style.opacity = "0";
      const o = (c) => {
        c.propertyName === "max-height" && (s.removeEventListener("transitionend", o), n(!1));
      };
      s.addEventListener("transitionend", o);
    });
  }, [e]);
  return { show: i, hide: r, isAnimating: t };
}, ge = {
  "mobile-navigation-block": "mobile-navigation-block",
  "mobile-navigation-block__chevron": "mobile-navigation-block__chevron",
  "mobile-navigation-block--open": "mobile-navigation-block--open",
  "mobile-navigation-block__button": "mobile-navigation-block__button",
  "mobile-navigation-block__submenu-list": "mobile-navigation-block__submenu-list",
  "mobile-navigation-block--active": "mobile-navigation-block--active",
  "mobile-navigation-block__link": "mobile-navigation-block__link",
  "mobile-navigation-block__submenu-list--depth-1": "mobile-navigation-block__submenu-list--depth-1",
  "mobile-navigation-block__submenu-list--depth-2": "mobile-navigation-block__submenu-list--depth-2",
  "mobile-navigation-block__submenu-list--depth-3": "mobile-navigation-block__submenu-list--depth-3",
  "mobile-navigation-block__submenu-item": "mobile-navigation-block__submenu-item",
  "mobile-navigation-block__submenu-item--active": "mobile-navigation-block__submenu-item--active",
  "mobile-navigation-block__submenu-item-title": "mobile-navigation-block__submenu-item-title",
  "mobile-navigation-block__submenu-item-title--active": "mobile-navigation-block__submenu-item-title--active",
  "mobile-navigation-block__submenu-item-arrow": "mobile-navigation-block__submenu-item-arrow",
  "mobile-navigation-block__submenu-item-link": "mobile-navigation-block__submenu-item-link"
}, ii = ({
  id: e,
  link: t,
  depth: n,
  expanded: i,
  onToggle: r,
  isNavOpen: s,
  currentPage: a
}) => {
  const { nestedLinks: o, text: c, url: l } = t, u = !!(o != null && o.length), p = i.has(e), h = G(null), { show: g, hide: _ } = Tc(h);
  U(() => {
    h.current && (p ? g() : _());
  }, [p, g, _]);
  const b = hi(() => `mobile-nav-panel-${e}`, [e]);
  if (!l && !u)
    return null;
  const y = Ne(l, a);
  return u ? /* @__PURE__ */ I("li", { className: L(ge["mobile-navigation-block"], p && ge["mobile-navigation-block--open"]), children: [
    /* @__PURE__ */ I(
      "button",
      {
        type: "button",
        className: ge["mobile-navigation-block__button"],
        onClick: () => r(e),
        "aria-controls": b,
        "aria-expanded": p,
        children: [
          c,
          /* @__PURE__ */ d("span", { className: ge["mobile-navigation-block__chevron"], children: /* @__PURE__ */ d(F, { icon: "chevron-down", height: "24px", decorative: !0 }) })
        ]
      }
    ),
    /* @__PURE__ */ I(
      "ul",
      {
        id: b,
        ref: h,
        className: L(
          ge["mobile-navigation-block__submenu-list"],
          n > 0 && ge[`mobile-navigation-block__submenu-list--depth-${n}`]
        ),
        children: [
          l && /* @__PURE__ */ d(
            "li",
            {
              className: L(
                ge["mobile-navigation-block__submenu-item-title"],
                y && ge["mobile-navigation-block__submenu-item-title--active"]
              ),
              children: /* @__PURE__ */ I(
                "a",
                {
                  className: ge["mobile-navigation-block__submenu-item-link"],
                  href: l,
                  onClick: t.onClick,
                  "aria-label": c,
                  "aria-current": Ne(l, a) ? "page" : void 0,
                  children: [
                    c,
                    /* @__PURE__ */ d("span", { className: ge["mobile-navigation-block__submenu-item-arrow"], children: /* @__PURE__ */ d(F, { icon: "arrow-right", height: "24px", decorative: !0 }) })
                  ]
                }
              )
            }
          ),
          o == null ? void 0 : o.map((m, f) => /* @__PURE__ */ d(
            ii,
            {
              id: `${e}-${f}`,
              link: m,
              depth: n + 1,
              expanded: i,
              onToggle: r,
              isNavOpen: s,
              currentPage: a
            },
            `${e}-${f + 1}`
          ))
        ]
      }
    )
  ] }) : /* @__PURE__ */ d("li", { className: L(ge["mobile-navigation-block"], y && ge["mobile-navigation-block--active"]), children: /* @__PURE__ */ d(
    "a",
    {
      className: ge["mobile-navigation-block__link"],
      href: l,
      onClick: t.onClick,
      "aria-current": y ? "page" : void 0,
      children: c
    }
  ) });
}, ke = {
  "mobile-navigation": "mobile-navigation",
  "mobile-navigation__overlay": "mobile-navigation__overlay",
  "mobile-navigation__overlay--open": "mobile-navigation__overlay--open",
  "mobile-navigation__overlay--closing": "mobile-navigation__overlay--closing",
  "mobile-navigation__header": "mobile-navigation__header",
  "mobile-navigation__close-button": "mobile-navigation__close-button",
  "mobile-navigation__list": "mobile-navigation__list",
  "mobile-navigation__list--primary": "mobile-navigation__list--primary",
  "mobile-navigation__meta-nav": "mobile-navigation__meta-nav"
}, Nc = ({
  primaryNav: e,
  secondaryNav: t,
  closeNavLabel: n,
  currentPage: i,
  isNavOpen: r,
  setIsNavOpen: s,
  languageSwitchConfig: a
}) => {
  var f;
  const o = G(null), c = G(null), [l, u] = B(!1), [p, h] = B(/* @__PURE__ */ new Set()), g = qr();
  U(() => {
    const w = Fr(e ?? [], i);
    w && h(() => {
      const T = /* @__PURE__ */ new Set();
      for (let N = 1; N <= w.length; N++)
        T.add(gc(w.slice(0, N)));
      return T;
    });
  }, [i, e]), U(() => {
    var w;
    const v = c.current;
    if (v) {
      if (r) {
        v.showModal(), (w = o.current) == null || w.focus();
        return;
      }
      if (g) {
        v.close();
        return;
      }
      v.open && u(!0);
    }
  }, [r, g]);
  const _ = () => {
    s(!1);
  }, b = (v) => {
    var w;
    v.target === c.current && l && v.propertyName === "transform" && (u(!1), (w = c.current) == null || w.close());
  }, E = (v) => {
    h((w) => {
      const T = new Set(w), N = ni(v).length, A = ji(v);
      for (const R of Array.from(T)) {
        const S = ni(R).length === N, k = A === ji(R);
        S && k && R !== v && Xi(T, R);
      }
      return T.has(v) ? Xi(T, v) : T.add(v), T;
    });
  }, y = L(
    ke["mobile-navigation__overlay"],
    r && ke["mobile-navigation__overlay--open"],
    l && ke["mobile-navigation__overlay--closing"]
  ), m = ((f = (a == null ? void 0 : a.alternates) ?? []) == null ? void 0 : f.length) > 0;
  return /* @__PURE__ */ d("nav", { className: ke["mobile-navigation"], children: /* @__PURE__ */ I(
    "dialog",
    {
      className: y,
      onClose: () => s(!1),
      id: "mobile-navigation",
      ref: c,
      inert: r ? null : "",
      onTransitionEnd: b,
      children: [
        /* @__PURE__ */ d("header", { className: ke["mobile-navigation__header"], children: /* @__PURE__ */ d(
          "button",
          {
            className: ke["mobile-navigation__close-button"],
            onClick: _,
            ref: o,
            "aria-label": n,
            "aria-controls": "mobile-navigation",
            type: "button",
            children: /* @__PURE__ */ d(F, { icon: "mobile-close", height: "32px", decorative: !0 })
          }
        ) }),
        /* @__PURE__ */ d("ul", { className: L(ke["mobile-navigation__list"], ke["mobile-navigation__list--primary"]), children: e == null ? void 0 : e.map((v, w) => /* @__PURE__ */ d(
          ii,
          {
            id: `${w}`,
            link: v,
            depth: 1,
            expanded: p,
            onToggle: E,
            isNavOpen: r,
            currentPage: i
          },
          `p-${w}`
        )) }),
        /* @__PURE__ */ d("ul", { className: ke["mobile-navigation__list"], children: t == null ? void 0 : t.map((v, w) => /* @__PURE__ */ d(
          ii,
          {
            id: `s-${w}`,
            link: v,
            depth: 1,
            expanded: p,
            onToggle: E,
            isNavOpen: r,
            currentPage: i
          },
          `s-${w}`
        )) }),
        a && m && /* @__PURE__ */ d("div", { className: ke["mobile-navigation__meta-nav"], children: /* @__PURE__ */ d(
          Ur,
          {
            alternates: a.alternates,
            currentLocale: a.currentLocale,
            currentPage: i,
            translatedLocale: a.translations.translatedLocale,
            translatedAriaLabel: a.translations.translatedAriaLabel,
            layout: An.INLINE_LIST,
            onClick: a.handleClickTracking
          }
        ) })
      ]
    }
  ) });
}, Cc = "header", Ac = "header__logo", Mc = "header__actions", Ic = "header__worldwide", Rc = "header__search", kc = "header__burger", Q = {
  header: Cc,
  "header__skip-link": "header__skip-link",
  "header__first-row": "header__first-row",
  "header__second-row": "header__second-row",
  header__logo: Ac,
  "header__logo-mobile": "header__logo-mobile",
  "header__logo-link": "header__logo-link",
  header__actions: Mc,
  header__worldwide: Ic,
  header__search: Rc,
  "header__search--active": "header__search--active",
  "header__search-icon": "header__search-icon",
  header__burger: kc,
  "header__worldwide-icon": "header__worldwide-icon",
  "header__burger-icon": "header__burger-icon",
  "header__mobile-nav": "header__mobile-nav",
  "header__secondary-nav": "header__secondary-nav",
  "header--scrolled": "header--scrolled",
  "header--transparent": "header--transparent",
  "header--hidden": "header--hidden"
}, Lc = 100, Bh = ({
  homeLink: e,
  searchLink: t,
  worldWideLink: n,
  openNavLabel: i,
  closeNavLabel: r,
  currentPage: s,
  isFixed: a,
  primaryNav: o,
  secondaryNav: c,
  primaryNavLabel: l,
  secondaryNavLabel: u,
  skipToContentLabel: p,
  languageSwitchConfig: h
}) => {
  const [g, _] = B(!1);
  En(g);
  const b = () => {
    _(!g);
  }, E = Hr(), y = mc(), m = E > 0, f = E < Lc, v = !a && !f && y === "down", w = !m, T = L(
    Q.header,
    a && Q["header--fixed"],
    m && Q["header--scrolled"],
    w && Q["header--transparent"],
    v && Q["header--hidden"]
  ), N = s === (t == null ? void 0 : t.url), A = () => n != null && n.url ? /* @__PURE__ */ d(
    "a",
    {
      href: n.url,
      className: Q.header__worldwide,
      onClick: n.onClick,
      "aria-label": n.label,
      children: R()
    }
  ) : /* @__PURE__ */ d(
    "button",
    {
      className: Q.header__worldwide,
      type: "button",
      onClick: n == null ? void 0 : n.onClick,
      "aria-label": n == null ? void 0 : n.label,
      children: R()
    }
  ), R = () => /* @__PURE__ */ d("span", { className: Q["header__worldwide-icon"], children: /* @__PURE__ */ d(F, { icon: "globe-mobile", height: "32px", width: "32px", decorative: !0 }) });
  return /* @__PURE__ */ I("header", { className: T, children: [
    /* @__PURE__ */ d("a", { className: Q["header__skip-link"], href: "#main-content", children: p }),
    /* @__PURE__ */ I("div", { className: Q["header__first-row"], children: [
      /* @__PURE__ */ I(
        "a",
        {
          className: Q["header__logo-link"],
          href: (e == null ? void 0 : e.url) ?? "/",
          "aria-label": e == null ? void 0 : e.label,
          onClick: e == null ? void 0 : e.onClick,
          children: [
            /* @__PURE__ */ d("span", { className: Q.header__logo, children: /* @__PURE__ */ d(F, { icon: "logo", height: "40px", decorative: !0 }) }),
            /* @__PURE__ */ d("span", { className: Q["header__logo-mobile"], children: /* @__PURE__ */ d(F, { icon: "logo", height: "30px", decorative: !0 }) })
          ]
        }
      ),
      /* @__PURE__ */ d("div", { className: Q["header__secondary-nav"], children: /* @__PURE__ */ d(
        Sc,
        {
          nav: c,
          secondaryNavLabel: u,
          worldWideLink: n,
          searchLink: t,
          currentPage: s,
          languageSwitchConfig: h
        }
      ) }),
      /* @__PURE__ */ I("div", { className: Q.header__actions, children: [
        n && A(),
        /* @__PURE__ */ d(
          "a",
          {
            href: t == null ? void 0 : t.url,
            className: L(Q.header__search, N && Q["header__search--active"]),
            "aria-label": t == null ? void 0 : t.label,
            "aria-current": N ? "page" : void 0,
            onClick: t == null ? void 0 : t.onClick,
            children: /* @__PURE__ */ d("span", { className: Q["header__search-icon"], children: /* @__PURE__ */ d(F, { icon: "search-mobile", height: "32px", decorative: !0 }) })
          }
        ),
        /* @__PURE__ */ d(
          "button",
          {
            className: Q.header__burger,
            onClick: b,
            "aria-label": i,
            "aria-controls": "mobile-navigation",
            "aria-expanded": g,
            type: "button",
            children: /* @__PURE__ */ d("span", { className: Q["header__burger-icon"], children: /* @__PURE__ */ d(F, { icon: "mobile-menu", height: "32px", decorative: !0 }) })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ d("div", { className: Q["header__second-row"], children: /* @__PURE__ */ d(Ec, { nav: o, primaryNavLabel: l, currentPage: s }) }),
    /* @__PURE__ */ d("div", { className: Q["header__mobile-nav"], children: /* @__PURE__ */ d(
      Nc,
      {
        primaryNav: o,
        secondaryNav: c,
        closeNavLabel: r,
        currentPage: s,
        isNavOpen: g,
        setIsNavOpen: _,
        languageSwitchConfig: h
      }
    ) })
  ] });
}, Ei = (e) => typeof e == "string" ? e.trim() : "", Si = (e) => {
  const [t, n] = B(!1);
  return U(() => {
    const i = () => {
      n(window.innerWidth < e);
    };
    return i(), window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, [e]), t;
}, Pc = (e) => {
  const [t, n] = B({ width: 0, height: 0 });
  return U(() => {
    const i = new ResizeObserver((r) => {
      for (const s of r) {
        const { width: a, height: o } = s.contentRect;
        n({
          width: Math.round(a),
          height: Math.round(o)
        });
      }
    });
    return e.current && i.observe(e.current), () => {
      e.current && i.unobserve(e.current);
    };
  }, []), t;
}, Oc = "image", Dc = "image__img", Vc = "image__container", $c = "image__description", zc = "image__caption", Hc = "image__copyright", he = {
  image: Oc,
  image__img: Dc,
  image__container: Vc,
  "image--fullscreen": "image--fullscreen",
  "image--bleed": "image--bleed",
  "image--original": "image--original",
  "image--contain": "image--contain",
  "image--top": "image--top",
  "image--center": "image--center",
  "image--bottom": "image--bottom",
  "image--full-height": "image--full-height",
  image__description: $c,
  image__caption: zc,
  image__copyright: Hc,
  "image__img--ratio-hd": "image__img--ratio-hd",
  "image__img--ratio-wide": "image__img--ratio-wide",
  "image__img--ratio-square": "image__img--ratio-square",
  "image__img--ratio-vertical": "image__img--ratio-vertical",
  "image__img--ratio-normal": "image__img--ratio-normal",
  "image__img--ratio-sixtofive": "image__img--ratio-sixtofive"
};
var oe = /* @__PURE__ */ ((e) => (e.HD = "16:9", e.WIDE = "2.39:1", e.SQUARE = "1:1", e.VERTICAL = "4:5", e.ORIGINAL = "original", e.NORMAL = "4:3", e.SIXTOFIVE = "6:5", e))(oe || {}), Bc = /* @__PURE__ */ ((e) => (e.LAZY = "lazy", e.EAGER = "eager", e))(Bc || {}), ct = /* @__PURE__ */ ((e) => (e.TOP = "top", e.CENTER = "center", e.BOTTOM = "bottom", e))(ct || {}), Mn = /* @__PURE__ */ ((e) => (e.COVER = "cover", e.CONTAIN = "contain", e))(Mn || {});
const Fc = [1, 1.5, 2, 3], Gc = (e) => {
  const t = Object.values(oe).includes(e) ? e : oe.HD;
  if (t === oe.ORIGINAL)
    return null;
  const [n, i] = t.split(":").map(parseFloat);
  return n / i;
}, Zi = (e, t, n, i) => {
  const r = Gc(n);
  let s = 0;
  return i ? s = i : r && (s = Math.round(t / r)), e.replace(/\$0/g, `${t}`).replace(/\$1/g, `${s}`);
}, Uc = (e) => e.includes("$0"), qc = (e) => {
  var t;
  return ((t = Object.entries(oe).find(([, n]) => n === e)) == null ? void 0 : t[0].toLowerCase()) || null;
}, Wc = (e) => Object.values(ct).includes(e) ? e : ct.CENTER, Yc = 300, In = ({
  src: e,
  alt: t,
  slot: n,
  caption: i = void 0,
  copyright: r = void 0,
  ratio: s = oe.HD,
  position: a = ct.CENTER,
  fullscreen: o = !1,
  showCaption: c = !1,
  showCopyright: l = !1,
  bleed: u = !1,
  forceHeight: p = void 0,
  loading: h = "lazy",
  imageFit: g
}) => {
  const _ = Zi(e, ne.SMALL, s, p), [{ fallbackSrc: b, width: E, srcSet: y }, m] = B({
    fallbackSrc: _,
    width: ne.SMALL,
    srcSet: ""
  }), f = G(null), v = Pc(f), w = qc(s), T = L({
    [he.image__img]: !0,
    [he[`image__img--ratio-${w}`]]: s !== oe.ORIGINAL && w
  });
  U(() => {
    if (!Uc(e))
      return;
    const R = setTimeout(() => {
      const S = window.devicePixelRatio || 1;
      if (v.width) {
        const k = Fc.map((P) => {
          const D = Math.round(v.width * S);
          return `${Zi(e, D, s, p)} ${P}x`;
        }).join(", ");
        m({ fallbackSrc: b, width: v.width, srcSet: k });
      }
    }, Yc);
    return () => clearTimeout(R);
  }, [v, b, e, s, p]);
  const N = Wc(a), A = L({
    [he.image]: !0,
    [he["image--fullscreen"]]: o,
    [he["image--bleed"]]: u,
    [he["image--top"]]: N === ct.TOP,
    [he["image--center"]]: N === ct.CENTER,
    [he["image--bottom"]]: N === ct.BOTTOM,
    [he["image--original"]]: s === oe.ORIGINAL,
    [he["image--full-height"]]: p !== void 0,
    [he["image--contain"]]: g === Mn.CONTAIN
  });
  return /* @__PURE__ */ I("figure", { className: A, slot: n, "data-ratio": s, children: [
    /* @__PURE__ */ d("div", { className: he.image__container, ref: f, children: /* @__PURE__ */ d(
      "img",
      {
        className: T,
        src: b,
        srcSet: y,
        sizes: `${E}px`,
        alt: t,
        title: i,
        loading: h
      }
    ) }),
    (c && i || l && r) && /* @__PURE__ */ I("div", { className: he.image__description, children: [
      c && i && /* @__PURE__ */ d("figcaption", { className: he.image__caption, children: i }),
      l && r && /* @__PURE__ */ I("div", { className: he.image__copyright, children: [
        "© ",
        r
      ] })
    ] })
  ] });
}, X = {
  "video-player": "video-player",
  "video-player__service--youtube": "video-player__service--youtube",
  "video-player__service--aws-video-js": "video-player__service--aws-video-js",
  "video-player__content--absolute": "video-player__content--absolute",
  "video-player__content--absolute-active": "video-player__content--absolute-active",
  "video-player__content--relative": "video-player__content--relative",
  "video-player__content--relative-fullscreen": "video-player__content--relative-fullscreen",
  "video-player__content--relative-ready": "video-player__content--relative-ready",
  "video-player__overlay": "video-player__overlay",
  "video-player__overlay-icon": "video-player__overlay-icon",
  "video-player__overlay-videoloop": "video-player__overlay-videoloop",
  "video-player__overlay--hidden": "video-player__overlay--hidden",
  "video-player__close-button": "video-player__close-button",
  "video-player--fullscreen": "video-player--fullscreen",
  "video-player__image": "video-player__image",
  "video-player__image--hidden": "video-player__image--hidden",
  "video-player__image--fullscreen": "video-player__image--fullscreen",
  "video-player__image--fullscreen-playing": "video-player__image--fullscreen-playing",
  "video-player__image--error": "video-player__image--error",
  "video-player__placeholder": "video-player__placeholder",
  "video-player__placeholder--fullscreen": "video-player__placeholder--fullscreen",
  "video-description": "video-description",
  "video-description__caption": "video-description__caption",
  "video-description__copyright": "video-description__copyright"
}, jc = 64, Xc = 80, Zc = 24, Wr = ({
  onPlay: e,
  onPause: t,
  fullscreen: n,
  isPlaying: i,
  videoloop: r,
  videoTitle: s,
  pauseLabel: a,
  playLabel: o
}) => {
  const c = Si(ne.MEDIUM), l = `${Ie(c ? jc : Xc)}rem`, u = `${Ie(Zc)}rem`, p = L(X["video-player__overlay"], X["video-player__overlay-videoloop"]), h = L(
    X["video-player__overlay"],
    i && X["video-player__overlay--hidden"]
  ), g = r ? p : h, _ = i ? "pause" : "play", b = i ? a : o, E = (m) => {
    m.preventDefault(), i && t ? t() : e();
  }, y = (m, f) => f ? `${m} ${f}` : m;
  return i && n ? /* @__PURE__ */ d("button", { className: X["video-player__close-button"], onClick: E, type: "button", children: /* @__PURE__ */ d(F, { icon: "close", height: u }) }) : /* @__PURE__ */ d("div", { className: g, children: /* @__PURE__ */ d(
    "button",
    {
      onClick: E,
      className: X["video-player__overlay-icon"],
      "aria-label": y(b, s),
      type: "button",
      children: /* @__PURE__ */ d(F, { icon: _, height: l })
    }
  ) });
}, Yr = ({
  isPlaying: e,
  fullscreen: t,
  preview: n,
  previewAlt: i,
  error: r
}) => {
  const s = L(
    X["video-player__image"],
    t && X["video-player__image--fullscreen"],
    t && e && X["video-player__image--fullscreen-playing"],
    e && !t && X["video-player__image--hidden"]
  ), a = L(X["video-player__image"], X["video-player__image--error"]);
  return /* @__PURE__ */ d("div", { className: r ? a : s, "aria-hidden": !0, children: /* @__PURE__ */ d(
    In,
    {
      src: n,
      alt: i,
      ratio: t ? oe.WIDE : oe.HD,
      fullscreen: t
    }
  ) });
}, jt = {
  "aws-player": "aws-player",
  "aws-player__controls--hidden": "aws-player__controls--hidden",
  "aws-player--fullscreen-videoloop": "aws-player--fullscreen-videoloop",
  "aws-player--fullscreen": "aws-player--fullscreen"
}, Kc = (e) => {
  const t = e.currentTime(), n = e.duration();
  return t && n ? Math.round(t / n * 100) : null;
}, Qc = ({
  awsServiceBaseUrl: e,
  options: t,
  fullscreen: n,
  videoLoop: i,
  preview: r,
  previewAlt: s,
  pauseLabel: a,
  playLabel: o,
  caption: c,
  videoId: l,
  onVideoStateChange: u
}) => {
  const p = G(null), h = G(null), g = n && !i, _ = n && i, [b, E] = B(!1), [y, m] = B(!1), [f, v] = B(!1), w = y && f, T = G(!1), N = G(!1), A = (O) => {
    var C;
    return {
      videoId: l,
      videoTitle: c ?? "",
      videoType: "aws",
      videoDurationTotal: O.duration() ?? 0,
      videoPercentageViewed: Kc(O) ?? 0,
      videoUrl: ((C = t.sources) == null ? void 0 : C[0].src) ?? "unknown videoUrl"
    };
  }, R = `${e}${l}`;
  U(() => {
    y && fetch(`${R}/meta.json`).then((O) => O.json()).then((O) => {
      var C;
      h.current ? (C = O.meta.video.text_tracks) == null || C.forEach((M) => {
        var $;
        ($ = h.current) == null || $.addRemoteTextTrack({
          ...M,
          src: `${R}${M.src}`
        });
      }) : console.error("AWS video player: Player not properly initialized");
    }).catch((O) => {
      console.error("AWS video player: Error fetching meta data", O);
    });
  }, [y]), U(() => {
    var O;
    if (h.current) {
      const C = h.current;
      C.autoplay(t.autoplay), C.src(t.sources);
    } else {
      const C = document.createElement("video-js");
      (O = p.current) == null || O.appendChild(C);
      const M = h.current = ps(C, t, () => {
      });
      M.on("ready", () => {
        m(!0);
      }), M.on("loadedmetadata", () => {
        v(!0);
      }), M.on("seeking", () => {
        N.current = !0;
      }), M.on("seeked", () => {
        T.current = !0;
      }), M.on("play", () => {
        E(!0), T.current ? T.current = !1 : u({
          type: "playing",
          base: { ...A(M) },
          trackingValue: "play"
        });
      }), M.on("pause", () => {
        N.current ? N.current = !1 : u({
          type: "pause",
          base: { ...A(M) },
          trackingValue: "pause"
        });
      }), M.on("ended", () => {
        u({
          type: "ended",
          base: { ...A(M) },
          trackingValue: "end"
        });
      }), M.on("timeupdate", () => {
        u({
          type: "timeupdate",
          base: { ...A(M) },
          trackingValue: "timeupdate"
        });
      }), M.on("error", ($) => {
        var ie, H, W;
        const q = ((W = (H = (ie = $ == null ? void 0 : $.target) == null ? void 0 : ie.player) == null ? void 0 : H.error_) == null ? void 0 : W.code) || "VIDEOJS_UNKNOWN_ERROR";
        u({
          type: "error",
          base: { ...A(M) },
          trackingValue: "videoError",
          errorCode: q
        }), console.error(q);
      });
    }
    return () => {
      const C = h.current;
      C && !C.isDisposed() && (C.dispose(), h.current = null);
    };
  }, []);
  const S = async () => {
    if (h.current && y)
      try {
        await h.current.play();
      } catch (O) {
        console.error("VideoJS (AWS) play failed:", O), E(!1);
      }
  }, k = () => {
    E(!1), h.current && h.current.pause();
  }, P = L(
    jt["aws-player"],
    i && jt["aws-player__controls--hidden"],
    g && jt["aws-player--fullscreen"],
    _ && jt["aws-player--fullscreen-videoloop"]
  ), D = L(
    X["video-player__content--relative"],
    n && X["video-player__content--relative-fullscreen"],
    w && X["video-player__content--relative-ready"]
  ), V = L(
    X["video-player__content--absolute"],
    y && b && X["video-player__content--absolute-active"]
  ), z = i ? D : V;
  return /* @__PURE__ */ I("div", { className: X["video-player__service--aws-video-js"], children: [
    !i && r && /* @__PURE__ */ d(
      Yr,
      {
        preview: r,
        previewAlt: s,
        isPlaying: b,
        fullscreen: n,
        error: !1
      }
    ),
    /* @__PURE__ */ d("div", { className: z, children: /* @__PURE__ */ d("div", { className: P, "data-vjs-player": !0, children: /* @__PURE__ */ d("div", { ref: p }) }) }),
    /* @__PURE__ */ d(
      Wr,
      {
        onPlay: S,
        onPause: k,
        isPlaying: b,
        pauseLabel: a,
        playLabel: o,
        videoTitle: c,
        videoloop: i,
        fullscreen: g
      }
    )
  ] });
}, Ki = "youtube-iframe-api-script", Jc = "https://www.youtube.com/iframe_api";
let Xt = null, It = null;
const ed = () => (Xt || (Xt = new Promise((e) => {
  if (It = e, document.getElementById(Ki))
    if (typeof window.YT < "u" && window.YT.Player) {
      e(!0);
      return;
    } else {
      window.onYouTubeIframeAPIReady = () => {
        e(!0);
      };
      return;
    }
  const t = document.createElement("script");
  t.id = Ki, t.src = Jc, t.async = !0, window.onYouTubeIframeAPIReady = () => {
    It && It(!0);
  }, t.onerror = () => {
    It && It(!1), Xt = null;
  }, document.head.appendChild(t);
})), Xt);
function td() {
  const [e, t] = B(!1);
  return U(() => {
    let n = !0;
    return ed().then((i) => {
      n && t(i);
    }), () => {
      n = !1;
    };
  }, []), e;
}
const nd = (e) => {
  const t = Math.round(e.getCurrentTime()), n = Math.round(e.getDuration());
  return Math.round(t / n * 100);
}, id = 1e3, rd = ({
  videoId: e,
  fullscreen: t,
  preview: n,
  previewAlt: i,
  pauseLabel: r,
  playLabel: s,
  onVideoStateChange: a
}) => {
  const o = td(), c = `yt-video-${e}`, l = G(null), u = G(null), [p, h] = B(!1), [g, _] = B(!1), [b, E] = B(""), y = G(), m = (S) => {
    const k = document.getElementById(c);
    k && (k.style.width = S ? "auto" : "100%", k.style.height = S ? "90% " : "auto", k.style.aspectRatio = "16 / 9", k.style.display = "none");
  }, f = () => {
    const S = document.getElementById(c);
    S && (S.style.display = "inline");
  }, v = (S) => ({
    videoId: e,
    videoTitle: S.getVideoData().title,
    videoType: "youtube",
    videoDurationTotal: S.getDuration(),
    videoPercentageViewed: nd(S),
    videoUrl: S.getVideoUrl()
  }), w = (S) => {
    switch (S.data) {
      case YT.PlayerState.PLAYING:
        T(), y.current = setInterval(
          () => N(S.target),
          id
        ), a({
          type: "playing",
          base: { ...v(S.target) },
          trackingValue: "play"
        });
        break;
      case YT.PlayerState.ENDED:
        T(), a({
          type: "ended",
          base: { ...v(S.target) },
          trackingValue: "end"
        });
        break;
      case YT.PlayerState.PAUSED:
        T(), N(S.target), a({
          type: "pause",
          base: { ...v(S.target) },
          trackingValue: "pause"
        });
        break;
      default:
        T();
    }
  }, T = () => {
    clearInterval(y.current);
  }, N = (S) => {
    a({
      type: "timeupdate",
      base: { ...v(S) },
      trackingValue: "timeupdate"
    });
  };
  U(() => {
    if (o && u.current && !l.current && e && typeof YT < "u" && YT.Player)
      try {
        l.current = new YT.Player(u.current, {
          videoId: e,
          playerVars: {
            autoplay: 0,
            controls: 1
          },
          host: "https://www.youtube-nocookie.com",
          events: {
            onReady: (S) => {
              h(!0), m(t), E(S.target.getVideoData().title);
            },
            onStateChange: w,
            onError: (S) => {
              const k = (S == null ? void 0 : S.data) || "YOUTUBE_UNKNOWN_ERROR";
              a({
                type: "error",
                base: { ...v(S.target) },
                trackingValue: "videoError",
                errorCode: k
              });
            }
          }
        });
      } catch (S) {
        console.error(`Failed to create YouTube Player with videoId: ${e} - Error: ${S.message}`);
      }
  }, [o, e, t]);
  const A = () => {
    _(!0), o && l.current && p && (f(), l.current.playVideo());
  }, R = () => {
    _(!1), o && l.current && p && l.current.pauseVideo();
  };
  return /* @__PURE__ */ I("div", { className: X["video-player__service--youtube"], children: [
    n && /* @__PURE__ */ d(
      Yr,
      {
        preview: n,
        previewAlt: i,
        isPlaying: g,
        fullscreen: t,
        error: g && !e
      }
    ),
    /* @__PURE__ */ d(
      "div",
      {
        className: L(
          X["video-player__content--absolute"],
          g && X["video-player__content--absolute-active"]
        ),
        children: /* @__PURE__ */ d("div", { id: c, ref: u })
      }
    ),
    /* @__PURE__ */ d(
      Wr,
      {
        onPlay: A,
        onPause: R,
        isPlaying: g,
        pauseLabel: r,
        playLabel: s,
        videoTitle: b,
        fullscreen: t
      }
    )
  ] });
}, Ti = ({
  awsServiceBaseUrl: e,
  service: t,
  fullscreen: n,
  videoLoop: i,
  caption: r,
  copyright: s,
  slot: a,
  ...o
}) => {
  const c = G(null), l = gr(c), u = Si(ne.MEDIUM), p = () => n ? i ? !0 : !u : !1, h = () => /* @__PURE__ */ d("div", { ref: c, className: b }), g = (y) => {
    switch (y) {
      case "youtube":
        return /* @__PURE__ */ d(rd, { fullscreen: p(), ...o });
      case "aws":
        if (e) {
          const m = `${e}${o.videoId}/hls/main.m3u8`;
          return /* @__PURE__ */ d(
            Qc,
            {
              awsServiceBaseUrl: e,
              fullscreen: p(),
              videoLoop: i,
              options: {
                aspectRatio: oe.HD,
                fluid: !0,
                preload: i ? "auto" : "none",
                muted: i,
                loop: i,
                autoplay: i,
                controls: !0,
                playsinline: !!i,
                disablePictureInPicture: !0,
                fullscreen: { navigationUI: "hide" },
                controlBar: {
                  fullscreenToggle: !0,
                  pictureInPictureToggle: !1
                },
                sources: [
                  {
                    src: m,
                    type: "application/x-mpegURL"
                  }
                ]
              },
              ...o
            }
          );
        }
        return console.error("Trying to render AWS video service without supplying video service URL"), h();
      default:
        console.info(`Trying to render not-implemented video service: - ${y}`);
        break;
    }
  }, _ = () => (r || s) && /* @__PURE__ */ I("div", { className: X["video-description"], children: [
    r && /* @__PURE__ */ d("figcaption", { className: X["video-description__caption"], children: r }),
    s && /* @__PURE__ */ I("div", { className: X["video-description__copyright"], children: [
      "© ",
      s
    ] })
  ] }), b = L(
    X["video-player__placeholder"],
    n && X["video-player__placeholder--fullscreen"]
  ), E = L(
    X["video-player"],
    n && !i && X["video-player--fullscreen"]
  );
  return l ? /* @__PURE__ */ I("div", { className: E, slot: a, children: [
    g(t),
    _()
  ] }) : h();
}, qe = {
  "hero-teaser": "hero-teaser",
  "hero-teaser__info-container": "hero-teaser__info-container",
  "hero-teaser__text-container": "hero-teaser__text-container",
  "hero-teaser__title-container": "hero-teaser__title-container",
  "hero-teaser__title": "hero-teaser__title",
  "hero-teaser__overline": "hero-teaser__overline",
  "hero-teaser__button-container": "hero-teaser__button-container",
  "hero-teaser__media-container": "hero-teaser__media-container",
  "hero-teaser--unpublished": "hero-teaser--unpublished"
}, Fh = ({
  teaserTitle: e,
  teaserOverline: t,
  teaserDescription: n,
  teaserImage: i,
  teaserVideoId: r,
  teaserImageRatio: s,
  teaserImageAlt: a,
  imageOnLeftSide: o = !1,
  primaryButtonUrl: c,
  primaryButtonText: l,
  secondaryButton: u,
  onPrimaryButtonClick: p,
  leftIcon: h,
  rightIcon: g,
  unpublished: _,
  playLabel: b,
  pauseLabel: E,
  onVideoStateChange: y,
  target: m,
  awsServiceBaseUrl: f
}) => {
  const w = Si(ne.MEDIUM) ? !0 : o, T = Ei(r), N = T !== "", A = !!i, R = A && /* @__PURE__ */ d(In, { src: i ?? "", alt: a ?? "", ratio: s }), S = N && /* @__PURE__ */ d(
    Ti,
    {
      awsServiceBaseUrl: f,
      service: "aws",
      videoId: T,
      previewAlt: a ?? "",
      playLabel: b ?? "",
      pauseLabel: E ?? "",
      videoLoop: !0,
      onVideoStateChange: (D) => {
        y && y(D);
      }
    }
  ), k = (A || N) && /* @__PURE__ */ d("div", { className: qe["hero-teaser__media-container"], children: A ? R : S }), P = /* @__PURE__ */ I("div", { className: qe["hero-teaser__info-container"], children: [
    /* @__PURE__ */ I("div", { className: qe["hero-teaser__text-container"], children: [
      /* @__PURE__ */ I("div", { className: qe["hero-teaser__title-container"], children: [
        t && t.length > 0 && /* @__PURE__ */ d("div", { className: qe["hero-teaser__overline"], children: t }),
        e && /* @__PURE__ */ d("h2", { className: qe["hero-teaser__title"], children: e })
      ] }),
      n && /* @__PURE__ */ d("p", { children: n })
    ] }),
    /* @__PURE__ */ I("div", { className: qe["hero-teaser__button-container"], children: [
      l && /* @__PURE__ */ d(
        St,
        {
          target: m || yn.SELF,
          hasMarginTop: !1,
          href: c,
          appearance: Me.SECONDARY,
          text: l,
          onClick: p,
          leftIcon: h,
          rightIcon: g
        }
      ),
      u
    ] })
  ] });
  return /* @__PURE__ */ d("section", { className: L(qe["hero-teaser"], _ && qe["hero-teaser--unpublished"]), children: w ? /* @__PURE__ */ I(ze, { children: [
    k,
    " ",
    P
  ] }) : /* @__PURE__ */ I(ze, { children: [
    P,
    " ",
    k
  ] }) });
}, Qi = {
  "highlight-box": "highlight-box",
  "highlight-box--transparent": "highlight-box--transparent",
  "highlight-box--theme-aware": "highlight-box--theme-aware",
  "highlight-box--neutral": "highlight-box--neutral",
  "highlight-box--neutral-100": "highlight-box--neutral-100",
  "highlight-box--neutral-200": "highlight-box--neutral-200",
  "highlight-box--grey": "highlight-box--grey",
  "highlight-box--grey-50": "highlight-box--grey-50",
  "highlight-box--grey-100": "highlight-box--grey-100",
  "highlight-box--grey-200": "highlight-box--grey-200",
  "highlight-box--grey-300": "highlight-box--grey-300",
  "highlight-box--white": "highlight-box--white"
}, Gh = ({ color: e, children: t }) => /* @__PURE__ */ d("section", { className: L(Qi["highlight-box"], Qi[`highlight-box--${e}`]), children: t }), sd = {
  "horizontal-center": "horizontal-center"
}, Uh = ({ children: e, slot: t }) => e != null && (Array.isArray(e) ? e.length > 0 : !0) ? /* @__PURE__ */ d("div", { className: sd["horizontal-center"], slot: t, children: e }) : null, ad = "input", od = "input__wrapper", ld = "input__input", cd = "input__label", dd = "input__hint", ud = "input__error", Ee = {
  input: ad,
  input__wrapper: od,
  "input--disabled": "input--disabled",
  input__input: ld,
  "input--error": "input--error",
  input__label: cd,
  "input__label-wrapper": "input__label-wrapper",
  input__hint: dd,
  input__error: ud,
  "input__error-text": "input__error-text",
  "input__clear-button": "input__clear-button"
};
var en = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.EMAIL = "email", e.TEXTAREA = "textarea", e.SEARCH = "search", e))(en || {});
const pd = "16px", hd = ({
  id: e,
  label: t,
  value: n,
  placeholder: i,
  required: r = !1,
  className: s,
  tooltip: a,
  tooltipAriaLabel: o,
  type: c = en.TEXT,
  maxLength: l,
  hint: u,
  error: p,
  disabled: h = !1,
  translations: g,
  valid: _,
  dirty: b,
  hintParsed: E,
  onBlur: y,
  onChange: m
}) => {
  const f = b && !_, v = `${e}-error`, w = `${e}-hint`, T = L(
    Ee.input,
    f && Ee["input--error"],
    h && Ee["input--disabled"],
    s
  ), N = !!(t || r || u), A = [u && w, f && v].filter(Boolean).join(" "), R = (V) => {
    m(V.target.value);
  }, S = (V) => {
    m(V.target.value);
  }, k = () => {
    m("");
  }, P = () => c === en.SEARCH && n ? /* @__PURE__ */ d(
    "button",
    {
      className: Ee["input__clear-button"],
      onClick: k,
      "aria-label": g == null ? void 0 : g.clearInput,
      type: "button",
      children: /* @__PURE__ */ d(F, { icon: "cross", height: pd })
    }
  ) : null, D = () => /* @__PURE__ */ I("div", { className: Ee.input__wrapper, children: [
    c !== en.TEXTAREA ? /* @__PURE__ */ d(
      "input",
      {
        id: e,
        className: Ee.input__input,
        maxLength: l || void 0,
        placeholder: i,
        disabled: h,
        value: n,
        required: r,
        "aria-invalid": f,
        "aria-describedby": A || void 0,
        onBlur: y,
        onChange: R,
        type: c
      }
    ) : /* @__PURE__ */ d(
      "textarea",
      {
        id: e,
        className: Ee.input__input,
        maxLength: l || void 0,
        required: r,
        placeholder: i,
        disabled: h,
        value: n,
        "aria-invalid": f,
        "aria-describedby": A || void 0,
        onBlur: y,
        onChange: S,
        rows: 5
      }
    ),
    P()
  ] });
  return /* @__PURE__ */ I("div", { className: T, children: [
    N && /* @__PURE__ */ I("div", { className: Ee["input__label-wrapper"], children: [
      /* @__PURE__ */ d("label", { className: Ee.input__label, htmlFor: e, children: mi(r, t) }),
      a && /* @__PURE__ */ d(xi, { ariaLabel: o, children: a }),
      u && /* @__PURE__ */ d("span", { id: w, className: Ee.input__hint, children: E })
    ] }),
    D(),
    /* @__PURE__ */ d("div", { id: v, className: Ee.input__error, ...f && { role: "alert" }, children: f && /* @__PURE__ */ I(ze, { children: [
      /* @__PURE__ */ d(F, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ d("p", { className: Ee["input__error-text"], children: p || `${g == null ? void 0 : g.error} ${t}` })
    ] }) })
  ] });
}, Ji = {
  "lead-text": "lead-text"
}, qh = ({ children: e, lead: t }) => t != null ? /* @__PURE__ */ d("p", { className: Ji["lead-text"], children: t }) : /* @__PURE__ */ d("div", { className: Ji["lead-text"], children: e }), Dn = {
  "loading-spinner": "loading-spinner",
  "loading-spinner__icon-container": "loading-spinner__icon-container",
  "loading-spinner__text": "loading-spinner__text"
}, fd = "loading", md = "24px", gd = ({ loadingText: e }) => /* @__PURE__ */ I("div", { className: Dn["loading-spinner"], children: [
  /* @__PURE__ */ d("div", { className: Dn["loading-spinner__icon-container"], children: /* @__PURE__ */ d(F, { icon: fd, height: md, decorative: !0, display: "inline" }) }),
  /* @__PURE__ */ d("div", { className: Dn["loading-spinner__text"], "aria-live": "polite", "aria-busy": "true", children: e })
] }), _d = "magnet", vd = {
  magnet: _d
}, Wh = () => /* @__PURE__ */ d("div", { className: vd.magnet }), wd = "marketo", bd = {
  marketo: wd
}, Yh = ({ children: e }) => /* @__PURE__ */ d("div", { className: bd.marketo, children: e }), yd = "pagination", xd = "pagination__row", Ed = "pagination__item", Sd = "pagination__icon", Td = "pagination__button", Nd = "pagination__separator", J = {
  pagination: yd,
  pagination__row: xd,
  "pagination__large-numbers": "pagination__large-numbers",
  "pagination__small-numbers": "pagination__small-numbers",
  pagination__item: Ed,
  "pagination__item--colored": "pagination__item--colored",
  "pagination__item--active": "pagination__item--active",
  "pagination__item-text": "pagination__item-text",
  "pagination__item--disabled": "pagination__item--disabled",
  pagination__icon: Sd,
  pagination__button: Td,
  pagination__separator: Nd,
  "pagination__visually-hidden": "pagination__visually-hidden"
}, fn = "…", Cd = ({ label: e }) => /* @__PURE__ */ d("span", { className: J["pagination__item-text"], "aria-hidden": "true", children: e }), er = ({ enabled: e, onClick: t, onFocus: n, icon: i, label: r }) => /* @__PURE__ */ d(
  "li",
  {
    className: L(
      {
        [J["pagination__item--disabled"]]: !e
      },
      J.pagination__item,
      J["pagination__item--colored"]
    ),
    children: /* @__PURE__ */ d(
      "button",
      {
        className: J.pagination__button,
        onClick: t,
        onFocus: () => n == null ? void 0 : n(),
        onMouseEnter: () => n == null ? void 0 : n(),
        disabled: !e,
        "aria-disabled": !e,
        "aria-label": r,
        type: "button",
        children: /* @__PURE__ */ d("span", { className: J.pagination__icon, children: /* @__PURE__ */ d(F, { icon: i, width: `${Ie(24)}rem`, height: `${Ie(24)}rem` }) })
      }
    )
  }
), Ad = ({
  page: e,
  isActive: t,
  setPage: n,
  focusPage: i,
  pageLabel: r,
  currentPageLabel: s
}) => {
  const a = `${r} ${e}`, o = t ? `${a}, ${s}` : a;
  return /* @__PURE__ */ d(
    "li",
    {
      className: L(
        J["pagination__large-numbers"],
        J.pagination__item,
        J["pagination__item--colored"],
        {
          [J["pagination__item--active"]]: t
        }
      ),
      children: /* @__PURE__ */ d(
        "button",
        {
          className: J.pagination__button,
          onClick: () => n(e),
          onMouseOver: () => {
            i && !t && i(e);
          },
          onFocus: () => {
            i && !t && i(e);
          },
          "aria-current": t ? "page" : void 0,
          "aria-label": o,
          tabIndex: t ? -1 : void 0,
          type: "button",
          children: /* @__PURE__ */ d(Cd, { label: e })
        }
      )
    },
    `page-${e}`
  );
}, Md = ({ index: e }) => /* @__PURE__ */ d(
  "li",
  {
    className: L(J["pagination__large-numbers"], J["pagination__item--disabled"], J.pagination__item),
    "aria-hidden": "true",
    role: "presentation",
    children: /* @__PURE__ */ d("span", { className: J["pagination__item-text"], children: fn })
  },
  `ellipsis-${e}`
), Vn = (e, t) => Array.from({ length: t - e }, (n, i) => i + e), Id = (e, t, n) => {
  const { floor: i, min: r, max: s } = Math;
  if (n <= e)
    return Vn(1, n + 1);
  const a = e - 4, o = i(a / 2);
  let c = s(2, t - o), l = r(n - 1, t + o), u = c - 2, p = n - 1 - l;
  if (u <= 1 && p > 1) {
    c = 2;
    const g = c + e - 4;
    l = s(g, t + 1);
  } else if (p <= 1 && u > 1) {
    l = n - 1;
    const g = l - e + 4;
    c = r(g, t - 1);
  } else if (u <= 1 && p <= 1)
    return Vn(1, n + 1);
  u = c - 2, p = n - 1 - l;
  const h = [1];
  return u > 1 ? h.push(fn) : u === 1 && h.push(2), h.push(...Vn(c, l + 1)), p > 1 ? h.push(fn) : p === 1 && h.push(n - 1), h.push(n), h;
}, Rd = ({
  totalPages: e,
  activePage: t,
  visiblePages: n,
  disableScrollTarget: i = !1,
  onPageChange: r,
  onPagePrefetch: s,
  scrollTarget: a,
  className: o,
  ariaLabels: c = {}
}) => {
  const {
    navigationLabel: l = "Search navigation",
    previousPageLabel: u = "Previous page",
    nextPageLabel: p = "Next page",
    pageLabel: h = "Page",
    currentPageLabel: g = "current page",
    pageStatusLabel: _ = "Page {current} of {total}"
  } = c, b = Math.max(Math.ceil(e), 1);
  if (b === 1)
    return null;
  const E = (f) => {
    t !== f && (r && r(f), !i && (a == null || a.scrollIntoView({ behavior: "smooth", block: "start" })));
  }, m = Id(n, t, b).map((f, v) => {
    if (f === fn)
      return /* @__PURE__ */ d(Md, { index: v }, `ellipsis-${v}`);
    const w = f;
    return /* @__PURE__ */ d(
      Ad,
      {
        page: w,
        isActive: w === t,
        setPage: E,
        focusPage: s,
        pageLabel: h,
        currentPageLabel: g
      },
      w
    );
  });
  return /* @__PURE__ */ I("nav", { className: L(J.pagination, o), "aria-label": l, children: [
    /* @__PURE__ */ d("div", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: J["pagination__visually-hidden"], children: _.replaceAll("{current}", `${t}`).replaceAll("{total}", `${b}`) }),
    /* @__PURE__ */ I("ol", { className: J.pagination__row, children: [
      /* @__PURE__ */ d(
        er,
        {
          enabled: t !== 1,
          onClick: () => {
            t > 1 && E(t - 1);
          },
          onFocus: () => {
            s && t > 1 && s(t - 1);
          },
          icon: "chevron-left",
          label: u
        }
      ),
      m,
      /* @__PURE__ */ d("li", { className: L(J.pagination__item, J["pagination__small-numbers"]), "aria-hidden": "true", children: /* @__PURE__ */ I("span", { className: J["pagination__item-text"], children: [
        t,
        " ",
        /* @__PURE__ */ d("span", { className: J.pagination__separator }),
        " ",
        b
      ] }) }),
      /* @__PURE__ */ d(
        er,
        {
          enabled: t !== b,
          onClick: () => {
            t < b && E(t + 1);
          },
          onFocus: () => {
            s && t < b && s(t + 1);
          },
          icon: "chevron-right",
          label: p
        }
      )
    ] })
  ] });
}, kd = "podcast", Ld = "podcast__iframe", mn = {
  podcast: kd,
  podcast__iframe: Ld
}, jr = [10, 25, 50, 75, 100], Pd = ({ src: e, onPodcastStateChange: t }) => {
  const n = G(null), i = G(null), [r, s] = B(!1), [a, o] = B(""), [c, l] = B(0), u = G(/* @__PURE__ */ new Set()), p = G(!1), h = Te(
    (m, f, v) => ({
      audioName: m,
      audioUrl: e,
      audioProvider: "soundcloud",
      audioDurationTotal: f,
      audioPercentage: v
    }),
    [e]
  ), g = () => {
    u.current.clear(), p.current = !1;
  }, _ = Te(() => {
    if (window.SC && typeof window.SC.Widget == "function") {
      s(!0);
      return;
    }
    const m = document.createElement("script");
    m.src = "https://w.soundcloud.com/player/api.js", m.async = !0, m.onload = () => s(!0), m.onerror = () => {
      t({
        type: "error",
        base: h("SoundCloud Player", 0, 0),
        errorMessage: "Failed to load SoundCloud Widget API",
        trackingValue: "audioError"
      });
    }, document.body.appendChild(m);
  }, [h, t]), b = Te(() => {
    !i.current || p.current || (p.current = !0, i.current.getCurrentSound((m) => {
      m && (o(m.title), l(m.duration), t({
        type: "starting",
        base: h(m.title, m.duration, 0),
        trackingValue: "audioStart"
      }));
    }));
  }, [h, t]), E = Te(
    (m) => {
      const f = Math.round(m.relativePosition * 100);
      for (const v of jr)
        f >= v && !u.current.has(v) && (u.current.add(v), t({
          type: "progress",
          base: h(a, c, v),
          trackingValue: "audioProgress"
        }));
    },
    [h, c, t, a]
  ), y = Te(() => {
    t({
      type: "completed",
      base: h(a, c, 100),
      trackingValue: "audioComplete"
    }), g();
  }, [h, c, t, a]);
  return U(() => {
    _();
  }, [_]), U(() => {
    r && n.current && (i.current = new window.SC.Widget(n.current));
  }, [r]), U(() => {
    const m = i.current;
    if (m)
      return m.bind(window.SC.Widget.Events.PLAY, b), m.bind(window.SC.Widget.Events.PLAY_PROGRESS, E), m.bind(window.SC.Widget.Events.FINISH, y), () => {
        m.unbind(window.SC.Widget.Events.PLAY, b), m.unbind(window.SC.Widget.Events.PLAY_PROGRESS, E), m.unbind(window.SC.Widget.Events.FINISH, y);
      };
  }, [b, E, y]), /* @__PURE__ */ d(
    "iframe",
    {
      ref: n,
      className: mn.podcast__iframe,
      title: "SoundCloud Player",
      src: e,
      width: "100%",
      allow: "autoplay",
      allowFullScreen: !0,
      loading: "lazy",
      seamless: !0
    }
  );
}, Od = 80, Dd = ({ src: e, onPodcastStateChange: t }) => {
  const n = G(null), i = G(null), [r, s] = B(null), [a, o] = B(!1), c = G(/* @__PURE__ */ new Set()), l = (b, E) => ({
    audioName: "Spotify Podcast",
    audioUrl: e,
    audioProvider: "spotify",
    audioDurationTotal: b,
    audioPercentage: E
  }), u = () => {
    c.current.clear();
  }, p = (b) => {
    const { position: E, duration: y } = b.data;
    if (y === 0) {
      g("No audio found");
      return;
    }
    const m = E / y * 100;
    for (const f of jr)
      m >= f && !c.current.has(f) && (c.current.add(f), t(f === 100 ? {
        type: "completed",
        base: l(y, m),
        trackingValue: "audioComplete"
      } : {
        type: "progress",
        base: l(y, f),
        trackingValue: "audioProgress"
      }));
  }, h = (b) => {
    const { duration: E } = b.data;
    if (E === 0) {
      g("No audio found");
      return;
    }
    u(), t({
      type: "starting",
      base: l(E, 0),
      trackingValue: "audioStart"
    });
  }, g = (b) => {
    t({
      type: "error",
      base: l(0, 0),
      trackingValue: "audioError",
      errorMessage: b
    });
  }, _ = (b) => {
    const E = b.match(/open\.spotify\.com\/embed\/(\w+)\/([\w\d]+)/);
    if (!E)
      return g("Failed to generate Spotify URI"), null;
    const [, y, m] = E;
    return `spotify:${y}:${m}`;
  };
  return U(() => {
    const b = document.createElement("script");
    return b.src = "https://open.spotify.com/embed/iframe-api/v1", b.async = !0, document.body.appendChild(b), () => {
      document.body.removeChild(b);
    };
  }, []), U(() => {
    r || (window.onSpotifyIframeApiReady = (b) => {
      s(b);
    });
  }, [r]), U(() => {
    if (!(a || r === null || !n.current))
      return r.createController(
        n.current,
        {
          height: Od,
          uri: _(e) || ""
        },
        (b) => {
          b.addListener("ready", () => {
            o(!0);
          }), b.addListener("playback_started", h), b.addListener("playback_update", p), i.current = b;
        }
      ), () => {
        i.current && i.current.removeListener("playback_update");
      };
  }, [a, r, e]), /* @__PURE__ */ d(
    "iframe",
    {
      ref: n,
      className: mn.podcast__iframe,
      title: "Podcast Player",
      src: e,
      width: "100%",
      seamless: !0,
      allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
      allowFullScreen: !0,
      loading: "lazy"
    }
  );
}, jh = ({ src: e, provider: t, slot: n, onPodcastStateChange: i }) => {
  const r = G(null), s = gr(r);
  return /* @__PURE__ */ I("div", { className: L(mn.podcast, `podcast--${t}`), slot: n, ref: r, children: [
    s && (t === "spotify-creators" || t === "spotify") && /* @__PURE__ */ d(Dd, { src: e, onPodcastStateChange: i }),
    s && t === "soundcloud" && /* @__PURE__ */ d(Pd, { src: e, onPodcastStateChange: i }),
    t === "transistor" && /* @__PURE__ */ d(
      "iframe",
      {
        className: mn.podcast__iframe,
        title: "Podcast Player",
        src: e,
        width: "100%",
        seamless: !0,
        allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
        allowFullScreen: !0,
        loading: "lazy"
      }
    )
  ] });
}, Vd = {
  "published-date": "published-date"
}, Xh = ({ publishedDate: e }) => /* @__PURE__ */ d("div", { className: Vd["published-date"], children: /* @__PURE__ */ d("time", { children: e }) }), We = {
  "roche-quote": "roche-quote",
  "roche-quote__image": "roche-quote__image",
  "roche-quote__content": "roche-quote__content",
  "roche-quote__text": "roche-quote__text",
  "roche-quote__text--small": "roche-quote__text--small",
  "roche-quote__subline": "roche-quote__subline",
  "roche-quote__link": "roche-quote__link",
  "roche-quote--with-image": "roche-quote--with-image",
  "roche-quote--equal-ratio": "roche-quote--equal-ratio"
};
var ri = /* @__PURE__ */ ((e) => (e.BIG = "big", e.SMALL = "small", e))(ri || {}), si = /* @__PURE__ */ ((e) => (e.WITH_IMAGE = "with-image", e.NORMAL = "normal", e))(si || {});
const Zh = ({
  quote: e,
  size: t = ri.BIG,
  layout: n = si.NORMAL,
  isEqualRatio: i = !1,
  image: r,
  sublines: s,
  link: a
}) => {
  const o = n === si.WITH_IMAGE, c = t === ri.SMALL, l = L(We["roche-quote"], {
    [We["roche-quote--with-image"]]: o,
    [We["roche-quote--equal-ratio"]]: i
  }), u = L(We["roche-quote__text"], {
    [We["roche-quote__text--small"]]: c
  });
  return /* @__PURE__ */ I("figure", { className: l, children: [
    o && /* @__PURE__ */ d("div", { className: We["roche-quote__image"], children: r }),
    /* @__PURE__ */ I("div", { className: We["roche-quote__content"], children: [
      /* @__PURE__ */ d("blockquote", { children: /* @__PURE__ */ d("p", { className: u, children: e }) }),
      /* @__PURE__ */ I("figcaption", { children: [
        s && s.length > 0 && /* @__PURE__ */ d("div", { className: We["roche-quote__subline"], children: s }),
        o && a && /* @__PURE__ */ d("div", { className: We["roche-quote__link"], children: a })
      ] })
    ] })
  ] });
}, $d = ["htm", "html"], zd = (e) => {
  var t;
  try {
    const i = new URL(e, window.location.origin).pathname.split("/").pop();
    if (!i) return { isDownload: !1 };
    if (!i.includes(".")) return { isDownload: !1 };
    const r = (t = i.split(".").pop()) == null ? void 0 : t.toLowerCase();
    return r ? $d.includes(r) ? { isDownload: !1 } : {
      isDownload: !0,
      extension: r,
      fileName: i
    } : { isDownload: !1 };
  } catch {
    return { isDownload: !1, extension: "", fileName: "" };
  }
}, Hd = (e, t) => ({ filteredData: hi(() => {
  if (!t)
    return e;
  const i = t.toLowerCase();
  return e.filter((r) => r.body.some((s) => String(s.value).toLowerCase().includes(i)));
}, [e, t]) });
var ai = /* @__PURE__ */ ((e) => (e.ROWS = "rows", e.COLUMNS = "columns", e))(ai || {}), tn = /* @__PURE__ */ ((e) => (e.ASCENDING = "chevron-up", e.DESCENDING = "chevron-down", e))(tn || {}), De = /* @__PURE__ */ ((e) => (e.ASCENDING = "asc", e.DESCENDING = "desc", e))(De || {});
const Bd = (e) => {
  const [t, n] = B(null), [i, r] = B(De.DESCENDING);
  return { sortedData: hi(() => t === null ? e : [...e].sort((o, c) => {
    var _, b;
    const l = String(((_ = o.body[t]) == null ? void 0 : _.value) || "").toLowerCase(), u = String(((b = c.body[t]) == null ? void 0 : b.value) || "").toLowerCase();
    if (l === u) return 0;
    const p = parseFloat(l.replace(",", ".")), h = parseFloat(u.replace(",", "."));
    if (!Number.isNaN(p) && !Number.isNaN(h))
      return i === De.ASCENDING ? p - h : h - p;
    const g = l > u ? 1 : -1;
    return i === De.ASCENDING ? g : -g;
  }), [e, t, i]), sortByIndex: t, sortDirection: i, toggleSort: (o) => {
    t === o ? r((c) => c === De.ASCENDING ? De.DESCENDING : De.ASCENDING) : (n(o), r(De.ASCENDING));
  } };
}, Fd = "input", Y = {
  "responsive-table": "responsive-table",
  "responsive-table__table": "responsive-table__table",
  "responsive-table__caption": "responsive-table__caption",
  "responsive-table__header-row": "responsive-table__header-row",
  "responsive-table__header-item": "responsive-table__header-item",
  "responsive-table__body-item": "responsive-table__body-item",
  "responsive-table__body-row": "responsive-table__body-row",
  "responsive-table__no-results": "responsive-table__no-results",
  "responsive-table__no-results-icon": "responsive-table__no-results-icon",
  "responsive-table--sticky-header": "responsive-table--sticky-header",
  "responsive-table--alternated-rows": "responsive-table--alternated-rows",
  "responsive-table--alternated-columns": "responsive-table--alternated-columns",
  "responsive-table--alternated-row-single": "responsive-table--alternated-row-single",
  "responsive-table--alternated-column-single": "responsive-table--alternated-column-single",
  "responsive-table--sortable": "responsive-table--sortable",
  "responsive-table__header-item--sortable": "responsive-table__header-item--sortable",
  "responsive-table__sort-icon": "responsive-table__sort-icon",
  "responsive-table--align-text-right": "responsive-table--align-text-right",
  "responsive-table__table--is-small": "responsive-table__table--is-small",
  "responsive-table__header": "responsive-table__header",
  "responsive-table__filter": "responsive-table__filter",
  input: Fd
}, Gd = 160, Kh = ({
  table: e,
  stickyHeader: t,
  sortable: n,
  filterable: i,
  noResults: r,
  alignText: s,
  multipleAlternatives: a,
  alternatedRow: o,
  alternatedColumn: c,
  caption: l,
  filterInputPlaceholder: u,
  clearFilterText: p,
  onResponsiveTableEvent: h
}) => {
  const g = fi(), _ = G(null), [b, E] = B(!1), [y, m] = B(""), { filteredData: f } = Hd(e.tbody, y), { sortedData: v, sortByIndex: w, sortDirection: T, toggleSort: N } = Bd(f), A = v.length, R = e.thead.length ? e.thead.map((H, W) => ({
    id: H.id,
    header: H,
    body: e.tbody.map((re) => re.body[W])
  })) : e.tbody.map((H) => ({
    id: H.id,
    header: { id: "", value: "" },
    body: H.body.map((W) => W)
  })), S = o && Number(o) > 0 && !a ? Number(o) : void 0, k = c && Number(c) > 0 && !a && !S ? Number(c) : void 0;
  U(() => {
    if (!_.current) return;
    const H = new ResizeObserver(() => {
      var Ke;
      const W = _.current;
      if (!W) return;
      const { width: re } = W.getBoundingClientRect(), ue = e.thead.length || (((Ke = e.tbody[0]) == null ? void 0 : Ke.body.length) ?? 0);
      if (re > ne.LARGE) {
        E(!1);
        return;
      }
      const Re = re / ue;
      E(Re < Gd);
    });
    return H.observe(_.current), () => H.disconnect();
  }, [e]), U(() => {
    y !== "" && h({
      type: "update_filter",
      trackingValue: "filter",
      value: y,
      additionalParameters: {
        filteredResults: v.length
      }
    });
  }, [y]), U(() => {
    w !== null && h({
      type: "update_sort_by",
      trackingValue: "sort",
      value: T,
      additionalParameters: {
        sortedColumnNr: w,
        sortedColumn: e.thead.length ? e.thead[w].value : ""
      }
    });
  }, [w, T]);
  const P = (H) => w !== H ? tn.DESCENDING : T === De.ASCENDING ? tn.ASCENDING : tn.DESCENDING, D = (H) => w !== H ? "none" : T === De.ASCENDING ? "ascending" : "descending", V = L(
    Y["responsive-table__table"],
    t && Y["responsive-table--sticky-header"],
    n && Y["responsive-table--sortable"],
    s === "right" && Y[`responsive-table--align-text-${s}`],
    a === ai.ROWS && Y["responsive-table--alternated-rows"],
    a === ai.COLUMNS && Y["responsive-table--alternated-columns"]
  ), z = (H) => S === H + 1 ? Y["responsive-table--alternated-row-single"] : "", O = (H) => k === H + 1 ? Y["responsive-table--alternated-column-single"] : "", C = (H) => {
    m(H);
  }, M = () => {
    m(""), h({
      type: "clear_filter",
      trackingValue: "clear_filter"
    });
  }, $ = (H) => {
    var Bt;
    const re = H.target.closest("a");
    if (!re) return;
    const ue = re.getAttribute("href"), Re = (Bt = re.textContent) == null ? void 0 : Bt.trim(), Ke = zd(ue || "");
    if (Ke.isDownload) {
      h({
        type: "download",
        event: "download",
        value: ue || "",
        additionalParameters: {
          file_type: Ke.extension,
          file_name: Ke.fileName
        }
      });
      return;
    }
    h({
      type: "link_click",
      event: "link_click",
      additionalParameters: {
        click_text: Re || "",
        click_url: ue || ""
      }
    });
  }, q = () => /* @__PURE__ */ I(ze, { children: [
    i && /* @__PURE__ */ I("div", { className: Y["responsive-table__filter"], children: [
      /* @__PURE__ */ d(
        hd,
        {
          id: "responsive-table-filter",
          value: y,
          placeholder: u,
          onChange: C,
          valid: !0,
          dirty: y !== "",
          hintParsed: "",
          onBlur: () => {
          }
        }
      ),
      /* @__PURE__ */ d(
        St,
        {
          disabled: y === "",
          leftIcon: y === "" ? "search" : "loading",
          text: p ?? "",
          hasMarginTop: !1,
          onClick: M
        }
      )
    ] }),
    /* @__PURE__ */ I("table", { className: V, onClick: $, children: [
      /* @__PURE__ */ d("caption", { className: Y["responsive-table__caption"], children: l }),
      /* @__PURE__ */ d("thead", { className: Y["responsive-table__header"], children: /* @__PURE__ */ d("tr", { className: Y["responsive-table__header-row"], children: e.thead.map((H, W) => /* @__PURE__ */ d(
        "th",
        {
          className: Y["responsive-table__header-item"],
          scope: "col",
          "aria-sort": n ? D(W) : void 0,
          children: n ? /* @__PURE__ */ I(
            "button",
            {
              type: "button",
              className: Y["responsive-table__header-item--sortable"],
              onClick: () => N(W),
              children: [
                H.value,
                /* @__PURE__ */ d("span", { className: Y["responsive-table__sort-icon"], children: /* @__PURE__ */ d(F, { icon: P(W), width: g ? "16px" : "12px", decorative: !1 }) })
              ]
            }
          ) : H.value
        },
        H.id
      )) }) }),
      /* @__PURE__ */ d("tbody", { children: A > 0 ? v.map((H, W) => /* @__PURE__ */ d(
        "tr",
        {
          className: L(
            Y["responsive-table__body-row"],
            S && z(W)
          ),
          children: H.body.map((re, ue) => /* @__PURE__ */ d(
            "td",
            {
              className: L(
                Y["responsive-table__body-item"],
                k && O(ue)
              ),
              dangerouslySetInnerHTML: { __html: re.value ?? "" }
            },
            re.id
          ))
        },
        H.id
      )) : /* @__PURE__ */ d("tr", { children: /* @__PURE__ */ d("td", { colSpan: e.thead.length, children: /* @__PURE__ */ I("div", { className: L(Y["responsive-table__no-results"]), children: [
        /* @__PURE__ */ d("span", { className: Y["responsive-table__no-results-icon"], children: /* @__PURE__ */ d(F, { icon: "mobile", height: "24px" }) }),
        r
      ] }) }) }) })
    ] })
  ] }), ie = () => /* @__PURE__ */ I(
    "table",
    {
      className: L(
        Y["responsive-table__table"],
        Y["responsive-table__table--is-small"],
        t && Y["responsive-table--sticky-header"],
        s === "right" && Y[`responsive-table--align-text-${s}`]
      ),
      onClick: $,
      children: [
        /* @__PURE__ */ d("caption", { className: Y["responsive-table__caption"], children: l }),
        /* @__PURE__ */ d("tbody", { children: R.map((H) => /* @__PURE__ */ I("tr", { className: Y["responsive-table__body-row"], children: [
          H.header.value && /* @__PURE__ */ d("th", { className: Y["responsive-table__header"], scope: "row", children: H.header.value }),
          H.body.map((W) => /* @__PURE__ */ d(
            "td",
            {
              className: Y["responsive-table__body-item"],
              dangerouslySetInnerHTML: { __html: W.value ?? "" }
            },
            W.id
          ))
        ] }, H.id)) })
      ]
    }
  );
  return /* @__PURE__ */ d("section", { ref: _, className: Y["responsive-table"], children: b ? ie() : q() });
}, $n = {
  "rich-text": "rich-text",
  "rich-text--is-footnote": "rich-text--is-footnote",
  "rich-text--is-footer-type": "rich-text--is-footer-type"
}, Qh = ({
  children: e,
  isFootnote: t,
  isFooterType: n,
  markup: i,
  slot: r,
  dir: s
}) => {
  const a = {
    ...i && { dangerouslySetInnerHTML: { __html: i } }
  };
  return /* @__PURE__ */ d(
    "div",
    {
      slot: r,
      dir: s,
      ...a,
      className: L(
        $n["rich-text"],
        t && $n["rich-text--is-footnote"],
        n && $n["rich-text--is-footer-type"]
      ),
      children: e
    }
  );
}, tr = {
  "popular-search": "popular-search",
  "popular-search__title": "popular-search__title"
}, Ud = ({
  title: e,
  className: t,
  popularSearches: n,
  onPopularSearchTermClick: i
}) => /* @__PURE__ */ I("section", { "aria-labelledby": "popular-search-title", className: L(tr["popular-search"], t), children: [
  /* @__PURE__ */ d("h2", { id: "popular-search-title", className: tr["popular-search__title"], children: e }),
  /* @__PURE__ */ d("ul", { children: n.map((r) => (
    // biome-ignore lint/a11y/useKeyWithClickEvents: The click listener should probably be on the button
    /* @__PURE__ */ d("li", { onClick: () => i(r.label), children: /* @__PURE__ */ d("button", { type: "button", children: r.label }) }, `popular-search-${r.label}`)
  )) })
] }), qd = "search", Wd = "search__title", Yd = "search__pagination", K = {
  search: qd,
  "search__sr-announcement": "search__sr-announcement",
  search__title: Wd,
  "search__input-container": "search__input-container",
  "search__loading-container": "search__loading-container",
  "search__support-content-wrapper": "search__support-content-wrapper",
  "search__popular-searches": "search__popular-searches",
  "search__quick-links": "search__quick-links",
  "search__quick-links-title": "search__quick-links-title",
  "search__filter-tabs": "search__filter-tabs",
  "search__results-container": "search__results-container",
  "search__results-heading": "search__results-heading",
  "search__results-list": "search__results-list",
  "search__no-results": "search__no-results",
  "search__no-results-title": "search__no-results-title",
  "search__no-results-message": "search__no-results-message",
  "search__teaser-container": "search__teaser-container",
  "search__teaser-container--eight-columns": "search__teaser-container--eight-columns",
  "search__teaser-container--loading": "search__teaser-container--loading",
  search__pagination: Yd,
  "search__pagination--eight-columns": "search__pagination--eight-columns",
  "data-search": "data-search",
  "data-search--with-input": "data-search--with-input"
}, _t = {
  "search-input": "search-input",
  "search-input__label": "search-input__label",
  "search-input__description": "search-input__description",
  "search-input__input": "search-input__input",
  "search-input__search-icon": "search-input__search-icon",
  "search-input__clear-icon": "search-input__clear-icon"
}, nr = "1.5rem", jd = ({
  className: e,
  placeholder: t,
  value: n,
  onChange: i,
  onClear: r,
  ariaLabels: s
}) => {
  const a = L(_t["search-input"], e), o = n && n.length > 0 && r, c = (l) => {
    l.key === "Escape" && r && r();
  };
  return /* @__PURE__ */ I("form", { className: a, onSubmit: (l) => l.preventDefault(), role: "search", "aria-label": s.siteSearch, children: [
    /* @__PURE__ */ d("label", { htmlFor: "search-input", className: _t["search-input__label"], children: s.searchInputLabel }),
    /* @__PURE__ */ d("span", { id: "search-description", className: _t["search-input__description"], children: s.searchInputDescription }),
    /* @__PURE__ */ d("span", { className: _t["search-input__search-icon"], "aria-hidden": "true", children: /* @__PURE__ */ d(F, { height: nr, icon: "search" }) }),
    /* @__PURE__ */ d(
      "input",
      {
        className: _t["search-input__input"],
        id: "search-input",
        type: "search",
        autoComplete: "off",
        value: n,
        onChange: i,
        placeholder: t,
        onKeyDown: c,
        "aria-describedby": "search-description"
      }
    ),
    o && /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        onClick: r,
        className: _t["search-input__clear-icon"],
        "aria-label": s.clearSearchTerm,
        tabIndex: -1,
        children: /* @__PURE__ */ d(F, { height: nr, icon: "remove" })
      }
    )
  ] });
}, ir = 2;
function Xd(e) {
  const [t, n] = B("none"), i = Te(() => {
    const r = e.current;
    if (!r) {
      n("none");
      return;
    }
    const s = document.documentElement.dir === "rtl", a = r.scrollLeft, o = r.clientWidth, c = r.scrollWidth, l = s ? a - ir > o - c : a > 0, u = c - o, p = s ? a < 0 : a + ir < u;
    n(l && p ? "both" : l ? "left" : p ? "right" : "none");
  }, [e.current]);
  return U(() => {
    const r = e.current;
    if (r)
      return i(), r.addEventListener("scroll", i), window.addEventListener("resize", i), () => {
        r.removeEventListener("scroll", i), window.removeEventListener("resize", i);
      };
  }, [i]), t;
}
const Zd = "tabs", Kd = "tabs__tab", Qd = "tabs__panel", ce = {
  tabs: Zd,
  tabs__tab: Kd,
  "tabs__tab--active": "tabs__tab--active",
  "tabs__tab-label": "tabs__tab-label",
  "tabs__scroll-button": "tabs__scroll-button",
  "tabs__scroll-button--left": "tabs__scroll-button--left",
  "tabs__scroll-button--right": "tabs__scroll-button--right",
  tabs__panel: Qd,
  "tabs__panel--active": "tabs__panel--active",
  "tabs__tab-list-wrapper": "tabs__tab-list-wrapper",
  "tabs__tab-list": "tabs__tab-list",
  "tabs--filter": "tabs--filter",
  "tabs--filter-grey": "tabs--filter-grey",
  "tabs--centered": "tabs--centered",
  "tabs--no-margin": "tabs--no-margin"
}, zn = ({
  initiallySelected: e = 0,
  appearance: t = "default",
  autoScroll: n = !0,
  centered: i = !1,
  hasMarginTop: r = !0,
  tabs: s,
  children: a,
  slot: o,
  onTabClick: c
}) => {
  const l = fi(), [u, p] = B(e), h = G([]), g = G(null), _ = G(null), b = Xd(_), [E, y] = fr(), { scrollToItem: m } = mr(h);
  U(() => {
    const A = E.substring(1), R = (s == null ? void 0 : s.findIndex((P) => P.id === A)) ?? null, S = e >= 0 && e < ((s == null ? void 0 : s.length) ?? 0) ? e : null, k = R !== null && R >= 0 ? R : S ?? 0;
    p(k), R !== null && h.current[R] && n && setTimeout(() => m(R), 0);
  }, [e]);
  const f = (A) => {
    var k;
    const S = A === e ? "" : ((k = s == null ? void 0 : s[A]) == null ? void 0 : k.id) || "";
    y(S);
  }, v = (A) => {
    var D;
    const R = (s == null ? void 0 : s.findIndex((V) => V.id === A.currentTarget.id)) ?? null;
    if (R === null || R < 0 || R === u)
      return;
    p(R), f(R);
    const S = s == null ? void 0 : s[R ?? 0], k = (S == null ? void 0 : S.headline) || "", P = (S == null ? void 0 : S.id) || "";
    h.current[R] && ((D = h.current[R]) == null || D.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })), c == null || c(A, k, P);
  }, w = (A) => {
    var z, O;
    if (!s || s.length === 0 || !A.key)
      return;
    const { key: R } = A, S = (C, M) => (C + 1) % M, k = (C, M) => (C - 1 + M) % M, P = {
      ArrowRight: l ? k : S,
      ArrowLeft: l ? S : k,
      Home: () => 0,
      End: (C, M) => M - 1
    };
    if (!P[R])
      return;
    A.preventDefault();
    const D = h.current.indexOf(document.activeElement), V = P[R](D ?? 0, s.length);
    V !== D && ((z = h.current[V]) == null || z.focus(), (O = h.current[V]) == null || O.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" }));
  }, T = (A) => {
    const R = g.current, S = _.current;
    if (!S || !R || Array.from(S.children).length === 0)
      return;
    const P = ((R == null ? void 0 : R.offsetWidth) ?? 0) * 0.8, D = A === "right" ? P : -P;
    S.scrollBy({
      left: D,
      behavior: "smooth"
    });
  }, N = L(ce.tabs, {
    [ce["tabs--centered"]]: i,
    [ce["tabs--no-margin"]]: !r,
    [ce["tabs--filter"]]: t === "filter" || t === "filter-grey",
    [ce["tabs--filter-grey"]]: t === "filter-grey"
  });
  return /* @__PURE__ */ I("div", { className: N, slot: o, children: [
    /* @__PURE__ */ I("div", { className: ce["tabs__tab-list-wrapper"], ref: g, children: [
      (b === "left" || b === "both") && /* @__PURE__ */ d(
        "div",
        {
          className: L(ce["tabs__scroll-button"], ce["tabs__scroll-button--left"]),
          onClick: () => T("left"),
          children: /* @__PURE__ */ d(F, { icon: l ? "chevron-right" : "chevron-left", height: "24px" })
        }
      ),
      /* @__PURE__ */ d("div", { className: ce["tabs__tab-list"], role: "tablist", ref: _, children: s == null ? void 0 : s.map((A, R) => /* @__PURE__ */ d(
        "button",
        {
          className: L(ce.tabs__tab, u === R && ce["tabs__tab--active"]),
          id: A.id,
          type: "button",
          role: "tab",
          "aria-selected": u === R,
          "aria-controls": `panel-${A.id}`,
          tabIndex: u === R ? 0 : -1,
          onClick: v,
          onKeyDown: w,
          ref: (S) => {
            h.current[R] = S;
          },
          children: /* @__PURE__ */ d("span", { className: ce["tabs__tab-label"], children: A.headline })
        },
        A.headline
      )) }),
      (b === "right" || b === "both") && /* @__PURE__ */ d(
        "div",
        {
          className: L(ce["tabs__scroll-button"], ce["tabs__scroll-button--right"]),
          onClick: () => T("right"),
          children: /* @__PURE__ */ d(F, { icon: l ? "chevron-left" : "chevron-right", height: "24px" })
        }
      )
    ] }),
    a == null ? void 0 : a.map((A, R) => {
      var S, k;
      return /* @__PURE__ */ d(
        "div",
        {
          className: L(ce.tabs__panel, u === R && ce["tabs__panel--active"]),
          id: `panel-${(S = s == null ? void 0 : s[R]) == null ? void 0 : S.id}`,
          role: "tabpanel",
          "aria-labelledby": (k = s == null ? void 0 : s[R]) == null ? void 0 : k.id,
          hidden: u !== R,
          children: A
        },
        R
      );
    })
  ] });
}, Jd = ({
  variant: e,
  tabs: t,
  subtabs: n,
  currentTab: i,
  currentSubtab: r,
  alwaysShowTabs: s,
  searchQuery: a,
  setSearchParams: o,
  currentPage: c,
  totalResultFoundText: l,
  itemRenderer: u,
  labels: p,
  onPagePrefetch: h,
  isTabSwitchLoading: g
}) => {
  if (!i) return null;
  const _ = t.findIndex((b) => b.tab === i);
  if (e === "main")
    return /* @__PURE__ */ d("div", { className: "search__filter-main-tabs", children: /* @__PURE__ */ d(
      zn,
      {
        autoScroll: !1,
        hasMarginTop: !1,
        tabs: t.map((b) => ({
          headline: `${b.title} (${b.totalItems})`,
          id: b.tab
        })),
        onTabClick: (b, E, y) => {
          const m = t.map((f) => f.tab).find((f) => f === y);
          o({
            query: a,
            page: 1,
            activeTab: m
          });
        },
        appearance: "filter",
        initiallySelected: _,
        children: t.map((b) => /* @__PURE__ */ d(
          rr,
          {
            title: b.title,
            labels: p,
            tab: b.tab,
            resultVariant: b.variant,
            searchVariant: e,
            items: b.items,
            itemRenderer: u,
            totalItems: b.totalItems,
            totalResultsFoundText: l,
            onPagePrefetch: (E, y) => h == null ? void 0 : h(E, y),
            onPageChange: (E, y) => {
              o({
                query: a,
                page: y,
                activeTab: E
              });
            },
            currentPage: c,
            isTabSwitchLoading: g
          },
          `roche-search-accordion-item-${b.tab}-${b.totalItems}`
        ))
      }
    ) });
  {
    const b = a.trim().length > 0, E = n && n.length > 0, y = n ? n.findIndex((f) => f === r) : -1, m = (f) => {
      o({
        query: a,
        page: 1,
        activeTab: i,
        activeSubtab: f
      });
    };
    return /* @__PURE__ */ I(ze, { children: [
      /* @__PURE__ */ I("div", { className: K["search__filter-tabs"], children: [
        (!b || s) && /* @__PURE__ */ d(
          zn,
          {
            tabs: t.map((f) => ({
              headline: f.title,
              id: f.tab
            })),
            onTabClick: (f, v, w) => {
              const T = t.map((N) => N.tab).find((N) => N === w);
              o({
                query: a,
                page: 1,
                activeTab: T,
                activeSubtab: r
              });
            },
            appearance: "filter",
            initiallySelected: _
          }
        ),
        E && /* @__PURE__ */ d(
          zn,
          {
            hasMarginTop: !1,
            tabs: n.map((f) => ({
              headline: f,
              id: f
            })),
            onTabClick: (f, v, w) => {
              const T = n.find((N) => N === w);
              m(T);
            },
            appearance: "filter",
            initiallySelected: y
          }
        )
      ] }),
      /* @__PURE__ */ d("div", { children: t.filter((f) => f.tab === i).map((f) => /* @__PURE__ */ d(
        rr,
        {
          title: f.title,
          labels: p,
          tab: f.tab,
          resultVariant: f.variant,
          searchVariant: e,
          itemRenderer: u,
          items: f.items,
          totalItems: f.totalItems,
          totalResultsFoundText: l,
          onPageChange: (v, w) => {
            o({
              query: a,
              page: w,
              activeTab: v
            });
          },
          onPagePrefetch: h,
          currentPage: c,
          isTabSwitchLoading: g
        },
        `roche-search-accordion-item-${f.tab}-${f.totalItems}`
      )) })
    ] });
  }
}, rr = ({
  tab: e,
  resultVariant: t,
  searchVariant: n,
  items: i,
  totalItems: r,
  currentPage: s,
  onPageChange: a,
  onPagePrefetch: o,
  totalResultsFoundText: c,
  itemRenderer: l,
  labels: u,
  isTabSwitchLoading: p
}) => {
  const h = () => {
    if (i.length === 0) return null;
    const _ = i.map((E, y) => l(E, e, y, s));
    if (t === "stories")
      return (
        // TODO: When refactoring teaser-wall, make sure the items are rendered in an UL/LI construct
        // as the other teasers for a11y improvements.
        /* @__PURE__ */ d(
          "roche-teaser-wall",
          {
            className: L(K["search__teaser-container"], {
              [K["search__teaser-container--loading"]]: p
            }),
            children: _
          },
          "teaser-wall-container"
        )
      );
    const b = i.map((E, y) => (
      // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
      /* @__PURE__ */ d("li", { children: l(E, e, y, s) }, `teaser-${y}`)
    ));
    return /* @__PURE__ */ d(
      "div",
      {
        className: L(
          K["search__teaser-container"],
          n === "main" ? K["search__teaser-container--eight-columns"] : "",
          {
            [K["search__teaser-container--loading"]]: p
          }
        ),
        children: /* @__PURE__ */ d("ul", { className: K["search__results-list"], children: b })
      },
      "teaser-container"
    );
  }, g = r / (n === "main" ? 6 : 10);
  return /* @__PURE__ */ I("div", { children: [
    i.length === 0 && n === "main" && /* @__PURE__ */ I("div", { className: K["search__no-results"], role: "status", "aria-live": "polite", children: [
      /* @__PURE__ */ d("h4", { className: K["search__no-results-title"], children: u.noResultsTitle }),
      /* @__PURE__ */ d("p", { className: K["search__no-results-message"], children: u.noResultsMessage })
    ] }),
    i.length === 0 && n === "data" && /* @__PURE__ */ d("div", { className: K["search__no-results"], role: "status", "aria-live": "polite", children: /* @__PURE__ */ d("p", { className: K["search__no-results-message"], children: u.noResultsMessage }) }),
    i.length > 0 && /* @__PURE__ */ I(ze, { children: [
      /* @__PURE__ */ d("h2", { className: K["search__results-heading"], "aria-live": "polite", "aria-atomic": "true", children: c.replace(/\$0/g, `${r}`) }),
      h(),
      Math.ceil(g) > 0 && /* @__PURE__ */ d(
        Rd,
        {
          className: L(
            K.search__pagination,
            t !== "stories" && n === "main" ? K["search__pagination--eight-columns"] : ""
          ),
          onPageChange: (_) => a(e, _),
          totalPages: g,
          activePage: s,
          visiblePages: n === "main" ? 7 : 8,
          onPagePrefetch: (_) => o == null ? void 0 : o(e, _)
        }
      )
    ] })
  ] });
};
var nn = /* @__PURE__ */ ((e) => (e[e.INPUT = 0] = "INPUT", e[e.POPULAR_SEARCHES = 1] = "POPULAR_SEARCHES", e))(nn || {});
const Jh = (e) => {
  const {
    labels: t,
    searchState: n,
    onSearchParamsChange: i,
    searchResults: r,
    subtabs: s,
    isLoading: a,
    hasQueriesBeenFetched: o,
    variant: c,
    showInput: l,
    resultsRef: u,
    alwaysShowTabs: p = !1
  } = e, h = n.query, g = n.page, _ = n.activeTab, b = n.activeSubtab, E = t.totalResultsFoundText.replace("{totalResults}", "{0}"), y = r.some((S) => S.items.length > 0), m = () => {
    i({
      query: "",
      page: 1,
      activeTab: _,
      trigger: nn.INPUT
    });
  }, f = (S, k) => {
    i({
      query: k,
      page: 1,
      activeTab: _,
      trigger: S
    });
  }, v = h.trim().length > 0, w = c === "main" && e.support && !a && !y && !v, T = c === "data" && a && y, N = (a || v && !y && !o) && !T, A = r.reduce((S, k) => S + k.totalItems, 0), R = () => v ? a && !y ? e.ariaLabels.searchingFor.replace("{searchQuery}", h) : A === 0 ? e.ariaLabels.noResultsFoundFor.replace("{searchQuery}", h) : e.ariaLabels.resultsFoundFor.replace("{totalResults}", `${A}`).replace("{searchQuery}", h) : "";
  return /* @__PURE__ */ I(
    "div",
    {
      className: L(
        K.search,
        c === "data" ? K["data-search"] : "",
        c === "data" && l ? K["data-search--with-input"] : ""
      ),
      children: [
        /* @__PURE__ */ d("div", { className: K["search__sr-announcement"], "aria-live": "polite", "aria-atomic": "true", role: "status", children: R() }),
        c === "main" && t.searchTitle && /* @__PURE__ */ d("h1", { className: K.search__title, children: t.searchTitle }),
        /* @__PURE__ */ I("div", { ref: u, children: [
          l && /* @__PURE__ */ d("div", { className: K["search__input-container"], children: /* @__PURE__ */ d(
            jd,
            {
              placeholder: t.searchPlaceholder,
              value: h,
              onClear: m,
              onChange: (S) => f(nn.INPUT, S.target.value),
              ariaLabels: {
                siteSearch: e.ariaLabels.siteSearch,
                searchInputLabel: e.ariaLabels.searchInputLabel,
                searchInputDescription: e.ariaLabels.searchInputDescription,
                clearSearchTerm: e.ariaLabels.clearSearchTerm
              }
            }
          ) }),
          N && /* @__PURE__ */ d("div", { className: K["search__loading-container"], children: /* @__PURE__ */ d(gd, { loadingText: t.loadingText }) }),
          w && /* @__PURE__ */ I("div", { className: K["search__support-content-wrapper"], children: [
            /* @__PURE__ */ d(
              Ud,
              {
                className: K["search__popular-searches"],
                title: e.support.labels.popularSearchesTitle,
                popularSearches: e.support.popularSearches,
                onPopularSearchTermClick: (S) => f(nn.POPULAR_SEARCHES, S)
              }
            ),
            /* @__PURE__ */ I("section", { className: K["search__quick-links"], "aria-labelledby": "quick-links-title", children: [
              /* @__PURE__ */ d("h2", { id: "quick-links-title", className: K["search__quick-links-title"], children: e.support.labels.quickLinksTitle }),
              /* @__PURE__ */ d("ul", { children: e.support.quick_links.map((S, k) => /* @__PURE__ */ d("li", { children: S }, `quick-link-${k}`)) })
            ] })
          ] }),
          !N && (c === "data" || !w) && /* @__PURE__ */ d("div", { className: K["search__results-container"], "aria-busy": a, children: /* @__PURE__ */ d(
            Jd,
            {
              variant: c,
              labels: {
                noResultsMessage: e.labels.noResultsMessage,
                noResultsTitle: e.labels.noResultsTitle
              },
              alwaysShowTabs: p,
              tabs: r,
              subtabs: s,
              itemRenderer: e.itemRenderer,
              currentTab: _,
              currentSubtab: b,
              searchQuery: h,
              setSearchParams: i,
              currentPage: g,
              totalResultFoundText: E,
              onPagePrefetch: e.onPagePrefetch,
              isTabSwitchLoading: T
            }
          ) })
        ] })
      ]
    }
  );
}, eu = "select", tu = "select__label", nu = "select__error", se = {
  select: eu,
  "select__native-input": "select__native-input",
  "select__native-input-custom-control": "select__native-input-custom-control",
  "select__native-input-custom-control--invalid": "select__native-input-custom-control--invalid",
  "select__native-input-icon": "select__native-input-icon",
  "select__native-input-icon--disabled": "select__native-input-icon--disabled",
  "select__input-wrapper": "select__input-wrapper",
  "select__label-wrapper": "select__label-wrapper",
  "select--disabled": "select--disabled",
  select__label: tu,
  "select__label--disabled": "select__label--disabled",
  "select__item-label": "select__item-label",
  "select__item-label--disabled": "select__item-label--disabled",
  "select__item-label-end": "select__item-label-end",
  select__error: nu,
  "select__error-text": "select__error-text"
}, ef = ({
  disabled: e,
  label: t,
  options: n,
  isMultiSelect: i,
  showError: r,
  required: s = !1,
  tooltip: a,
  tooltipAriaLabel: o,
  selected: c,
  onBlur: l,
  onSelect: u,
  error: p,
  ...h
}) => {
  const g = i ? "checkbox" : "radio", _ = iu(t) || "selectGroupName", b = (v) => {
    u(v);
  }, E = () => {
    l == null || l();
  }, y = (v) => i && Array.isArray(c) ? c.includes(v) : c === v, m = (v, w) => {
    v.key === "Enter" && i && b(w);
  }, f = L(se.select, e && se["select--disabled"]);
  return /* @__PURE__ */ I("div", { className: f, children: [
    /* @__PURE__ */ I("div", { className: se["select__label-wrapper"], children: [
      /* @__PURE__ */ d("span", { className: L(se.select__label, e && se["select__label--disabled"]), children: mi(s, t) }),
      a && /* @__PURE__ */ d(xi, { ariaLabel: o, children: a })
    ] }),
    n.map((v, w) => {
      const T = y(v.value || v.label), N = `select-item-${v.value}-${w}`, A = `${N}-error`;
      return /* @__PURE__ */ I("label", { className: se["select__input-wrapper"], children: [
        /* @__PURE__ */ d(
          "input",
          {
            type: g,
            id: N,
            name: _,
            value: v.value || v.label,
            required: s,
            checked: T,
            disabled: e,
            onChange: () => b(v),
            onBlur: E,
            className: se["select__native-input"],
            onKeyDown: (R) => m(R, v),
            "aria-invalid": r,
            "aria-describedby": r ? A : void 0,
            ...h
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            className: L(
              se["select__native-input-custom-control"],
              r && se["select__native-input-custom-control--invalid"]
            ),
            children: T && /* @__PURE__ */ d(
              "div",
              {
                className: L(
                  se["select__native-input-icon"],
                  e && se["select__native-input-icon--disabled"]
                ),
                children: /* @__PURE__ */ d(F, { icon: i ? "checkmark" : "circle" })
              }
            )
          }
        ),
        /* @__PURE__ */ I("span", { className: L(se["select__item-label"], e && se["select__item-label--disabled"]), children: [
          /* @__PURE__ */ d("span", { className: se["select__item-label-text"], children: v.label }),
          v.labelEnd && /* @__PURE__ */ d("span", { className: se["select__item-label-end"], children: v.labelEnd })
        ] })
      ] }, N);
    }),
    /* @__PURE__ */ d("div", { className: se.select__error, children: r && p && /* @__PURE__ */ I(ze, { children: [
      /* @__PURE__ */ d(F, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ d("p", { id: `error-${t}`, role: "alert", className: se["select__error-text"], children: p })
    ] }) })
  ] });
}, iu = (e) => e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, ""), vt = {
  "side-by-side": "side-by-side",
  "side-by-side--right": "side-by-side--right",
  "side-by-side--space-between": "side-by-side--space-between",
  "side-by-side--top": "side-by-side--top",
  "side-by-side--bottom": "side-by-side--bottom",
  "side-by-side--equal-ratio": "side-by-side--equal-ratio"
};
var rn = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e.SPACE_BETWEEN = "space-between", e))(rn || {}), sn = /* @__PURE__ */ ((e) => (e.TOP = "top", e.MIDDLE = "middle", e.BOTTOM = "bottom", e))(sn || {});
const tf = ({
  horizontalAlignment: e = rn.LEFT,
  verticalAlignment: t = sn.MIDDLE,
  equalRatio: n = !1,
  children: i
}) => {
  const r = L(
    vt["side-by-side"],
    e === rn.RIGHT && vt["side-by-side--right"],
    e === rn.SPACE_BETWEEN && vt["side-by-side--space-between"],
    t === sn.TOP && vt["side-by-side--top"],
    t === sn.BOTTOM && vt["side-by-side--bottom"],
    n && vt["side-by-side--equal-ratio"]
  );
  return /* @__PURE__ */ d("div", { className: r, children: i });
};
function sr(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function Ni(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {});
  const n = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((i) => n.indexOf(i) < 0).forEach((i) => {
    typeof e[i] > "u" ? e[i] = t[i] : sr(t[i]) && sr(e[i]) && Object.keys(t[i]).length > 0 && Ni(e[i], t[i]);
  });
}
const Xr = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Ze() {
  const e = typeof document < "u" ? document : {};
  return Ni(e, Xr), e;
}
const ru = {
  document: Xr,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function me() {
  const e = typeof window < "u" ? window : {};
  return Ni(e, ru), e;
}
function su(e) {
  return e === void 0 && (e = ""), e.trim().split(" ").filter((t) => !!t.trim());
}
function au(e) {
  const t = e;
  Object.keys(t).forEach((n) => {
    try {
      t[n] = null;
    } catch {
    }
    try {
      delete t[n];
    } catch {
    }
  });
}
function oi(e, t) {
  return t === void 0 && (t = 0), setTimeout(e, t);
}
function gn() {
  return Date.now();
}
function ou(e) {
  const t = me();
  let n;
  return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n;
}
function lu(e, t) {
  t === void 0 && (t = "x");
  const n = me();
  let i, r, s;
  const a = ou(e);
  return n.WebKitCSSMatrix ? (r = a.transform || a.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map((o) => o.replace(",", ".")).join(", ")), s = new n.WebKitCSSMatrix(r === "none" ? "" : r)) : (s = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), i = s.toString().split(",")), t === "x" && (n.WebKitCSSMatrix ? r = s.m41 : i.length === 16 ? r = parseFloat(i[12]) : r = parseFloat(i[4])), t === "y" && (n.WebKitCSSMatrix ? r = s.m42 : i.length === 16 ? r = parseFloat(i[13]) : r = parseFloat(i[5])), r || 0;
}
function Zt(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function cu(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function _e() {
  const e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < arguments.length; n += 1) {
    const i = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (i != null && !cu(i)) {
      const r = Object.keys(Object(i)).filter((s) => t.indexOf(s) < 0);
      for (let s = 0, a = r.length; s < a; s += 1) {
        const o = r[s], c = Object.getOwnPropertyDescriptor(i, o);
        c !== void 0 && c.enumerable && (Zt(e[o]) && Zt(i[o]) ? i[o].__swiper__ ? e[o] = i[o] : _e(e[o], i[o]) : !Zt(e[o]) && Zt(i[o]) ? (e[o] = {}, i[o].__swiper__ ? e[o] = i[o] : _e(e[o], i[o])) : e[o] = i[o]);
      }
    }
  }
  return e;
}
function Kt(e, t, n) {
  e.style.setProperty(t, n);
}
function Zr(e) {
  let {
    swiper: t,
    targetPosition: n,
    side: i
  } = e;
  const r = me(), s = -t.translate;
  let a = null, o;
  const c = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(t.cssModeFrameID);
  const l = n > s ? "next" : "prev", u = (h, g) => l === "next" && h >= g || l === "prev" && h <= g, p = () => {
    o = (/* @__PURE__ */ new Date()).getTime(), a === null && (a = o);
    const h = Math.max(Math.min((o - a) / c, 1), 0), g = 0.5 - Math.cos(h * Math.PI) / 2;
    let _ = s + g * (n - s);
    if (u(_, n) && (_ = n), t.wrapperEl.scrollTo({
      [i]: _
    }), u(_, n)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [i]: _
        });
      }), r.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = r.requestAnimationFrame(p);
  };
  p();
}
function Kr(e) {
  return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
}
function Ve(e, t) {
  t === void 0 && (t = "");
  const n = me(), i = [...e.children];
  return n.HTMLSlotElement && e instanceof HTMLSlotElement && i.push(...e.assignedElements()), t ? i.filter((r) => r.matches(t)) : i;
}
function du(e, t) {
  const n = [t];
  for (; n.length > 0; ) {
    const i = n.shift();
    if (e === i)
      return !0;
    n.push(...i.children, ...i.shadowRoot ? i.shadowRoot.children : [], ...i.assignedElements ? i.assignedElements() : []);
  }
}
function uu(e, t) {
  const n = me();
  let i = t.contains(e);
  return !i && n.HTMLSlotElement && t instanceof HTMLSlotElement && (i = [...t.assignedElements()].includes(e), i || (i = du(e, t))), i;
}
function _n(e) {
  try {
    console.warn(e);
    return;
  } catch {
  }
}
function Dt(e, t) {
  t === void 0 && (t = []);
  const n = document.createElement(e);
  return n.classList.add(...Array.isArray(t) ? t : su(t)), n;
}
function pu(e, t) {
  const n = [];
  for (; e.previousElementSibling; ) {
    const i = e.previousElementSibling;
    t ? i.matches(t) && n.push(i) : n.push(i), e = i;
  }
  return n;
}
function hu(e, t) {
  const n = [];
  for (; e.nextElementSibling; ) {
    const i = e.nextElementSibling;
    t ? i.matches(t) && n.push(i) : n.push(i), e = i;
  }
  return n;
}
function it(e, t) {
  return me().getComputedStyle(e, null).getPropertyValue(t);
}
function Vt(e) {
  let t = e, n;
  if (t) {
    for (n = 0; (t = t.previousSibling) !== null; )
      t.nodeType === 1 && (n += 1);
    return n;
  }
}
function Qr(e, t) {
  const n = [];
  let i = e.parentElement;
  for (; i; )
    t ? i.matches(t) && n.push(i) : n.push(i), i = i.parentElement;
  return n;
}
function fu(e, t) {
  function n(i) {
    i.target === e && (t.call(e, i), e.removeEventListener("transitionend", n));
  }
  t && e.addEventListener("transitionend", n);
}
function li(e, t, n) {
  const i = me();
  return e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(i.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(i.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom"));
}
function Z(e) {
  return (Array.isArray(e) ? e : [e]).filter((t) => !!t);
}
function ci(e, t) {
  t === void 0 && (t = ""), typeof trustedTypes < "u" ? e.innerHTML = trustedTypes.createPolicy("html", {
    createHTML: (n) => n
  }).createHTML(t) : e.innerHTML = t;
}
let Hn;
function mu() {
  const e = me(), t = Ze();
  return {
    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
  };
}
function Jr() {
  return Hn || (Hn = mu()), Hn;
}
let Bn;
function gu(e) {
  let {
    userAgent: t
  } = e === void 0 ? {} : e;
  const n = Jr(), i = me(), r = i.navigator.platform, s = t || i.navigator.userAgent, a = {
    ios: !1,
    android: !1
  }, o = i.screen.width, c = i.screen.height, l = s.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = s.match(/(iPad).*OS\s([\d_]+)/);
  const p = s.match(/(iPod)(.*OS\s([\d_]+))?/), h = !u && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/), g = r === "Win32";
  let _ = r === "MacIntel";
  const b = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && _ && n.touch && b.indexOf(`${o}x${c}`) >= 0 && (u = s.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), _ = !1), l && !g && (a.os = "android", a.android = !0), (u || h || p) && (a.os = "ios", a.ios = !0), a;
}
function es(e) {
  return e === void 0 && (e = {}), Bn || (Bn = gu(e)), Bn;
}
let Fn;
function _u() {
  const e = me(), t = es();
  let n = !1;
  function i() {
    const o = e.navigator.userAgent.toLowerCase();
    return o.indexOf("safari") >= 0 && o.indexOf("chrome") < 0 && o.indexOf("android") < 0;
  }
  if (i()) {
    const o = String(e.navigator.userAgent);
    if (o.includes("Version/")) {
      const [c, l] = o.split("Version/")[1].split(" ")[0].split(".").map((u) => Number(u));
      n = c < 16 || c === 16 && l < 2;
    }
  }
  const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), s = i(), a = s || r && t.ios;
  return {
    isSafari: n || s,
    needPerspectiveFix: n,
    need3dFix: a,
    isWebView: r
  };
}
function ts() {
  return Fn || (Fn = _u()), Fn;
}
function vu(e) {
  let {
    swiper: t,
    on: n,
    emit: i
  } = e;
  const r = me();
  let s = null, a = null;
  const o = () => {
    !t || t.destroyed || !t.initialized || (i("beforeResize"), i("resize"));
  }, c = () => {
    !t || t.destroyed || !t.initialized || (s = new ResizeObserver((p) => {
      a = r.requestAnimationFrame(() => {
        const {
          width: h,
          height: g
        } = t;
        let _ = h, b = g;
        p.forEach((E) => {
          let {
            contentBoxSize: y,
            contentRect: m,
            target: f
          } = E;
          f && f !== t.el || (_ = m ? m.width : (y[0] || y).inlineSize, b = m ? m.height : (y[0] || y).blockSize);
        }), (_ !== h || b !== g) && o();
      });
    }), s.observe(t.el));
  }, l = () => {
    a && r.cancelAnimationFrame(a), s && s.unobserve && t.el && (s.unobserve(t.el), s = null);
  }, u = () => {
    !t || t.destroyed || !t.initialized || i("orientationchange");
  };
  n("init", () => {
    if (t.params.resizeObserver && typeof r.ResizeObserver < "u") {
      c();
      return;
    }
    r.addEventListener("resize", o), r.addEventListener("orientationchange", u);
  }), n("destroy", () => {
    l(), r.removeEventListener("resize", o), r.removeEventListener("orientationchange", u);
  });
}
function wu(e) {
  let {
    swiper: t,
    extendParams: n,
    on: i,
    emit: r
  } = e;
  const s = [], a = me(), o = function(u, p) {
    p === void 0 && (p = {});
    const h = a.MutationObserver || a.WebkitMutationObserver, g = new h((_) => {
      if (t.__preventObserver__) return;
      if (_.length === 1) {
        r("observerUpdate", _[0]);
        return;
      }
      const b = function() {
        r("observerUpdate", _[0]);
      };
      a.requestAnimationFrame ? a.requestAnimationFrame(b) : a.setTimeout(b, 0);
    });
    g.observe(u, {
      attributes: typeof p.attributes > "u" ? !0 : p.attributes,
      childList: t.isElement || (typeof p.childList > "u" ? !0 : p).childList,
      characterData: typeof p.characterData > "u" ? !0 : p.characterData
    }), s.push(g);
  }, c = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const u = Qr(t.hostEl);
        for (let p = 0; p < u.length; p += 1)
          o(u[p]);
      }
      o(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), o(t.wrapperEl, {
        attributes: !1
      });
    }
  }, l = () => {
    s.forEach((u) => {
      u.disconnect();
    }), s.splice(0, s.length);
  };
  n({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), i("init", c), i("destroy", l);
}
var bu = {
  on(e, t, n) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof t != "function") return i;
    const r = n ? "unshift" : "push";
    return e.split(" ").forEach((s) => {
      i.eventsListeners[s] || (i.eventsListeners[s] = []), i.eventsListeners[s][r](t);
    }), i;
  },
  once(e, t, n) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof t != "function") return i;
    function r() {
      i.off(e, r), r.__emitterProxy && delete r.__emitterProxy;
      for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
        a[o] = arguments[o];
      t.apply(i, a);
    }
    return r.__emitterProxy = t, i.on(e, r, n);
  },
  onAny(e, t) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    const i = t ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[i](e), n;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
    const n = t.eventsAnyListeners.indexOf(e);
    return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
  },
  off(e, t) {
    const n = this;
    return !n.eventsListeners || n.destroyed || !n.eventsListeners || e.split(" ").forEach((i) => {
      typeof t > "u" ? n.eventsListeners[i] = [] : n.eventsListeners[i] && n.eventsListeners[i].forEach((r, s) => {
        (r === t || r.__emitterProxy && r.__emitterProxy === t) && n.eventsListeners[i].splice(s, 1);
      });
    }), n;
  },
  emit() {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
    let t, n, i;
    for (var r = arguments.length, s = new Array(r), a = 0; a < r; a++)
      s[a] = arguments[a];
    return typeof s[0] == "string" || Array.isArray(s[0]) ? (t = s[0], n = s.slice(1, s.length), i = e) : (t = s[0].events, n = s[0].data, i = s[0].context || e), n.unshift(i), (Array.isArray(t) ? t : t.split(" ")).forEach((c) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((l) => {
        l.apply(i, [c, ...n]);
      }), e.eventsListeners && e.eventsListeners[c] && e.eventsListeners[c].forEach((l) => {
        l.apply(i, n);
      });
    }), e;
  }
};
function yu() {
  const e = this;
  let t, n;
  const i = e.el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = i.clientWidth, typeof e.params.height < "u" && e.params.height !== null ? n = e.params.height : n = i.clientHeight, !(t === 0 && e.isHorizontal() || n === 0 && e.isVertical()) && (t = t - parseInt(it(i, "padding-left") || 0, 10) - parseInt(it(i, "padding-right") || 0, 10), n = n - parseInt(it(i, "padding-top") || 0, 10) - parseInt(it(i, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
    width: t,
    height: n,
    size: e.isHorizontal() ? t : n
  }));
}
function xu() {
  const e = this;
  function t(S, k) {
    return parseFloat(S.getPropertyValue(e.getDirectionLabel(k)) || 0);
  }
  const n = e.params, {
    wrapperEl: i,
    slidesEl: r,
    size: s,
    rtlTranslate: a,
    wrongRTL: o
  } = e, c = e.virtual && n.virtual.enabled, l = c ? e.virtual.slides.length : e.slides.length, u = Ve(r, `.${e.params.slideClass}, swiper-slide`), p = c ? e.virtual.slides.length : u.length;
  let h = [];
  const g = [], _ = [];
  let b = n.slidesOffsetBefore;
  typeof b == "function" && (b = n.slidesOffsetBefore.call(e));
  let E = n.slidesOffsetAfter;
  typeof E == "function" && (E = n.slidesOffsetAfter.call(e));
  const y = e.snapGrid.length, m = e.slidesGrid.length;
  let f = n.spaceBetween, v = -b, w = 0, T = 0;
  if (typeof s > "u")
    return;
  typeof f == "string" && f.indexOf("%") >= 0 ? f = parseFloat(f.replace("%", "")) / 100 * s : typeof f == "string" && (f = parseFloat(f)), e.virtualSize = -f, u.forEach((S) => {
    a ? S.style.marginLeft = "" : S.style.marginRight = "", S.style.marginBottom = "", S.style.marginTop = "";
  }), n.centeredSlides && n.cssMode && (Kt(i, "--swiper-centered-offset-before", ""), Kt(i, "--swiper-centered-offset-after", ""));
  const N = n.grid && n.grid.rows > 1 && e.grid;
  N ? e.grid.initSlides(u) : e.grid && e.grid.unsetSlides();
  let A;
  const R = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((S) => typeof n.breakpoints[S].slidesPerView < "u").length > 0;
  for (let S = 0; S < p; S += 1) {
    A = 0;
    let k;
    if (u[S] && (k = u[S]), N && e.grid.updateSlide(S, k, u), !(u[S] && it(k, "display") === "none")) {
      if (n.slidesPerView === "auto") {
        R && (u[S].style[e.getDirectionLabel("width")] = "");
        const P = getComputedStyle(k), D = k.style.transform, V = k.style.webkitTransform;
        if (D && (k.style.transform = "none"), V && (k.style.webkitTransform = "none"), n.roundLengths)
          A = e.isHorizontal() ? li(k, "width") : li(k, "height");
        else {
          const z = t(P, "width"), O = t(P, "padding-left"), C = t(P, "padding-right"), M = t(P, "margin-left"), $ = t(P, "margin-right"), q = P.getPropertyValue("box-sizing");
          if (q && q === "border-box")
            A = z + M + $;
          else {
            const {
              clientWidth: ie,
              offsetWidth: H
            } = k;
            A = z + O + C + M + $ + (H - ie);
          }
        }
        D && (k.style.transform = D), V && (k.style.webkitTransform = V), n.roundLengths && (A = Math.floor(A));
      } else
        A = (s - (n.slidesPerView - 1) * f) / n.slidesPerView, n.roundLengths && (A = Math.floor(A)), u[S] && (u[S].style[e.getDirectionLabel("width")] = `${A}px`);
      u[S] && (u[S].swiperSlideSize = A), _.push(A), n.centeredSlides ? (v = v + A / 2 + w / 2 + f, w === 0 && S !== 0 && (v = v - s / 2 - f), S === 0 && (v = v - s / 2 - f), Math.abs(v) < 1 / 1e3 && (v = 0), n.roundLengths && (v = Math.floor(v)), T % n.slidesPerGroup === 0 && h.push(v), g.push(v)) : (n.roundLengths && (v = Math.floor(v)), (T - Math.min(e.params.slidesPerGroupSkip, T)) % e.params.slidesPerGroup === 0 && h.push(v), g.push(v), v = v + A + f), e.virtualSize += A + f, w = A, T += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, s) + E, a && o && (n.effect === "slide" || n.effect === "coverflow") && (i.style.width = `${e.virtualSize + f}px`), n.setWrapperSize && (i.style[e.getDirectionLabel("width")] = `${e.virtualSize + f}px`), N && e.grid.updateWrapperSize(A, h), !n.centeredSlides) {
    const S = [];
    for (let k = 0; k < h.length; k += 1) {
      let P = h[k];
      n.roundLengths && (P = Math.floor(P)), h[k] <= e.virtualSize - s && S.push(P);
    }
    h = S, Math.floor(e.virtualSize - s) - Math.floor(h[h.length - 1]) > 1 && h.push(e.virtualSize - s);
  }
  if (c && n.loop) {
    const S = _[0] + f;
    if (n.slidesPerGroup > 1) {
      const k = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / n.slidesPerGroup), P = S * n.slidesPerGroup;
      for (let D = 0; D < k; D += 1)
        h.push(h[h.length - 1] + P);
    }
    for (let k = 0; k < e.virtual.slidesBefore + e.virtual.slidesAfter; k += 1)
      n.slidesPerGroup === 1 && h.push(h[h.length - 1] + S), g.push(g[g.length - 1] + S), e.virtualSize += S;
  }
  if (h.length === 0 && (h = [0]), f !== 0) {
    const S = e.isHorizontal() && a ? "marginLeft" : e.getDirectionLabel("marginRight");
    u.filter((k, P) => !n.cssMode || n.loop ? !0 : P !== u.length - 1).forEach((k) => {
      k.style[S] = `${f}px`;
    });
  }
  if (n.centeredSlides && n.centeredSlidesBounds) {
    let S = 0;
    _.forEach((P) => {
      S += P + (f || 0);
    }), S -= f;
    const k = S > s ? S - s : 0;
    h = h.map((P) => P <= 0 ? -b : P > k ? k + E : P);
  }
  if (n.centerInsufficientSlides) {
    let S = 0;
    _.forEach((P) => {
      S += P + (f || 0);
    }), S -= f;
    const k = (n.slidesOffsetBefore || 0) + (n.slidesOffsetAfter || 0);
    if (S + k < s) {
      const P = (s - S - k) / 2;
      h.forEach((D, V) => {
        h[V] = D - P;
      }), g.forEach((D, V) => {
        g[V] = D + P;
      });
    }
  }
  if (Object.assign(e, {
    slides: u,
    snapGrid: h,
    slidesGrid: g,
    slidesSizesGrid: _
  }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
    Kt(i, "--swiper-centered-offset-before", `${-h[0]}px`), Kt(i, "--swiper-centered-offset-after", `${e.size / 2 - _[_.length - 1] / 2}px`);
    const S = -e.snapGrid[0], k = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((P) => P + S), e.slidesGrid = e.slidesGrid.map((P) => P + k);
  }
  if (p !== l && e.emit("slidesLengthChange"), h.length !== y && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), g.length !== m && e.emit("slidesGridLengthChange"), n.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !c && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
    const S = `${n.containerModifierClass}backface-hidden`, k = e.el.classList.contains(S);
    p <= n.maxBackfaceHiddenSlides ? k || e.el.classList.add(S) : k && e.el.classList.remove(S);
  }
}
function Eu(e) {
  const t = this, n = [], i = t.virtual && t.params.virtual.enabled;
  let r = 0, s;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const a = (o) => i ? t.slides[t.getSlideIndexByData(o)] : t.slides[o];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || []).forEach((o) => {
        n.push(o);
      });
    else
      for (s = 0; s < Math.ceil(t.params.slidesPerView); s += 1) {
        const o = t.activeIndex + s;
        if (o > t.slides.length && !i) break;
        n.push(a(o));
      }
  else
    n.push(a(t.activeIndex));
  for (s = 0; s < n.length; s += 1)
    if (typeof n[s] < "u") {
      const o = n[s].offsetHeight;
      r = o > r ? o : r;
    }
  (r || r === 0) && (t.wrapperEl.style.height = `${r}px`);
}
function Su() {
  const e = this, t = e.slides, n = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
  for (let i = 0; i < t.length; i += 1)
    t[i].swiperSlideOffset = (e.isHorizontal() ? t[i].offsetLeft : t[i].offsetTop) - n - e.cssOverflowAdjustment();
}
const ar = (e, t, n) => {
  t && !e.classList.contains(n) ? e.classList.add(n) : !t && e.classList.contains(n) && e.classList.remove(n);
};
function Tu(e) {
  e === void 0 && (e = this && this.translate || 0);
  const t = this, n = t.params, {
    slides: i,
    rtlTranslate: r,
    snapGrid: s
  } = t;
  if (i.length === 0) return;
  typeof i[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let a = -e;
  r && (a = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  let o = n.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : typeof o == "string" && (o = parseFloat(o));
  for (let c = 0; c < i.length; c += 1) {
    const l = i[c];
    let u = l.swiperSlideOffset;
    n.cssMode && n.centeredSlides && (u -= i[0].swiperSlideOffset);
    const p = (a + (n.centeredSlides ? t.minTranslate() : 0) - u) / (l.swiperSlideSize + o), h = (a - s[0] + (n.centeredSlides ? t.minTranslate() : 0) - u) / (l.swiperSlideSize + o), g = -(a - u), _ = g + t.slidesSizesGrid[c], b = g >= 0 && g <= t.size - t.slidesSizesGrid[c], E = g >= 0 && g < t.size - 1 || _ > 1 && _ <= t.size || g <= 0 && _ >= t.size;
    E && (t.visibleSlides.push(l), t.visibleSlidesIndexes.push(c)), ar(l, E, n.slideVisibleClass), ar(l, b, n.slideFullyVisibleClass), l.progress = r ? -p : p, l.originalProgress = r ? -h : h;
  }
}
function Nu(e) {
  const t = this;
  if (typeof e > "u") {
    const u = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * u || 0;
  }
  const n = t.params, i = t.maxTranslate() - t.minTranslate();
  let {
    progress: r,
    isBeginning: s,
    isEnd: a,
    progressLoop: o
  } = t;
  const c = s, l = a;
  if (i === 0)
    r = 0, s = !0, a = !0;
  else {
    r = (e - t.minTranslate()) / i;
    const u = Math.abs(e - t.minTranslate()) < 1, p = Math.abs(e - t.maxTranslate()) < 1;
    s = u || r <= 0, a = p || r >= 1, u && (r = 0), p && (r = 1);
  }
  if (n.loop) {
    const u = t.getSlideIndexByData(0), p = t.getSlideIndexByData(t.slides.length - 1), h = t.slidesGrid[u], g = t.slidesGrid[p], _ = t.slidesGrid[t.slidesGrid.length - 1], b = Math.abs(e);
    b >= h ? o = (b - h) / _ : o = (b + _ - g) / _, o > 1 && (o -= 1);
  }
  Object.assign(t, {
    progress: r,
    progressLoop: o,
    isBeginning: s,
    isEnd: a
  }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), s && !c && t.emit("reachBeginning toEdge"), a && !l && t.emit("reachEnd toEdge"), (c && !s || l && !a) && t.emit("fromEdge"), t.emit("progress", r);
}
const Gn = (e, t, n) => {
  t && !e.classList.contains(n) ? e.classList.add(n) : !t && e.classList.contains(n) && e.classList.remove(n);
};
function Cu() {
  const e = this, {
    slides: t,
    params: n,
    slidesEl: i,
    activeIndex: r
  } = e, s = e.virtual && n.virtual.enabled, a = e.grid && n.grid && n.grid.rows > 1, o = (p) => Ve(i, `.${n.slideClass}${p}, swiper-slide${p}`)[0];
  let c, l, u;
  if (s)
    if (n.loop) {
      let p = r - e.virtual.slidesBefore;
      p < 0 && (p = e.virtual.slides.length + p), p >= e.virtual.slides.length && (p -= e.virtual.slides.length), c = o(`[data-swiper-slide-index="${p}"]`);
    } else
      c = o(`[data-swiper-slide-index="${r}"]`);
  else
    a ? (c = t.find((p) => p.column === r), u = t.find((p) => p.column === r + 1), l = t.find((p) => p.column === r - 1)) : c = t[r];
  c && (a || (u = hu(c, `.${n.slideClass}, swiper-slide`)[0], n.loop && !u && (u = t[0]), l = pu(c, `.${n.slideClass}, swiper-slide`)[0], n.loop && !l === 0 && (l = t[t.length - 1]))), t.forEach((p) => {
    Gn(p, p === c, n.slideActiveClass), Gn(p, p === u, n.slideNextClass), Gn(p, p === l, n.slidePrevClass);
  }), e.emitSlidesClasses();
}
const an = (e, t) => {
  if (!e || e.destroyed || !e.params) return;
  const n = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, i = t.closest(n());
  if (i) {
    let r = i.querySelector(`.${e.params.lazyPreloaderClass}`);
    !r && e.isElement && (i.shadowRoot ? r = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      i.shadowRoot && (r = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), r && r.remove());
    })), r && r.remove();
  }
}, Un = (e, t) => {
  if (!e.slides[t]) return;
  const n = e.slides[t].querySelector('[loading="lazy"]');
  n && n.removeAttribute("loading");
}, di = (e) => {
  if (!e || e.destroyed || !e.params) return;
  let t = e.params.lazyPreloadPrevNext;
  const n = e.slides.length;
  if (!n || !t || t < 0) return;
  t = Math.min(t, n);
  const i = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), r = e.activeIndex;
  if (e.params.grid && e.params.grid.rows > 1) {
    const a = r, o = [a - t];
    o.push(...Array.from({
      length: t
    }).map((c, l) => a + i + l)), e.slides.forEach((c, l) => {
      o.includes(c.column) && Un(e, l);
    });
    return;
  }
  const s = r + i - 1;
  if (e.params.rewind || e.params.loop)
    for (let a = r - t; a <= s + t; a += 1) {
      const o = (a % n + n) % n;
      (o < r || o > s) && Un(e, o);
    }
  else
    for (let a = Math.max(r - t, 0); a <= Math.min(s + t, n - 1); a += 1)
      a !== r && (a > s || a < r) && Un(e, a);
};
function Au(e) {
  const {
    slidesGrid: t,
    params: n
  } = e, i = e.rtlTranslate ? e.translate : -e.translate;
  let r;
  for (let s = 0; s < t.length; s += 1)
    typeof t[s + 1] < "u" ? i >= t[s] && i < t[s + 1] - (t[s + 1] - t[s]) / 2 ? r = s : i >= t[s] && i < t[s + 1] && (r = s + 1) : i >= t[s] && (r = s);
  return n.normalizeSlideIndex && (r < 0 || typeof r > "u") && (r = 0), r;
}
function Mu(e) {
  const t = this, n = t.rtlTranslate ? t.translate : -t.translate, {
    snapGrid: i,
    params: r,
    activeIndex: s,
    realIndex: a,
    snapIndex: o
  } = t;
  let c = e, l;
  const u = (g) => {
    let _ = g - t.virtual.slidesBefore;
    return _ < 0 && (_ = t.virtual.slides.length + _), _ >= t.virtual.slides.length && (_ -= t.virtual.slides.length), _;
  };
  if (typeof c > "u" && (c = Au(t)), i.indexOf(n) >= 0)
    l = i.indexOf(n);
  else {
    const g = Math.min(r.slidesPerGroupSkip, c);
    l = g + Math.floor((c - g) / r.slidesPerGroup);
  }
  if (l >= i.length && (l = i.length - 1), c === s && !t.params.loop) {
    l !== o && (t.snapIndex = l, t.emit("snapIndexChange"));
    return;
  }
  if (c === s && t.params.loop && t.virtual && t.params.virtual.enabled) {
    t.realIndex = u(c);
    return;
  }
  const p = t.grid && r.grid && r.grid.rows > 1;
  let h;
  if (t.virtual && r.virtual.enabled && r.loop)
    h = u(c);
  else if (p) {
    const g = t.slides.find((b) => b.column === c);
    let _ = parseInt(g.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(_) && (_ = Math.max(t.slides.indexOf(g), 0)), h = Math.floor(_ / r.grid.rows);
  } else if (t.slides[c]) {
    const g = t.slides[c].getAttribute("data-swiper-slide-index");
    g ? h = parseInt(g, 10) : h = c;
  } else
    h = c;
  Object.assign(t, {
    previousSnapIndex: o,
    snapIndex: l,
    previousRealIndex: a,
    realIndex: h,
    previousIndex: s,
    activeIndex: c
  }), t.initialized && di(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (a !== h && t.emit("realIndexChange"), t.emit("slideChange"));
}
function Iu(e, t) {
  const n = this, i = n.params;
  let r = e.closest(`.${i.slideClass}, swiper-slide`);
  !r && n.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((o) => {
    !r && o.matches && o.matches(`.${i.slideClass}, swiper-slide`) && (r = o);
  });
  let s = !1, a;
  if (r) {
    for (let o = 0; o < n.slides.length; o += 1)
      if (n.slides[o] === r) {
        s = !0, a = o;
        break;
      }
  }
  if (r && s)
    n.clickedSlide = r, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : n.clickedIndex = a;
  else {
    n.clickedSlide = void 0, n.clickedIndex = void 0;
    return;
  }
  i.slideToClickedSlide && n.clickedIndex !== void 0 && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
}
var Ru = {
  updateSize: yu,
  updateSlides: xu,
  updateAutoHeight: Eu,
  updateSlidesOffset: Su,
  updateSlidesProgress: Tu,
  updateProgress: Nu,
  updateSlidesClasses: Cu,
  updateActiveIndex: Mu,
  updateClickedSlide: Iu
};
function ku(e) {
  e === void 0 && (e = this.isHorizontal() ? "x" : "y");
  const t = this, {
    params: n,
    rtlTranslate: i,
    translate: r,
    wrapperEl: s
  } = t;
  if (n.virtualTranslate)
    return i ? -r : r;
  if (n.cssMode)
    return r;
  let a = lu(s, e);
  return a += t.cssOverflowAdjustment(), i && (a = -a), a || 0;
}
function Lu(e, t) {
  const n = this, {
    rtlTranslate: i,
    params: r,
    wrapperEl: s,
    progress: a
  } = n;
  let o = 0, c = 0;
  const l = 0;
  n.isHorizontal() ? o = i ? -e : e : c = e, r.roundLengths && (o = Math.floor(o), c = Math.floor(c)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? o : c, r.cssMode ? s[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -o : -c : r.virtualTranslate || (n.isHorizontal() ? o -= n.cssOverflowAdjustment() : c -= n.cssOverflowAdjustment(), s.style.transform = `translate3d(${o}px, ${c}px, ${l}px)`);
  let u;
  const p = n.maxTranslate() - n.minTranslate();
  p === 0 ? u = 0 : u = (e - n.minTranslate()) / p, u !== a && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
}
function Pu() {
  return -this.snapGrid[0];
}
function Ou() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function Du(e, t, n, i, r) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), i === void 0 && (i = !0);
  const s = this, {
    params: a,
    wrapperEl: o
  } = s;
  if (s.animating && a.preventInteractionOnTransition)
    return !1;
  const c = s.minTranslate(), l = s.maxTranslate();
  let u;
  if (i && e > c ? u = c : i && e < l ? u = l : u = e, s.updateProgress(u), a.cssMode) {
    const p = s.isHorizontal();
    if (t === 0)
      o[p ? "scrollLeft" : "scrollTop"] = -u;
    else {
      if (!s.support.smoothScroll)
        return Zr({
          swiper: s,
          targetPosition: -u,
          side: p ? "left" : "top"
        }), !0;
      o.scrollTo({
        [p ? "left" : "top"]: -u,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (s.setTransition(0), s.setTranslate(u), n && (s.emit("beforeTransitionStart", t, r), s.emit("transitionEnd"))) : (s.setTransition(t), s.setTranslate(u), n && (s.emit("beforeTransitionStart", t, r), s.emit("transitionStart")), s.animating || (s.animating = !0, s.onTranslateToWrapperTransitionEnd || (s.onTranslateToWrapperTransitionEnd = function(h) {
    !s || s.destroyed || h.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onTranslateToWrapperTransitionEnd), s.onTranslateToWrapperTransitionEnd = null, delete s.onTranslateToWrapperTransitionEnd, s.animating = !1, n && s.emit("transitionEnd"));
  }), s.wrapperEl.addEventListener("transitionend", s.onTranslateToWrapperTransitionEnd))), !0;
}
var Vu = {
  getTranslate: ku,
  setTranslate: Lu,
  minTranslate: Pu,
  maxTranslate: Ou,
  translateTo: Du
};
function $u(e, t) {
  const n = this;
  n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${e}ms`, n.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), n.emit("setTransition", e, t);
}
function ns(e) {
  let {
    swiper: t,
    runCallbacks: n,
    direction: i,
    step: r
  } = e;
  const {
    activeIndex: s,
    previousIndex: a
  } = t;
  let o = i;
  o || (s > a ? o = "next" : s < a ? o = "prev" : o = "reset"), t.emit(`transition${r}`), n && o === "reset" ? t.emit(`slideResetTransition${r}`) : n && s !== a && (t.emit(`slideChangeTransition${r}`), o === "next" ? t.emit(`slideNextTransition${r}`) : t.emit(`slidePrevTransition${r}`));
}
function zu(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: i
  } = n;
  i.cssMode || (i.autoHeight && n.updateAutoHeight(), ns({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function Hu(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: i
  } = n;
  n.animating = !1, !i.cssMode && (n.setTransition(0), ns({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
var Bu = {
  setTransition: $u,
  transitionStart: zu,
  transitionEnd: Hu
};
function Fu(e, t, n, i, r) {
  e === void 0 && (e = 0), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
  const s = this;
  let a = e;
  a < 0 && (a = 0);
  const {
    params: o,
    snapGrid: c,
    slidesGrid: l,
    previousIndex: u,
    activeIndex: p,
    rtlTranslate: h,
    wrapperEl: g,
    enabled: _
  } = s;
  if (!_ && !i && !r || s.destroyed || s.animating && o.preventInteractionOnTransition)
    return !1;
  typeof t > "u" && (t = s.params.speed);
  const b = Math.min(s.params.slidesPerGroupSkip, a);
  let E = b + Math.floor((a - b) / s.params.slidesPerGroup);
  E >= c.length && (E = c.length - 1);
  const y = -c[E];
  if (o.normalizeSlideIndex)
    for (let N = 0; N < l.length; N += 1) {
      const A = -Math.floor(y * 100), R = Math.floor(l[N] * 100), S = Math.floor(l[N + 1] * 100);
      typeof l[N + 1] < "u" ? A >= R && A < S - (S - R) / 2 ? a = N : A >= R && A < S && (a = N + 1) : A >= R && (a = N);
    }
  if (s.initialized && a !== p && (!s.allowSlideNext && (h ? y > s.translate && y > s.minTranslate() : y < s.translate && y < s.minTranslate()) || !s.allowSlidePrev && y > s.translate && y > s.maxTranslate() && (p || 0) !== a))
    return !1;
  a !== (u || 0) && n && s.emit("beforeSlideChangeStart"), s.updateProgress(y);
  let m;
  a > p ? m = "next" : a < p ? m = "prev" : m = "reset";
  const f = s.virtual && s.params.virtual.enabled;
  if (!(f && r) && (h && -y === s.translate || !h && y === s.translate))
    return s.updateActiveIndex(a), o.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), o.effect !== "slide" && s.setTranslate(y), m !== "reset" && (s.transitionStart(n, m), s.transitionEnd(n, m)), !1;
  if (o.cssMode) {
    const N = s.isHorizontal(), A = h ? y : -y;
    if (t === 0)
      f && (s.wrapperEl.style.scrollSnapType = "none", s._immediateVirtual = !0), f && !s._cssModeVirtualInitialSet && s.params.initialSlide > 0 ? (s._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        g[N ? "scrollLeft" : "scrollTop"] = A;
      })) : g[N ? "scrollLeft" : "scrollTop"] = A, f && requestAnimationFrame(() => {
        s.wrapperEl.style.scrollSnapType = "", s._immediateVirtual = !1;
      });
    else {
      if (!s.support.smoothScroll)
        return Zr({
          swiper: s,
          targetPosition: A,
          side: N ? "left" : "top"
        }), !0;
      g.scrollTo({
        [N ? "left" : "top"]: A,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const T = ts().isSafari;
  return f && !r && T && s.isElement && s.virtual.update(!1, !1, a), s.setTransition(t), s.setTranslate(y), s.updateActiveIndex(a), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(n, m), t === 0 ? s.transitionEnd(n, m) : s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function(A) {
    !s || s.destroyed || A.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(n, m));
  }), s.wrapperEl.addEventListener("transitionend", s.onSlideToWrapperTransitionEnd)), !0;
}
function Gu(e, t, n, i) {
  e === void 0 && (e = 0), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
  const r = this;
  if (r.destroyed) return;
  typeof t > "u" && (t = r.params.speed);
  const s = r.grid && r.params.grid && r.params.grid.rows > 1;
  let a = e;
  if (r.params.loop)
    if (r.virtual && r.params.virtual.enabled)
      a = a + r.virtual.slidesBefore;
    else {
      let o;
      if (s) {
        const h = a * r.params.grid.rows;
        o = r.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === h).column;
      } else
        o = r.getSlideIndexByData(a);
      const c = s ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length, {
        centeredSlides: l
      } = r.params;
      let u = r.params.slidesPerView;
      u === "auto" ? u = r.slidesPerViewDynamic() : (u = Math.ceil(parseFloat(r.params.slidesPerView, 10)), l && u % 2 === 0 && (u = u + 1));
      let p = c - o < u;
      if (l && (p = p || o < Math.ceil(u / 2)), i && l && r.params.slidesPerView !== "auto" && !s && (p = !1), p) {
        const h = l ? o < r.activeIndex ? "prev" : "next" : o - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
        r.loopFix({
          direction: h,
          slideTo: !0,
          activeSlideIndex: h === "next" ? o + 1 : o - c + 1,
          slideRealIndex: h === "next" ? r.realIndex : void 0
        });
      }
      if (s) {
        const h = a * r.params.grid.rows;
        a = r.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === h).column;
      } else
        a = r.getSlideIndexByData(a);
    }
  return requestAnimationFrame(() => {
    r.slideTo(a, t, n, i);
  }), r;
}
function Uu(e, t, n) {
  t === void 0 && (t = !0);
  const i = this, {
    enabled: r,
    params: s,
    animating: a
  } = i;
  if (!r || i.destroyed) return i;
  typeof e > "u" && (e = i.params.speed);
  let o = s.slidesPerGroup;
  s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto && (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
  const c = i.activeIndex < s.slidesPerGroupSkip ? 1 : o, l = i.virtual && s.virtual.enabled;
  if (s.loop) {
    if (a && !l && s.loopPreventsSliding) return !1;
    if (i.loopFix({
      direction: "next"
    }), i._clientLeft = i.wrapperEl.clientLeft, i.activeIndex === i.slides.length - 1 && s.cssMode)
      return requestAnimationFrame(() => {
        i.slideTo(i.activeIndex + c, e, t, n);
      }), !0;
  }
  return s.rewind && i.isEnd ? i.slideTo(0, e, t, n) : i.slideTo(i.activeIndex + c, e, t, n);
}
function qu(e, t, n) {
  t === void 0 && (t = !0);
  const i = this, {
    params: r,
    snapGrid: s,
    slidesGrid: a,
    rtlTranslate: o,
    enabled: c,
    animating: l
  } = i;
  if (!c || i.destroyed) return i;
  typeof e > "u" && (e = i.params.speed);
  const u = i.virtual && r.virtual.enabled;
  if (r.loop) {
    if (l && !u && r.loopPreventsSliding) return !1;
    i.loopFix({
      direction: "prev"
    }), i._clientLeft = i.wrapperEl.clientLeft;
  }
  const p = o ? i.translate : -i.translate;
  function h(m) {
    return m < 0 ? -Math.floor(Math.abs(m)) : Math.floor(m);
  }
  const g = h(p), _ = s.map((m) => h(m)), b = r.freeMode && r.freeMode.enabled;
  let E = s[_.indexOf(g) - 1];
  if (typeof E > "u" && (r.cssMode || b)) {
    let m;
    s.forEach((f, v) => {
      g >= f && (m = v);
    }), typeof m < "u" && (E = b ? s[m] : s[m > 0 ? m - 1 : m]);
  }
  let y = 0;
  if (typeof E < "u" && (y = a.indexOf(E), y < 0 && (y = i.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (y = y - i.slidesPerViewDynamic("previous", !0) + 1, y = Math.max(y, 0))), r.rewind && i.isBeginning) {
    const m = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1;
    return i.slideTo(m, e, t, n);
  } else if (r.loop && i.activeIndex === 0 && r.cssMode)
    return requestAnimationFrame(() => {
      i.slideTo(y, e, t, n);
    }), !0;
  return i.slideTo(y, e, t, n);
}
function Wu(e, t, n) {
  t === void 0 && (t = !0);
  const i = this;
  if (!i.destroyed)
    return typeof e > "u" && (e = i.params.speed), i.slideTo(i.activeIndex, e, t, n);
}
function Yu(e, t, n, i) {
  t === void 0 && (t = !0), i === void 0 && (i = 0.5);
  const r = this;
  if (r.destroyed) return;
  typeof e > "u" && (e = r.params.speed);
  let s = r.activeIndex;
  const a = Math.min(r.params.slidesPerGroupSkip, s), o = a + Math.floor((s - a) / r.params.slidesPerGroup), c = r.rtlTranslate ? r.translate : -r.translate;
  if (c >= r.snapGrid[o]) {
    const l = r.snapGrid[o], u = r.snapGrid[o + 1];
    c - l > (u - l) * i && (s += r.params.slidesPerGroup);
  } else {
    const l = r.snapGrid[o - 1], u = r.snapGrid[o];
    c - l <= (u - l) * i && (s -= r.params.slidesPerGroup);
  }
  return s = Math.max(s, 0), s = Math.min(s, r.slidesGrid.length - 1), r.slideTo(s, e, t, n);
}
function ju() {
  const e = this;
  if (e.destroyed) return;
  const {
    params: t,
    slidesEl: n
  } = e, i = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let r = e.clickedIndex, s;
  const a = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
  if (t.loop) {
    if (e.animating) return;
    s = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? r < e.loopedSlides - i / 2 || r > e.slides.length - e.loopedSlides + i / 2 ? (e.loopFix(), r = e.getSlideIndex(Ve(n, `${a}[data-swiper-slide-index="${s}"]`)[0]), oi(() => {
      e.slideTo(r);
    })) : e.slideTo(r) : r > e.slides.length - i ? (e.loopFix(), r = e.getSlideIndex(Ve(n, `${a}[data-swiper-slide-index="${s}"]`)[0]), oi(() => {
      e.slideTo(r);
    })) : e.slideTo(r);
  } else
    e.slideTo(r);
}
var Xu = {
  slideTo: Fu,
  slideToLoop: Gu,
  slideNext: Uu,
  slidePrev: qu,
  slideReset: Wu,
  slideToClosest: Yu,
  slideToClickedSlide: ju
};
function Zu(e, t) {
  const n = this, {
    params: i,
    slidesEl: r
  } = n;
  if (!i.loop || n.virtual && n.params.virtual.enabled) return;
  const s = () => {
    Ve(r, `.${i.slideClass}, swiper-slide`).forEach((h, g) => {
      h.setAttribute("data-swiper-slide-index", g);
    });
  }, a = n.grid && i.grid && i.grid.rows > 1, o = i.slidesPerGroup * (a ? i.grid.rows : 1), c = n.slides.length % o !== 0, l = a && n.slides.length % i.grid.rows !== 0, u = (p) => {
    for (let h = 0; h < p; h += 1) {
      const g = n.isElement ? Dt("swiper-slide", [i.slideBlankClass]) : Dt("div", [i.slideClass, i.slideBlankClass]);
      n.slidesEl.append(g);
    }
  };
  if (c) {
    if (i.loopAddBlankSlides) {
      const p = o - n.slides.length % o;
      u(p), n.recalcSlides(), n.updateSlides();
    } else
      _n("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    s();
  } else if (l) {
    if (i.loopAddBlankSlides) {
      const p = i.grid.rows - n.slides.length % i.grid.rows;
      u(p), n.recalcSlides(), n.updateSlides();
    } else
      _n("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    s();
  } else
    s();
  n.loopFix({
    slideRealIndex: e,
    direction: i.centeredSlides ? void 0 : "next",
    initial: t
  });
}
function Ku(e) {
  let {
    slideRealIndex: t,
    slideTo: n = !0,
    direction: i,
    setTranslate: r,
    activeSlideIndex: s,
    initial: a,
    byController: o,
    byMousewheel: c
  } = e === void 0 ? {} : e;
  const l = this;
  if (!l.params.loop) return;
  l.emit("beforeLoopFix");
  const {
    slides: u,
    allowSlidePrev: p,
    allowSlideNext: h,
    slidesEl: g,
    params: _
  } = l, {
    centeredSlides: b,
    initialSlide: E
  } = _;
  if (l.allowSlidePrev = !0, l.allowSlideNext = !0, l.virtual && _.virtual.enabled) {
    n && (!_.centeredSlides && l.snapIndex === 0 ? l.slideTo(l.virtual.slides.length, 0, !1, !0) : _.centeredSlides && l.snapIndex < _.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0)), l.allowSlidePrev = p, l.allowSlideNext = h, l.emit("loopFix");
    return;
  }
  let y = _.slidesPerView;
  y === "auto" ? y = l.slidesPerViewDynamic() : (y = Math.ceil(parseFloat(_.slidesPerView, 10)), b && y % 2 === 0 && (y = y + 1));
  const m = _.slidesPerGroupAuto ? y : _.slidesPerGroup;
  let f = m;
  f % m !== 0 && (f += m - f % m), f += _.loopAdditionalSlides, l.loopedSlides = f;
  const v = l.grid && _.grid && _.grid.rows > 1;
  u.length < y + f || l.params.effect === "cards" && u.length < y + f * 2 ? _n("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : v && _.grid.fill === "row" && _n("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const w = [], T = [], N = v ? Math.ceil(u.length / _.grid.rows) : u.length, A = a && N - E < y && !b;
  let R = A ? E : l.activeIndex;
  typeof s > "u" ? s = l.getSlideIndex(u.find((O) => O.classList.contains(_.slideActiveClass))) : R = s;
  const S = i === "next" || !i, k = i === "prev" || !i;
  let P = 0, D = 0;
  const z = (v ? u[s].column : s) + (b && typeof r > "u" ? -y / 2 + 0.5 : 0);
  if (z < f) {
    P = Math.max(f - z, m);
    for (let O = 0; O < f - z; O += 1) {
      const C = O - Math.floor(O / N) * N;
      if (v) {
        const M = N - C - 1;
        for (let $ = u.length - 1; $ >= 0; $ -= 1)
          u[$].column === M && w.push($);
      } else
        w.push(N - C - 1);
    }
  } else if (z + y > N - f) {
    D = Math.max(z - (N - f * 2), m), A && (D = Math.max(D, y - N + E + 1));
    for (let O = 0; O < D; O += 1) {
      const C = O - Math.floor(O / N) * N;
      v ? u.forEach((M, $) => {
        M.column === C && T.push($);
      }) : T.push(C);
    }
  }
  if (l.__preventObserver__ = !0, requestAnimationFrame(() => {
    l.__preventObserver__ = !1;
  }), l.params.effect === "cards" && u.length < y + f * 2 && (T.includes(s) && T.splice(T.indexOf(s), 1), w.includes(s) && w.splice(w.indexOf(s), 1)), k && w.forEach((O) => {
    u[O].swiperLoopMoveDOM = !0, g.prepend(u[O]), u[O].swiperLoopMoveDOM = !1;
  }), S && T.forEach((O) => {
    u[O].swiperLoopMoveDOM = !0, g.append(u[O]), u[O].swiperLoopMoveDOM = !1;
  }), l.recalcSlides(), _.slidesPerView === "auto" ? l.updateSlides() : v && (w.length > 0 && k || T.length > 0 && S) && l.slides.forEach((O, C) => {
    l.grid.updateSlide(C, O, l.slides);
  }), _.watchSlidesProgress && l.updateSlidesOffset(), n) {
    if (w.length > 0 && k) {
      if (typeof t > "u") {
        const O = l.slidesGrid[R], M = l.slidesGrid[R + P] - O;
        c ? l.setTranslate(l.translate - M) : (l.slideTo(R + Math.ceil(P), 0, !1, !0), r && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - M, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - M));
      } else if (r) {
        const O = v ? w.length / _.grid.rows : w.length;
        l.slideTo(l.activeIndex + O, 0, !1, !0), l.touchEventsData.currentTranslate = l.translate;
      }
    } else if (T.length > 0 && S)
      if (typeof t > "u") {
        const O = l.slidesGrid[R], M = l.slidesGrid[R - D] - O;
        c ? l.setTranslate(l.translate - M) : (l.slideTo(R - D, 0, !1, !0), r && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - M, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - M));
      } else {
        const O = v ? T.length / _.grid.rows : T.length;
        l.slideTo(l.activeIndex - O, 0, !1, !0);
      }
  }
  if (l.allowSlidePrev = p, l.allowSlideNext = h, l.controller && l.controller.control && !o) {
    const O = {
      slideRealIndex: t,
      direction: i,
      setTranslate: r,
      activeSlideIndex: s,
      byController: !0
    };
    Array.isArray(l.controller.control) ? l.controller.control.forEach((C) => {
      !C.destroyed && C.params.loop && C.loopFix({
        ...O,
        slideTo: C.params.slidesPerView === _.slidesPerView ? n : !1
      });
    }) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix({
      ...O,
      slideTo: l.controller.control.params.slidesPerView === _.slidesPerView ? n : !1
    });
  }
  l.emit("loopFix");
}
function Qu() {
  const e = this, {
    params: t,
    slidesEl: n
  } = e;
  if (!t.loop || !n || e.virtual && e.params.virtual.enabled) return;
  e.recalcSlides();
  const i = [];
  e.slides.forEach((r) => {
    const s = typeof r.swiperSlideIndex > "u" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
    i[s] = r;
  }), e.slides.forEach((r) => {
    r.removeAttribute("data-swiper-slide-index");
  }), i.forEach((r) => {
    n.append(r);
  }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
var Ju = {
  loopCreate: Zu,
  loopFix: Ku,
  loopDestroy: Qu
};
function ep(e) {
  const t = this;
  if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
  const n = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  t.isElement && (t.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  });
}
function tp() {
  const e = this;
  e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  }));
}
var np = {
  setGrabCursor: ep,
  unsetGrabCursor: tp
};
function ip(e, t) {
  t === void 0 && (t = this);
  function n(i) {
    if (!i || i === Ze() || i === me()) return null;
    i.assignedSlot && (i = i.assignedSlot);
    const r = i.closest(e);
    return !r && !i.getRootNode ? null : r || n(i.getRootNode().host);
  }
  return n(t);
}
function or(e, t, n) {
  const i = me(), {
    params: r
  } = e, s = r.edgeSwipeDetection, a = r.edgeSwipeThreshold;
  return s && (n <= a || n >= i.innerWidth - a) ? s === "prevent" ? (t.preventDefault(), !0) : !1 : !0;
}
function rp(e) {
  const t = this, n = Ze();
  let i = e;
  i.originalEvent && (i = i.originalEvent);
  const r = t.touchEventsData;
  if (i.type === "pointerdown") {
    if (r.pointerId !== null && r.pointerId !== i.pointerId)
      return;
    r.pointerId = i.pointerId;
  } else i.type === "touchstart" && i.targetTouches.length === 1 && (r.touchId = i.targetTouches[0].identifier);
  if (i.type === "touchstart") {
    or(t, i, i.targetTouches[0].pageX);
    return;
  }
  const {
    params: s,
    touches: a,
    enabled: o
  } = t;
  if (!o || !s.simulateTouch && i.pointerType === "mouse" || t.animating && s.preventInteractionOnTransition)
    return;
  !t.animating && s.cssMode && s.loop && t.loopFix();
  let c = i.target;
  if (s.touchEventsTarget === "wrapper" && !uu(c, t.wrapperEl) || "which" in i && i.which === 3 || "button" in i && i.button > 0 || r.isTouched && r.isMoved) return;
  const l = !!s.noSwipingClass && s.noSwipingClass !== "", u = i.composedPath ? i.composedPath() : i.path;
  l && i.target && i.target.shadowRoot && u && (c = u[0]);
  const p = s.noSwipingSelector ? s.noSwipingSelector : `.${s.noSwipingClass}`, h = !!(i.target && i.target.shadowRoot);
  if (s.noSwiping && (h ? ip(p, c) : c.closest(p))) {
    t.allowClick = !0;
    return;
  }
  if (s.swipeHandler && !c.closest(s.swipeHandler))
    return;
  a.currentX = i.pageX, a.currentY = i.pageY;
  const g = a.currentX, _ = a.currentY;
  if (!or(t, i, g))
    return;
  Object.assign(r, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = g, a.startY = _, r.touchStartTime = gn(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, s.threshold > 0 && (r.allowThresholdMove = !1);
  let b = !0;
  c.matches(r.focusableElements) && (b = !1, c.nodeName === "SELECT" && (r.isTouched = !1)), n.activeElement && n.activeElement.matches(r.focusableElements) && n.activeElement !== c && (i.pointerType === "mouse" || i.pointerType !== "mouse" && !c.matches(r.focusableElements)) && n.activeElement.blur();
  const E = b && t.allowTouchMove && s.touchStartPreventDefault;
  (s.touchStartForcePreventDefault || E) && !c.isContentEditable && i.preventDefault(), s.freeMode && s.freeMode.enabled && t.freeMode && t.animating && !s.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", i);
}
function sp(e) {
  const t = Ze(), n = this, i = n.touchEventsData, {
    params: r,
    touches: s,
    rtlTranslate: a,
    enabled: o
  } = n;
  if (!o || !r.simulateTouch && e.pointerType === "mouse") return;
  let c = e;
  if (c.originalEvent && (c = c.originalEvent), c.type === "pointermove" && (i.touchId !== null || c.pointerId !== i.pointerId))
    return;
  let l;
  if (c.type === "touchmove") {
    if (l = [...c.changedTouches].find((w) => w.identifier === i.touchId), !l || l.identifier !== i.touchId) return;
  } else
    l = c;
  if (!i.isTouched) {
    i.startMoving && i.isScrolling && n.emit("touchMoveOpposite", c);
    return;
  }
  const u = l.pageX, p = l.pageY;
  if (c.preventedByNestedSwiper) {
    s.startX = u, s.startY = p;
    return;
  }
  if (!n.allowTouchMove) {
    c.target.matches(i.focusableElements) || (n.allowClick = !1), i.isTouched && (Object.assign(s, {
      startX: u,
      startY: p,
      currentX: u,
      currentY: p
    }), i.touchStartTime = gn());
    return;
  }
  if (r.touchReleaseOnEdges && !r.loop)
    if (n.isVertical()) {
      if (p < s.startY && n.translate <= n.maxTranslate() || p > s.startY && n.translate >= n.minTranslate()) {
        i.isTouched = !1, i.isMoved = !1;
        return;
      }
    } else {
      if (a && (u > s.startX && -n.translate <= n.maxTranslate() || u < s.startX && -n.translate >= n.minTranslate()))
        return;
      if (!a && (u < s.startX && n.translate <= n.maxTranslate() || u > s.startX && n.translate >= n.minTranslate()))
        return;
    }
  if (t.activeElement && t.activeElement.matches(i.focusableElements) && t.activeElement !== c.target && c.pointerType !== "mouse" && t.activeElement.blur(), t.activeElement && c.target === t.activeElement && c.target.matches(i.focusableElements)) {
    i.isMoved = !0, n.allowClick = !1;
    return;
  }
  i.allowTouchCallbacks && n.emit("touchMove", c), s.previousX = s.currentX, s.previousY = s.currentY, s.currentX = u, s.currentY = p;
  const h = s.currentX - s.startX, g = s.currentY - s.startY;
  if (n.params.threshold && Math.sqrt(h ** 2 + g ** 2) < n.params.threshold) return;
  if (typeof i.isScrolling > "u") {
    let w;
    n.isHorizontal() && s.currentY === s.startY || n.isVertical() && s.currentX === s.startX ? i.isScrolling = !1 : h * h + g * g >= 25 && (w = Math.atan2(Math.abs(g), Math.abs(h)) * 180 / Math.PI, i.isScrolling = n.isHorizontal() ? w > r.touchAngle : 90 - w > r.touchAngle);
  }
  if (i.isScrolling && n.emit("touchMoveOpposite", c), typeof i.startMoving > "u" && (s.currentX !== s.startX || s.currentY !== s.startY) && (i.startMoving = !0), i.isScrolling || c.type === "touchmove" && i.preventTouchMoveFromPointerMove) {
    i.isTouched = !1;
    return;
  }
  if (!i.startMoving)
    return;
  n.allowClick = !1, !r.cssMode && c.cancelable && c.preventDefault(), r.touchMoveStopPropagation && !r.nested && c.stopPropagation();
  let _ = n.isHorizontal() ? h : g, b = n.isHorizontal() ? s.currentX - s.previousX : s.currentY - s.previousY;
  r.oneWayMovement && (_ = Math.abs(_) * (a ? 1 : -1), b = Math.abs(b) * (a ? 1 : -1)), s.diff = _, _ *= r.touchRatio, a && (_ = -_, b = -b);
  const E = n.touchesDirection;
  n.swipeDirection = _ > 0 ? "prev" : "next", n.touchesDirection = b > 0 ? "prev" : "next";
  const y = n.params.loop && !r.cssMode, m = n.touchesDirection === "next" && n.allowSlideNext || n.touchesDirection === "prev" && n.allowSlidePrev;
  if (!i.isMoved) {
    if (y && m && n.loopFix({
      direction: n.swipeDirection
    }), i.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
      const w = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      n.wrapperEl.dispatchEvent(w);
    }
    i.allowMomentumBounce = !1, r.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", c);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), r._loopSwapReset !== !1 && i.isMoved && i.allowThresholdMove && E !== n.touchesDirection && y && m && Math.abs(_) >= 1) {
    Object.assign(s, {
      startX: u,
      startY: p,
      currentX: u,
      currentY: p,
      startTranslate: i.currentTranslate
    }), i.loopSwapReset = !0, i.startTranslate = i.currentTranslate;
    return;
  }
  n.emit("sliderMove", c), i.isMoved = !0, i.currentTranslate = _ + i.startTranslate;
  let f = !0, v = r.resistanceRatio;
  if (r.touchReleaseOnEdges && (v = 0), _ > 0 ? (y && m && i.allowThresholdMove && i.currentTranslate > (r.centeredSlides ? n.minTranslate() - n.slidesSizesGrid[n.activeIndex + 1] - (r.slidesPerView !== "auto" && n.slides.length - r.slidesPerView >= 2 ? n.slidesSizesGrid[n.activeIndex + 1] + n.params.spaceBetween : 0) - n.params.spaceBetween : n.minTranslate()) && n.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), i.currentTranslate > n.minTranslate() && (f = !1, r.resistance && (i.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + i.startTranslate + _) ** v))) : _ < 0 && (y && m && i.allowThresholdMove && i.currentTranslate < (r.centeredSlides ? n.maxTranslate() + n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween + (r.slidesPerView !== "auto" && n.slides.length - r.slidesPerView >= 2 ? n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween : 0) : n.maxTranslate()) && n.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: n.slides.length - (r.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10)))
  }), i.currentTranslate < n.maxTranslate() && (f = !1, r.resistance && (i.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - i.startTranslate - _) ** v))), f && (c.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (i.currentTranslate = i.startTranslate), r.threshold > 0)
    if (Math.abs(_) > r.threshold || i.allowThresholdMove) {
      if (!i.allowThresholdMove) {
        i.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, i.currentTranslate = i.startTranslate, s.diff = n.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY;
        return;
      }
    } else {
      i.currentTranslate = i.startTranslate;
      return;
    }
  !r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && n.freeMode || r.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(i.currentTranslate), n.setTranslate(i.currentTranslate));
}
function ap(e) {
  const t = this, n = t.touchEventsData;
  let i = e;
  i.originalEvent && (i = i.originalEvent);
  let r;
  if (i.type === "touchend" || i.type === "touchcancel") {
    if (r = [...i.changedTouches].find((w) => w.identifier === n.touchId), !r || r.identifier !== n.touchId) return;
  } else {
    if (n.touchId !== null || i.pointerId !== n.pointerId) return;
    r = i;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(i.type) && !(["pointercancel", "contextmenu"].includes(i.type) && (t.browser.isSafari || t.browser.isWebView)))
    return;
  n.pointerId = null, n.touchId = null;
  const {
    params: a,
    touches: o,
    rtlTranslate: c,
    slidesGrid: l,
    enabled: u
  } = t;
  if (!u || !a.simulateTouch && i.pointerType === "mouse") return;
  if (n.allowTouchCallbacks && t.emit("touchEnd", i), n.allowTouchCallbacks = !1, !n.isTouched) {
    n.isMoved && a.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
    return;
  }
  a.grabCursor && n.isMoved && n.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const p = gn(), h = p - n.touchStartTime;
  if (t.allowClick) {
    const w = i.path || i.composedPath && i.composedPath();
    t.updateClickedSlide(w && w[0] || i.target, w), t.emit("tap click", i), h < 300 && p - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", i);
  }
  if (n.lastClickTime = gn(), oi(() => {
    t.destroyed || (t.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !t.swipeDirection || o.diff === 0 && !n.loopSwapReset || n.currentTranslate === n.startTranslate && !n.loopSwapReset) {
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    return;
  }
  n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
  let g;
  if (a.followFinger ? g = c ? t.translate : -t.translate : g = -n.currentTranslate, a.cssMode)
    return;
  if (a.freeMode && a.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: g
    });
    return;
  }
  const _ = g >= -t.maxTranslate() && !t.params.loop;
  let b = 0, E = t.slidesSizesGrid[0];
  for (let w = 0; w < l.length; w += w < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
    const T = w < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
    typeof l[w + T] < "u" ? (_ || g >= l[w] && g < l[w + T]) && (b = w, E = l[w + T] - l[w]) : (_ || g >= l[w]) && (b = w, E = l[l.length - 1] - l[l.length - 2]);
  }
  let y = null, m = null;
  a.rewind && (t.isBeginning ? m = a.virtual && a.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (y = 0));
  const f = (g - l[b]) / E, v = b < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
  if (h > a.longSwipesMs) {
    if (!a.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (f >= a.longSwipesRatio ? t.slideTo(a.rewind && t.isEnd ? y : b + v) : t.slideTo(b)), t.swipeDirection === "prev" && (f > 1 - a.longSwipesRatio ? t.slideTo(b + v) : m !== null && f < 0 && Math.abs(f) > a.longSwipesRatio ? t.slideTo(m) : t.slideTo(b));
  } else {
    if (!a.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (i.target === t.navigation.nextEl || i.target === t.navigation.prevEl) ? i.target === t.navigation.nextEl ? t.slideTo(b + v) : t.slideTo(b) : (t.swipeDirection === "next" && t.slideTo(y !== null ? y : b + v), t.swipeDirection === "prev" && t.slideTo(m !== null ? m : b));
  }
}
function lr() {
  const e = this, {
    params: t,
    el: n
  } = e;
  if (n && n.offsetWidth === 0) return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: i,
    allowSlidePrev: r,
    snapGrid: s
  } = e, a = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const o = a && t.loop;
  (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !o ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !a ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = r, e.allowSlideNext = i, e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow();
}
function op(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function lp() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: n,
    enabled: i
  } = e;
  if (!i) return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let r;
  const s = e.maxTranslate() - e.minTranslate();
  s === 0 ? r = 0 : r = (e.translate - e.minTranslate()) / s, r !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function cp(e) {
  const t = this;
  an(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
function dp() {
  const e = this;
  e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
const is = (e, t) => {
  const n = Ze(), {
    params: i,
    el: r,
    wrapperEl: s,
    device: a
  } = e, o = !!i.nested, c = t === "on" ? "addEventListener" : "removeEventListener", l = t;
  !r || typeof r == "string" || (n[c]("touchstart", e.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), r[c]("touchstart", e.onTouchStart, {
    passive: !1
  }), r[c]("pointerdown", e.onTouchStart, {
    passive: !1
  }), n[c]("touchmove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), n[c]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), n[c]("touchend", e.onTouchEnd, {
    passive: !0
  }), n[c]("pointerup", e.onTouchEnd, {
    passive: !0
  }), n[c]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), n[c]("touchcancel", e.onTouchEnd, {
    passive: !0
  }), n[c]("pointerout", e.onTouchEnd, {
    passive: !0
  }), n[c]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), n[c]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (i.preventClicks || i.preventClicksPropagation) && r[c]("click", e.onClick, !0), i.cssMode && s[c]("scroll", e.onScroll), i.updateOnWindowResize ? e[l](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", lr, !0) : e[l]("observerUpdate", lr, !0), r[c]("load", e.onLoad, {
    capture: !0
  }));
};
function up() {
  const e = this, {
    params: t
  } = e;
  e.onTouchStart = rp.bind(e), e.onTouchMove = sp.bind(e), e.onTouchEnd = ap.bind(e), e.onDocumentTouchStart = dp.bind(e), t.cssMode && (e.onScroll = lp.bind(e)), e.onClick = op.bind(e), e.onLoad = cp.bind(e), is(e, "on");
}
function pp() {
  is(this, "off");
}
var hp = {
  attachEvents: up,
  detachEvents: pp
};
const cr = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function fp() {
  const e = this, {
    realIndex: t,
    initialized: n,
    params: i,
    el: r
  } = e, s = i.breakpoints;
  if (!s || s && Object.keys(s).length === 0) return;
  const a = Ze(), o = i.breakpointsBase === "window" || !i.breakpointsBase ? i.breakpointsBase : "container", c = ["window", "container"].includes(i.breakpointsBase) || !i.breakpointsBase ? e.el : a.querySelector(i.breakpointsBase), l = e.getBreakpoint(s, o, c);
  if (!l || e.currentBreakpoint === l) return;
  const p = (l in s ? s[l] : void 0) || e.originalParams, h = cr(e, i), g = cr(e, p), _ = e.params.grabCursor, b = p.grabCursor, E = i.enabled;
  h && !g ? (r.classList.remove(`${i.containerModifierClass}grid`, `${i.containerModifierClass}grid-column`), e.emitContainerClasses()) : !h && g && (r.classList.add(`${i.containerModifierClass}grid`), (p.grid.fill && p.grid.fill === "column" || !p.grid.fill && i.grid.fill === "column") && r.classList.add(`${i.containerModifierClass}grid-column`), e.emitContainerClasses()), _ && !b ? e.unsetGrabCursor() : !_ && b && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((T) => {
    if (typeof p[T] > "u") return;
    const N = i[T] && i[T].enabled, A = p[T] && p[T].enabled;
    N && !A && e[T].disable(), !N && A && e[T].enable();
  });
  const y = p.direction && p.direction !== i.direction, m = i.loop && (p.slidesPerView !== i.slidesPerView || y), f = i.loop;
  y && n && e.changeDirection(), _e(e.params, p);
  const v = e.params.enabled, w = e.params.loop;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), E && !v ? e.disable() : !E && v && e.enable(), e.currentBreakpoint = l, e.emit("_beforeBreakpoint", p), n && (m ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !f && w ? (e.loopCreate(t), e.updateSlides()) : f && !w && e.loopDestroy()), e.emit("breakpoint", p);
}
function mp(e, t, n) {
  if (t === void 0 && (t = "window"), !e || t === "container" && !n) return;
  let i = !1;
  const r = me(), s = t === "window" ? r.innerHeight : n.clientHeight, a = Object.keys(e).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const c = parseFloat(o.substr(1));
      return {
        value: s * c,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  a.sort((o, c) => parseInt(o.value, 10) - parseInt(c.value, 10));
  for (let o = 0; o < a.length; o += 1) {
    const {
      point: c,
      value: l
    } = a[o];
    t === "window" ? r.matchMedia(`(min-width: ${l}px)`).matches && (i = c) : l <= n.clientWidth && (i = c);
  }
  return i || "max";
}
var gp = {
  setBreakpoint: fp,
  getBreakpoint: mp
};
function _p(e, t) {
  const n = [];
  return e.forEach((i) => {
    typeof i == "object" ? Object.keys(i).forEach((r) => {
      i[r] && n.push(t + r);
    }) : typeof i == "string" && n.push(t + i);
  }), n;
}
function vp() {
  const e = this, {
    classNames: t,
    params: n,
    rtl: i,
    el: r,
    device: s
  } = e, a = _p(["initialized", n.direction, {
    "free-mode": e.params.freeMode && n.freeMode.enabled
  }, {
    autoheight: n.autoHeight
  }, {
    rtl: i
  }, {
    grid: n.grid && n.grid.rows > 1
  }, {
    "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
  }, {
    android: s.android
  }, {
    ios: s.ios
  }, {
    "css-mode": n.cssMode
  }, {
    centered: n.cssMode && n.centeredSlides
  }, {
    "watch-progress": n.watchSlidesProgress
  }], n.containerModifierClass);
  t.push(...a), r.classList.add(...t), e.emitContainerClasses();
}
function wp() {
  const e = this, {
    el: t,
    classNames: n
  } = e;
  !t || typeof t == "string" || (t.classList.remove(...n), e.emitContainerClasses());
}
var bp = {
  addClasses: vp,
  removeClasses: wp
};
function yp() {
  const e = this, {
    isLocked: t,
    params: n
  } = e, {
    slidesOffsetBefore: i
  } = n;
  if (i) {
    const r = e.slides.length - 1, s = e.slidesGrid[r] + e.slidesSizesGrid[r] + i * 2;
    e.isLocked = e.size > s;
  } else
    e.isLocked = e.snapGrid.length === 1;
  n.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), n.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
var xp = {
  checkOverflow: yp
}, dr = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function Ep(e, t) {
  return function(i) {
    i === void 0 && (i = {});
    const r = Object.keys(i)[0], s = i[r];
    if (typeof s != "object" || s === null) {
      _e(t, i);
      return;
    }
    if (e[r] === !0 && (e[r] = {
      enabled: !0
    }), r === "navigation" && e[r] && e[r].enabled && !e[r].prevEl && !e[r].nextEl && (e[r].auto = !0), ["pagination", "scrollbar"].indexOf(r) >= 0 && e[r] && e[r].enabled && !e[r].el && (e[r].auto = !0), !(r in e && "enabled" in s)) {
      _e(t, i);
      return;
    }
    typeof e[r] == "object" && !("enabled" in e[r]) && (e[r].enabled = !0), e[r] || (e[r] = {
      enabled: !1
    }), _e(t, i);
  };
}
const qn = {
  eventsEmitter: bu,
  update: Ru,
  translate: Vu,
  transition: Bu,
  slide: Xu,
  loop: Ju,
  grabCursor: np,
  events: hp,
  breakpoints: gp,
  checkOverflow: xp,
  classes: bp
}, Wn = {};
class Se {
  constructor() {
    let t, n;
    for (var i = arguments.length, r = new Array(i), s = 0; s < i; s++)
      r[s] = arguments[s];
    r.length === 1 && r[0].constructor && Object.prototype.toString.call(r[0]).slice(8, -1) === "Object" ? n = r[0] : [t, n] = r, n || (n = {}), n = _e({}, n), t && !n.el && (n.el = t);
    const a = Ze();
    if (n.el && typeof n.el == "string" && a.querySelectorAll(n.el).length > 1) {
      const u = [];
      return a.querySelectorAll(n.el).forEach((p) => {
        const h = _e({}, n, {
          el: p
        });
        u.push(new Se(h));
      }), u;
    }
    const o = this;
    o.__swiper__ = !0, o.support = Jr(), o.device = es({
      userAgent: n.userAgent
    }), o.browser = ts(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], n.modules && Array.isArray(n.modules) && o.modules.push(...n.modules);
    const c = {};
    o.modules.forEach((u) => {
      u({
        params: n,
        swiper: o,
        extendParams: Ep(n, c),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    const l = _e({}, dr, c);
    return o.params = _e({}, l, Wn, n), o.originalParams = _e({}, o.params), o.passedParams = _e({}, n), o.params && o.params.on && Object.keys(o.params.on).forEach((u) => {
      o.on(u, o.params.on[u]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
      enabled: o.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return o.params.direction === "horizontal";
      },
      isVertical() {
        return o.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: o.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  getDirectionLabel(t) {
    return this.isHorizontal() ? t : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[t];
  }
  getSlideIndex(t) {
    const {
      slidesEl: n,
      params: i
    } = this, r = Ve(n, `.${i.slideClass}, swiper-slide`), s = Vt(r[0]);
    return Vt(t) - s;
  }
  getSlideIndexByData(t) {
    return this.getSlideIndex(this.slides.find((n) => n.getAttribute("data-swiper-slide-index") * 1 === t));
  }
  recalcSlides() {
    const t = this, {
      slidesEl: n,
      params: i
    } = t;
    t.slides = Ve(n, `.${i.slideClass}, swiper-slide`);
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, n) {
    const i = this;
    t = Math.min(Math.max(t, 0), 1);
    const r = i.minTranslate(), a = (i.maxTranslate() - r) * t + r;
    i.translateTo(a, typeof n > "u" ? 0 : n), i.updateActiveIndex(), i.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const n = t.el.className.split(" ").filter((i) => i.indexOf("swiper") === 0 || i.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", n.join(" "));
  }
  getSlideClasses(t) {
    const n = this;
    return n.destroyed ? "" : t.className.split(" ").filter((i) => i.indexOf("swiper-slide") === 0 || i.indexOf(n.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const n = [];
    t.slides.forEach((i) => {
      const r = t.getSlideClasses(i);
      n.push({
        slideEl: i,
        classNames: r
      }), t.emit("_slideClass", i, r);
    }), t.emit("_slideClasses", n);
  }
  slidesPerViewDynamic(t, n) {
    t === void 0 && (t = "current"), n === void 0 && (n = !1);
    const i = this, {
      params: r,
      slides: s,
      slidesGrid: a,
      slidesSizesGrid: o,
      size: c,
      activeIndex: l
    } = i;
    let u = 1;
    if (typeof r.slidesPerView == "number") return r.slidesPerView;
    if (r.centeredSlides) {
      let p = s[l] ? Math.ceil(s[l].swiperSlideSize) : 0, h;
      for (let g = l + 1; g < s.length; g += 1)
        s[g] && !h && (p += Math.ceil(s[g].swiperSlideSize), u += 1, p > c && (h = !0));
      for (let g = l - 1; g >= 0; g -= 1)
        s[g] && !h && (p += s[g].swiperSlideSize, u += 1, p > c && (h = !0));
    } else if (t === "current")
      for (let p = l + 1; p < s.length; p += 1)
        (n ? a[p] + o[p] - a[l] < c : a[p] - a[l] < c) && (u += 1);
    else
      for (let p = l - 1; p >= 0; p -= 1)
        a[l] - a[p] < c && (u += 1);
    return u;
  }
  update() {
    const t = this;
    if (!t || t.destroyed) return;
    const {
      snapGrid: n,
      params: i
    } = t;
    i.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((a) => {
      a.complete && an(t, a);
    }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function r() {
      const a = t.rtlTranslate ? t.translate * -1 : t.translate, o = Math.min(Math.max(a, t.maxTranslate()), t.minTranslate());
      t.setTranslate(o), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let s;
    if (i.freeMode && i.freeMode.enabled && !i.cssMode)
      r(), i.autoHeight && t.updateAutoHeight();
    else {
      if ((i.slidesPerView === "auto" || i.slidesPerView > 1) && t.isEnd && !i.centeredSlides) {
        const a = t.virtual && i.virtual.enabled ? t.virtual.slides : t.slides;
        s = t.slideTo(a.length - 1, 0, !1, !0);
      } else
        s = t.slideTo(t.activeIndex, 0, !1, !0);
      s || r();
    }
    i.watchOverflow && n !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, n) {
    n === void 0 && (n = !0);
    const i = this, r = i.params.direction;
    return t || (t = r === "horizontal" ? "vertical" : "horizontal"), t === r || t !== "horizontal" && t !== "vertical" || (i.el.classList.remove(`${i.params.containerModifierClass}${r}`), i.el.classList.add(`${i.params.containerModifierClass}${t}`), i.emitContainerClasses(), i.params.direction = t, i.slides.forEach((s) => {
      t === "vertical" ? s.style.width = "" : s.style.height = "";
    }), i.emit("changeDirection"), n && i.update()), i;
  }
  changeLanguageDirection(t) {
    const n = this;
    n.rtl && t === "rtl" || !n.rtl && t === "ltr" || (n.rtl = t === "rtl", n.rtlTranslate = n.params.direction === "horizontal" && n.rtl, n.rtl ? (n.el.classList.add(`${n.params.containerModifierClass}rtl`), n.el.dir = "rtl") : (n.el.classList.remove(`${n.params.containerModifierClass}rtl`), n.el.dir = "ltr"), n.update());
  }
  mount(t) {
    const n = this;
    if (n.mounted) return !0;
    let i = t || n.params.el;
    if (typeof i == "string" && (i = document.querySelector(i)), !i)
      return !1;
    i.swiper = n, i.parentNode && i.parentNode.host && i.parentNode.host.nodeName === n.params.swiperElementNodeName.toUpperCase() && (n.isElement = !0);
    const r = () => `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let a = i && i.shadowRoot && i.shadowRoot.querySelector ? i.shadowRoot.querySelector(r()) : Ve(i, r())[0];
    return !a && n.params.createElements && (a = Dt("div", n.params.wrapperClass), i.append(a), Ve(i, `.${n.params.slideClass}`).forEach((o) => {
      a.append(o);
    })), Object.assign(n, {
      el: i,
      wrapperEl: a,
      slidesEl: n.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : a,
      hostEl: n.isElement ? i.parentNode.host : i,
      mounted: !0,
      // RTL
      rtl: i.dir.toLowerCase() === "rtl" || it(i, "direction") === "rtl",
      rtlTranslate: n.params.direction === "horizontal" && (i.dir.toLowerCase() === "rtl" || it(i, "direction") === "rtl"),
      wrongRTL: it(a, "display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const n = this;
    if (n.initialized || n.mount(t) === !1) return n;
    n.emit("beforeInit"), n.params.breakpoints && n.setBreakpoint(), n.addClasses(), n.updateSize(), n.updateSlides(), n.params.watchOverflow && n.checkOverflow(), n.params.grabCursor && n.enabled && n.setGrabCursor(), n.params.loop && n.virtual && n.params.virtual.enabled ? n.slideTo(n.params.initialSlide + n.virtual.slidesBefore, 0, n.params.runCallbacksOnInit, !1, !0) : n.slideTo(n.params.initialSlide, 0, n.params.runCallbacksOnInit, !1, !0), n.params.loop && n.loopCreate(void 0, !0), n.attachEvents();
    const r = [...n.el.querySelectorAll('[loading="lazy"]')];
    return n.isElement && r.push(...n.hostEl.querySelectorAll('[loading="lazy"]')), r.forEach((s) => {
      s.complete ? an(n, s) : s.addEventListener("load", (a) => {
        an(n, a.target);
      });
    }), di(n), n.initialized = !0, di(n), n.emit("init"), n.emit("afterInit"), n;
  }
  destroy(t, n) {
    t === void 0 && (t = !0), n === void 0 && (n = !0);
    const i = this, {
      params: r,
      el: s,
      wrapperEl: a,
      slides: o
    } = i;
    return typeof i.params > "u" || i.destroyed || (i.emit("beforeDestroy"), i.initialized = !1, i.detachEvents(), r.loop && i.loopDestroy(), n && (i.removeClasses(), s && typeof s != "string" && s.removeAttribute("style"), a && a.removeAttribute("style"), o && o.length && o.forEach((c) => {
      c.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), c.removeAttribute("style"), c.removeAttribute("data-swiper-slide-index");
    })), i.emit("destroy"), Object.keys(i.eventsListeners).forEach((c) => {
      i.off(c);
    }), t !== !1 && (i.el && typeof i.el != "string" && (i.el.swiper = null), au(i)), i.destroyed = !0), null;
  }
  static extendDefaults(t) {
    _e(Wn, t);
  }
  static get extendedDefaults() {
    return Wn;
  }
  static get defaults() {
    return dr;
  }
  static installModule(t) {
    Se.prototype.__modules__ || (Se.prototype.__modules__ = []);
    const n = Se.prototype.__modules__;
    typeof t == "function" && n.indexOf(t) < 0 && n.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((n) => Se.installModule(n)), Se) : (Se.installModule(t), Se);
  }
}
Object.keys(qn).forEach((e) => {
  Object.keys(qn[e]).forEach((t) => {
    Se.prototype[t] = qn[e][t];
  });
});
Se.use([vu, wu]);
function Sp(e, t, n, i) {
  return e.params.createElements && Object.keys(i).forEach((r) => {
    if (!n[r] && n.auto === !0) {
      let s = Ve(e.el, `.${i[r]}`)[0];
      s || (s = Dt("div", i[r]), s.className = i[r], e.el.append(s)), n[r] = s, t[r] = s;
    }
  }), n;
}
function nt(e) {
  return e === void 0 && (e = ""), `.${e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Tp(e) {
  let {
    swiper: t,
    extendParams: n,
    on: i,
    emit: r
  } = e;
  const s = "swiper-pagination";
  n({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (m) => m,
      formatFractionTotal: (m) => m,
      bulletClass: `${s}-bullet`,
      bulletActiveClass: `${s}-bullet-active`,
      modifierClass: `${s}-`,
      currentClass: `${s}-current`,
      totalClass: `${s}-total`,
      hiddenClass: `${s}-hidden`,
      progressbarFillClass: `${s}-progressbar-fill`,
      progressbarOppositeClass: `${s}-progressbar-opposite`,
      clickableClass: `${s}-clickable`,
      lockClass: `${s}-lock`,
      horizontalClass: `${s}-horizontal`,
      verticalClass: `${s}-vertical`,
      paginationDisabledClass: `${s}-disabled`
    }
  }), t.pagination = {
    el: null,
    bullets: []
  };
  let a, o = 0;
  function c() {
    return !t.params.pagination.el || !t.pagination.el || Array.isArray(t.pagination.el) && t.pagination.el.length === 0;
  }
  function l(m, f) {
    const {
      bulletActiveClass: v
    } = t.params.pagination;
    m && (m = m[`${f === "prev" ? "previous" : "next"}ElementSibling`], m && (m.classList.add(`${v}-${f}`), m = m[`${f === "prev" ? "previous" : "next"}ElementSibling`], m && m.classList.add(`${v}-${f}-${f}`)));
  }
  function u(m, f, v) {
    if (m = m % v, f = f % v, f === m + 1)
      return "next";
    if (f === m - 1)
      return "previous";
  }
  function p(m) {
    const f = m.target.closest(nt(t.params.pagination.bulletClass));
    if (!f)
      return;
    m.preventDefault();
    const v = Vt(f) * t.params.slidesPerGroup;
    if (t.params.loop) {
      if (t.realIndex === v) return;
      const w = u(t.realIndex, v, t.slides.length);
      w === "next" ? t.slideNext() : w === "previous" ? t.slidePrev() : t.slideToLoop(v);
    } else
      t.slideTo(v);
  }
  function h() {
    const m = t.rtl, f = t.params.pagination;
    if (c()) return;
    let v = t.pagination.el;
    v = Z(v);
    let w, T;
    const N = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length, A = t.params.loop ? Math.ceil(N / t.params.slidesPerGroup) : t.snapGrid.length;
    if (t.params.loop ? (T = t.previousRealIndex || 0, w = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex) : typeof t.snapIndex < "u" ? (w = t.snapIndex, T = t.previousSnapIndex) : (T = t.previousIndex || 0, w = t.activeIndex || 0), f.type === "bullets" && t.pagination.bullets && t.pagination.bullets.length > 0) {
      const R = t.pagination.bullets;
      let S, k, P;
      if (f.dynamicBullets && (a = li(R[0], t.isHorizontal() ? "width" : "height"), v.forEach((D) => {
        D.style[t.isHorizontal() ? "width" : "height"] = `${a * (f.dynamicMainBullets + 4)}px`;
      }), f.dynamicMainBullets > 1 && T !== void 0 && (o += w - (T || 0), o > f.dynamicMainBullets - 1 ? o = f.dynamicMainBullets - 1 : o < 0 && (o = 0)), S = Math.max(w - o, 0), k = S + (Math.min(R.length, f.dynamicMainBullets) - 1), P = (k + S) / 2), R.forEach((D) => {
        const V = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((z) => `${f.bulletActiveClass}${z}`)].map((z) => typeof z == "string" && z.includes(" ") ? z.split(" ") : z).flat();
        D.classList.remove(...V);
      }), v.length > 1)
        R.forEach((D) => {
          const V = Vt(D);
          V === w ? D.classList.add(...f.bulletActiveClass.split(" ")) : t.isElement && D.setAttribute("part", "bullet"), f.dynamicBullets && (V >= S && V <= k && D.classList.add(...`${f.bulletActiveClass}-main`.split(" ")), V === S && l(D, "prev"), V === k && l(D, "next"));
        });
      else {
        const D = R[w];
        if (D && D.classList.add(...f.bulletActiveClass.split(" ")), t.isElement && R.forEach((V, z) => {
          V.setAttribute("part", z === w ? "bullet-active" : "bullet");
        }), f.dynamicBullets) {
          const V = R[S], z = R[k];
          for (let O = S; O <= k; O += 1)
            R[O] && R[O].classList.add(...`${f.bulletActiveClass}-main`.split(" "));
          l(V, "prev"), l(z, "next");
        }
      }
      if (f.dynamicBullets) {
        const D = Math.min(R.length, f.dynamicMainBullets + 4), V = (a * D - a) / 2 - P * a, z = m ? "right" : "left";
        R.forEach((O) => {
          O.style[t.isHorizontal() ? z : "top"] = `${V}px`;
        });
      }
    }
    v.forEach((R, S) => {
      if (f.type === "fraction" && (R.querySelectorAll(nt(f.currentClass)).forEach((k) => {
        k.textContent = f.formatFractionCurrent(w + 1);
      }), R.querySelectorAll(nt(f.totalClass)).forEach((k) => {
        k.textContent = f.formatFractionTotal(A);
      })), f.type === "progressbar") {
        let k;
        f.progressbarOpposite ? k = t.isHorizontal() ? "vertical" : "horizontal" : k = t.isHorizontal() ? "horizontal" : "vertical";
        const P = (w + 1) / A;
        let D = 1, V = 1;
        k === "horizontal" ? D = P : V = P, R.querySelectorAll(nt(f.progressbarFillClass)).forEach((z) => {
          z.style.transform = `translate3d(0,0,0) scaleX(${D}) scaleY(${V})`, z.style.transitionDuration = `${t.params.speed}ms`;
        });
      }
      f.type === "custom" && f.renderCustom ? (ci(R, f.renderCustom(t, w + 1, A)), S === 0 && r("paginationRender", R)) : (S === 0 && r("paginationRender", R), r("paginationUpdate", R)), t.params.watchOverflow && t.enabled && R.classList[t.isLocked ? "add" : "remove"](f.lockClass);
    });
  }
  function g() {
    const m = t.params.pagination;
    if (c()) return;
    const f = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.grid && t.params.grid.rows > 1 ? t.slides.length / Math.ceil(t.params.grid.rows) : t.slides.length;
    let v = t.pagination.el;
    v = Z(v);
    let w = "";
    if (m.type === "bullets") {
      let T = t.params.loop ? Math.ceil(f / t.params.slidesPerGroup) : t.snapGrid.length;
      t.params.freeMode && t.params.freeMode.enabled && T > f && (T = f);
      for (let N = 0; N < T; N += 1)
        m.renderBullet ? w += m.renderBullet.call(t, N, m.bulletClass) : w += `<${m.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${m.bulletClass}"></${m.bulletElement}>`;
    }
    m.type === "fraction" && (m.renderFraction ? w = m.renderFraction.call(t, m.currentClass, m.totalClass) : w = `<span class="${m.currentClass}"></span> / <span class="${m.totalClass}"></span>`), m.type === "progressbar" && (m.renderProgressbar ? w = m.renderProgressbar.call(t, m.progressbarFillClass) : w = `<span class="${m.progressbarFillClass}"></span>`), t.pagination.bullets = [], v.forEach((T) => {
      m.type !== "custom" && ci(T, w || ""), m.type === "bullets" && t.pagination.bullets.push(...T.querySelectorAll(nt(m.bulletClass)));
    }), m.type !== "custom" && r("paginationRender", v[0]);
  }
  function _() {
    t.params.pagination = Sp(t, t.originalParams.pagination, t.params.pagination, {
      el: "swiper-pagination"
    });
    const m = t.params.pagination;
    if (!m.el) return;
    let f;
    typeof m.el == "string" && t.isElement && (f = t.el.querySelector(m.el)), !f && typeof m.el == "string" && (f = [...document.querySelectorAll(m.el)]), f || (f = m.el), !(!f || f.length === 0) && (t.params.uniqueNavElements && typeof m.el == "string" && Array.isArray(f) && f.length > 1 && (f = [...t.el.querySelectorAll(m.el)], f.length > 1 && (f = f.find((v) => Qr(v, ".swiper")[0] === t.el))), Array.isArray(f) && f.length === 1 && (f = f[0]), Object.assign(t.pagination, {
      el: f
    }), f = Z(f), f.forEach((v) => {
      m.type === "bullets" && m.clickable && v.classList.add(...(m.clickableClass || "").split(" ")), v.classList.add(m.modifierClass + m.type), v.classList.add(t.isHorizontal() ? m.horizontalClass : m.verticalClass), m.type === "bullets" && m.dynamicBullets && (v.classList.add(`${m.modifierClass}${m.type}-dynamic`), o = 0, m.dynamicMainBullets < 1 && (m.dynamicMainBullets = 1)), m.type === "progressbar" && m.progressbarOpposite && v.classList.add(m.progressbarOppositeClass), m.clickable && v.addEventListener("click", p), t.enabled || v.classList.add(m.lockClass);
    }));
  }
  function b() {
    const m = t.params.pagination;
    if (c()) return;
    let f = t.pagination.el;
    f && (f = Z(f), f.forEach((v) => {
      v.classList.remove(m.hiddenClass), v.classList.remove(m.modifierClass + m.type), v.classList.remove(t.isHorizontal() ? m.horizontalClass : m.verticalClass), m.clickable && (v.classList.remove(...(m.clickableClass || "").split(" ")), v.removeEventListener("click", p));
    })), t.pagination.bullets && t.pagination.bullets.forEach((v) => v.classList.remove(...m.bulletActiveClass.split(" ")));
  }
  i("changeDirection", () => {
    if (!t.pagination || !t.pagination.el) return;
    const m = t.params.pagination;
    let {
      el: f
    } = t.pagination;
    f = Z(f), f.forEach((v) => {
      v.classList.remove(m.horizontalClass, m.verticalClass), v.classList.add(t.isHorizontal() ? m.horizontalClass : m.verticalClass);
    });
  }), i("init", () => {
    t.params.pagination.enabled === !1 ? y() : (_(), g(), h());
  }), i("activeIndexChange", () => {
    typeof t.snapIndex > "u" && h();
  }), i("snapIndexChange", () => {
    h();
  }), i("snapGridLengthChange", () => {
    g(), h();
  }), i("destroy", () => {
    b();
  }), i("enable disable", () => {
    let {
      el: m
    } = t.pagination;
    m && (m = Z(m), m.forEach((f) => f.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)));
  }), i("lock unlock", () => {
    h();
  }), i("click", (m, f) => {
    const v = f.target, w = Z(t.pagination.el);
    if (t.params.pagination.el && t.params.pagination.hideOnClick && w && w.length > 0 && !v.classList.contains(t.params.pagination.bulletClass)) {
      if (t.navigation && (t.navigation.nextEl && v === t.navigation.nextEl || t.navigation.prevEl && v === t.navigation.prevEl)) return;
      const T = w[0].classList.contains(t.params.pagination.hiddenClass);
      r(T === !0 ? "paginationShow" : "paginationHide"), w.forEach((N) => N.classList.toggle(t.params.pagination.hiddenClass));
    }
  });
  const E = () => {
    t.el.classList.remove(t.params.pagination.paginationDisabledClass);
    let {
      el: m
    } = t.pagination;
    m && (m = Z(m), m.forEach((f) => f.classList.remove(t.params.pagination.paginationDisabledClass))), _(), g(), h();
  }, y = () => {
    t.el.classList.add(t.params.pagination.paginationDisabledClass);
    let {
      el: m
    } = t.pagination;
    m && (m = Z(m), m.forEach((f) => f.classList.add(t.params.pagination.paginationDisabledClass))), b();
  };
  Object.assign(t.pagination, {
    enable: E,
    disable: y,
    render: g,
    update: h,
    init: _,
    destroy: b
  });
}
function Np(e) {
  let {
    swiper: t,
    extendParams: n,
    on: i
  } = e;
  n({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), t.a11y = {
    clicked: !1
  };
  let r = null, s, a, o = (/* @__PURE__ */ new Date()).getTime();
  function c(C) {
    const M = r;
    M.length !== 0 && ci(M, C);
  }
  function l(C) {
    const M = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(C).replace(/x/g, M);
  }
  function u(C) {
    C = Z(C), C.forEach((M) => {
      M.setAttribute("tabIndex", "0");
    });
  }
  function p(C) {
    C = Z(C), C.forEach((M) => {
      M.setAttribute("tabIndex", "-1");
    });
  }
  function h(C, M) {
    C = Z(C), C.forEach(($) => {
      $.setAttribute("role", M);
    });
  }
  function g(C, M) {
    C = Z(C), C.forEach(($) => {
      $.setAttribute("aria-roledescription", M);
    });
  }
  function _(C, M) {
    C = Z(C), C.forEach(($) => {
      $.setAttribute("aria-controls", M);
    });
  }
  function b(C, M) {
    C = Z(C), C.forEach(($) => {
      $.setAttribute("aria-label", M);
    });
  }
  function E(C, M) {
    C = Z(C), C.forEach(($) => {
      $.setAttribute("id", M);
    });
  }
  function y(C, M) {
    C = Z(C), C.forEach(($) => {
      $.setAttribute("aria-live", M);
    });
  }
  function m(C) {
    C = Z(C), C.forEach((M) => {
      M.setAttribute("aria-disabled", !0);
    });
  }
  function f(C) {
    C = Z(C), C.forEach((M) => {
      M.setAttribute("aria-disabled", !1);
    });
  }
  function v(C) {
    if (C.keyCode !== 13 && C.keyCode !== 32) return;
    const M = t.params.a11y, $ = C.target;
    if (!(t.pagination && t.pagination.el && ($ === t.pagination.el || t.pagination.el.contains(C.target)) && !C.target.matches(nt(t.params.pagination.bulletClass)))) {
      if (t.navigation && t.navigation.prevEl && t.navigation.nextEl) {
        const q = Z(t.navigation.prevEl);
        Z(t.navigation.nextEl).includes($) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? c(M.lastSlideMessage) : c(M.nextSlideMessage)), q.includes($) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? c(M.firstSlideMessage) : c(M.prevSlideMessage));
      }
      t.pagination && $.matches(nt(t.params.pagination.bulletClass)) && $.click();
    }
  }
  function w() {
    if (t.params.loop || t.params.rewind || !t.navigation) return;
    const {
      nextEl: C,
      prevEl: M
    } = t.navigation;
    M && (t.isBeginning ? (m(M), p(M)) : (f(M), u(M))), C && (t.isEnd ? (m(C), p(C)) : (f(C), u(C)));
  }
  function T() {
    return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
  }
  function N() {
    return T() && t.params.pagination.clickable;
  }
  function A() {
    const C = t.params.a11y;
    T() && t.pagination.bullets.forEach((M) => {
      t.params.pagination.clickable && (u(M), t.params.pagination.renderBullet || (h(M, "button"), b(M, C.paginationBulletMessage.replace(/\{\{index\}\}/, Vt(M) + 1)))), M.matches(nt(t.params.pagination.bulletActiveClass)) ? M.setAttribute("aria-current", "true") : M.removeAttribute("aria-current");
    });
  }
  const R = (C, M, $) => {
    u(C), C.tagName !== "BUTTON" && (h(C, "button"), C.addEventListener("keydown", v)), b(C, $), _(C, M);
  }, S = (C) => {
    a && a !== C.target && !a.contains(C.target) && (s = !0), t.a11y.clicked = !0;
  }, k = () => {
    s = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        t.destroyed || (t.a11y.clicked = !1);
      });
    });
  }, P = (C) => {
    o = (/* @__PURE__ */ new Date()).getTime();
  }, D = (C) => {
    if (t.a11y.clicked || !t.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - o < 100) return;
    const M = C.target.closest(`.${t.params.slideClass}, swiper-slide`);
    if (!M || !t.slides.includes(M)) return;
    a = M;
    const $ = t.slides.indexOf(M) === t.activeIndex, q = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(M);
    $ || q || C.sourceCapabilities && C.sourceCapabilities.firesTouchEvents || (t.isHorizontal() ? t.el.scrollLeft = 0 : t.el.scrollTop = 0, requestAnimationFrame(() => {
      s || (t.params.loop ? t.slideToLoop(parseInt(M.getAttribute("data-swiper-slide-index")), 0) : t.slideTo(t.slides.indexOf(M), 0), s = !1);
    }));
  }, V = () => {
    const C = t.params.a11y;
    C.itemRoleDescriptionMessage && g(t.slides, C.itemRoleDescriptionMessage), C.slideRole && h(t.slides, C.slideRole);
    const M = t.slides.length;
    C.slideLabelMessage && t.slides.forEach(($, q) => {
      const ie = t.params.loop ? parseInt($.getAttribute("data-swiper-slide-index"), 10) : q, H = C.slideLabelMessage.replace(/\{\{index\}\}/, ie + 1).replace(/\{\{slidesLength\}\}/, M);
      b($, H);
    });
  }, z = () => {
    const C = t.params.a11y;
    t.el.append(r);
    const M = t.el;
    C.containerRoleDescriptionMessage && g(M, C.containerRoleDescriptionMessage), C.containerMessage && b(M, C.containerMessage), C.containerRole && h(M, C.containerRole);
    const $ = t.wrapperEl, q = C.id || $.getAttribute("id") || `swiper-wrapper-${l(16)}`, ie = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
    E($, q), y($, ie), V();
    let {
      nextEl: H,
      prevEl: W
    } = t.navigation ? t.navigation : {};
    H = Z(H), W = Z(W), H && H.forEach((ue) => R(ue, q, C.nextSlideMessage)), W && W.forEach((ue) => R(ue, q, C.prevSlideMessage)), N() && Z(t.pagination.el).forEach((Re) => {
      Re.addEventListener("keydown", v);
    }), Ze().addEventListener("visibilitychange", P), t.el.addEventListener("focus", D, !0), t.el.addEventListener("focus", D, !0), t.el.addEventListener("pointerdown", S, !0), t.el.addEventListener("pointerup", k, !0);
  };
  function O() {
    r && r.remove();
    let {
      nextEl: C,
      prevEl: M
    } = t.navigation ? t.navigation : {};
    C = Z(C), M = Z(M), C && C.forEach((q) => q.removeEventListener("keydown", v)), M && M.forEach((q) => q.removeEventListener("keydown", v)), N() && Z(t.pagination.el).forEach((ie) => {
      ie.removeEventListener("keydown", v);
    }), Ze().removeEventListener("visibilitychange", P), t.el && typeof t.el != "string" && (t.el.removeEventListener("focus", D, !0), t.el.removeEventListener("pointerdown", S, !0), t.el.removeEventListener("pointerup", k, !0));
  }
  i("beforeInit", () => {
    r = Dt("span", t.params.a11y.notificationClass), r.setAttribute("aria-live", "assertive"), r.setAttribute("aria-atomic", "true");
  }), i("afterInit", () => {
    t.params.a11y.enabled && z();
  }), i("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    t.params.a11y.enabled && V();
  }), i("fromEdge toEdge afterInit lock unlock", () => {
    t.params.a11y.enabled && w();
  }), i("paginationUpdate", () => {
    t.params.a11y.enabled && A();
  }), i("destroy", () => {
    t.params.a11y.enabled && O();
  });
}
function Cp(e) {
  const {
    effect: t,
    swiper: n,
    on: i,
    setTranslate: r,
    setTransition: s,
    overwriteParams: a,
    perspective: o,
    recreateShadows: c,
    getEffectParams: l
  } = e;
  i("beforeInit", () => {
    if (n.params.effect !== t) return;
    n.classNames.push(`${n.params.containerModifierClass}${t}`), o && o() && n.classNames.push(`${n.params.containerModifierClass}3d`);
    const p = a ? a() : {};
    Object.assign(n.params, p), Object.assign(n.originalParams, p);
  }), i("setTranslate _virtualUpdated", () => {
    n.params.effect === t && r();
  }), i("setTransition", (p, h) => {
    n.params.effect === t && s(h);
  }), i("transitionEnd", () => {
    if (n.params.effect === t && c) {
      if (!l || !l().slideShadows) return;
      n.slides.forEach((p) => {
        p.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((h) => h.remove());
      }), c();
    }
  });
  let u;
  i("virtualUpdate", () => {
    n.params.effect === t && (n.slides.length || (u = !0), requestAnimationFrame(() => {
      u && n.slides && n.slides.length && (r(), u = !1);
    }));
  });
}
function Ap(e, t) {
  const n = Kr(t);
  return n !== t && (n.style.backfaceVisibility = "hidden", n.style["-webkit-backface-visibility"] = "hidden"), n;
}
function Mp(e) {
  let {
    swiper: t,
    duration: n,
    transformElements: i
  } = e;
  const {
    activeIndex: r
  } = t;
  if (t.params.virtualTranslate && n !== 0) {
    let s = !1, a;
    a = i, a.forEach((o) => {
      fu(o, () => {
        if (s || !t || t.destroyed) return;
        s = !0, t.animating = !1;
        const c = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        t.wrapperEl.dispatchEvent(c);
      });
    });
  }
}
function Ip(e) {
  let {
    swiper: t,
    extendParams: n,
    on: i
  } = e;
  n({
    fadeEffect: {
      crossFade: !1
    }
  }), Cp({
    effect: "fade",
    swiper: t,
    on: i,
    setTranslate: () => {
      const {
        slides: a
      } = t, o = t.params.fadeEffect;
      for (let c = 0; c < a.length; c += 1) {
        const l = t.slides[c];
        let p = -l.swiperSlideOffset;
        t.params.virtualTranslate || (p -= t.translate);
        let h = 0;
        t.isHorizontal() || (h = p, p = 0);
        const g = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(l.progress), 0) : 1 + Math.min(Math.max(l.progress, -1), 0), _ = Ap(o, l);
        _.style.opacity = g, _.style.transform = `translate3d(${p}px, ${h}px, 0px)`;
      }
    },
    setTransition: (a) => {
      const o = t.slides.map((c) => Kr(c));
      o.forEach((c) => {
        c.style.transitionDuration = `${a}ms`;
      }), Mp({
        swiper: t,
        duration: a,
        transformElements: o
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !t.params.cssMode
    })
  });
}
const Rp = "swiper", kp = "teaser", Lp = "swiper__controls", Ye = {
  swiper: Rp,
  "swiper-slide": "swiper-slide",
  teaser: kp,
  "swiper-pagination": "swiper-pagination",
  "swiper-pagination-current": "swiper-pagination-current",
  "swiper-pagination-total": "swiper-pagination-total",
  "swiper-pagination-fraction": "swiper-pagination-fraction",
  "swiper__button-next-custom": "swiper__button-next-custom",
  "swiper__button-prev-custom": "swiper__button-prev-custom",
  "swiper__button-icon-custom": "swiper__button-icon-custom",
  "swiper__button--disabled": "swiper__button--disabled",
  swiper__controls: Lp,
  "swiper__controls-wrapper": "swiper__controls-wrapper",
  "swiper__controls-wrapper--navigation-hidden": "swiper__controls-wrapper--navigation-hidden"
};
var vn = /* @__PURE__ */ ((e) => (e.BY_SLIDE = "by-slide", e.BY_PAGE = "by-page", e))(vn || {}), at = /* @__PURE__ */ ((e) => (e.ENTER_FROM_RIGHT = "enter-from-right", e.CROSSFADE = "crossfade", e))(at || {});
const ur = (e) => e <= 2 ? 1 : 2, Yn = {
  [ne.SMALL]: 25,
  [ne.MEDIUM]: 24,
  [ne.LARGE]: 30,
  [ne.X_LARGE]: 0,
  // unused, 0 is library default
  [ne.XX_LARGE]: 0
  // unused, 0 is library default
}, Pp = {
  [at.ENTER_FROM_RIGHT]: 500,
  [at.CROSSFADE]: 800
}, Op = {
  [at.ENTER_FROM_RIGHT]: "slide",
  [at.CROSSFADE]: "fade"
}, Dp = (e, t, n) => ({
  [ne.SMALL]: {
    spaceBetween: Yn[ne.SMALL],
    slidesPerView: 1,
    slidesPerGroup: 1
  },
  [ne.MEDIUM]: {
    spaceBetween: Yn[ne.MEDIUM],
    slidesPerView: ur(e),
    slidesPerGroup: n === vn.BY_PAGE ? ur(e) : 1
  },
  [ne.LARGE]: {
    spaceBetween: Yn[ne.LARGE],
    /**
     * https://github.com/nolimits4web/swiper/issues/2062
     */
    slidesPerView: t === at.CROSSFADE ? 1 : e,
    slidesPerGroup: n === vn.BY_PAGE ? e : 1
  }
}), Vp = (e) => Pp[e], $p = (e) => Op[e], jn = (e) => {
  const t = e.el.querySelectorAll(".swiper-slide-visible"), n = Array.from(t);
  e.slides.forEach((i) => {
    n.includes(i) ? (i.removeAttribute("inert"), i.removeAttribute("aria-hidden")) : (i.setAttribute("inert", ""), i.setAttribute("aria-hidden", "true"));
  });
}, nf = ({
  id: e,
  slidesPerPage: t,
  nextSlideLabel: n,
  prevSlideLabel: i,
  trackSlide: r,
  transition: s = vn.BY_PAGE,
  animation: a,
  slot: o,
  children: c
}) => {
  const l = `${Ie(36)}rem`, [u, p] = B(0), [h, g] = B(!0), [_, b] = B(!1), [E, y] = B(!1), m = G(null), f = G(null), v = qr(), w = (A) => {
    g(A.isBeginning), b(A.isEnd);
  };
  U(() => (v && a !== at.CROSSFADE ? p(0) : p(Vp(a)), m.current && (f.current = new Se(m.current, {
    a11y: { enabled: !0 },
    modules: [Tp, Ip, Np],
    watchSlidesProgress: !0,
    watchOverflow: !0,
    noSwipingClass: "vjs-control-bar",
    navigation: !1,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      renderFraction(A, R) {
        return document.documentElement.getAttribute("dir") === "rtl" ? `<span class="${R}"></span>/<span class="${A}"></span>` : `<span class="${A}"></span>/<span class="${R}"></span>`;
      }
    },
    on: {
      init: (A) => {
        w(A), jn(A), y(A.isLocked);
      },
      slideChange: (A) => {
        w(A), jn(A);
      },
      activeIndexChange: (A) => {
        r(A.snapIndex, A.previousIndex, e);
      },
      resize: (A) => {
        w(A), jn(A), y(A.isLocked);
      },
      lock: () => y(!0),
      unlock: () => y(!1)
    },
    effect: $p(a),
    fadeEffect: {
      crossFade: a === at.CROSSFADE
    },
    speed: u,
    observer: !0,
    observeParents: !0,
    breakpoints: Dp(t, a, s)
  })), () => {
    f.current && (f.current.destroy(), f.current = null);
  }), [v]);
  const T = () => {
    f.current && f.current.slideNext(u);
  }, N = () => {
    f.current && f.current.slidePrev(u);
  };
  return c ? /* @__PURE__ */ I("div", { className: "swiper", ref: m, slot: o, children: [
    /* @__PURE__ */ d("div", { className: "swiper-wrapper", children: c.map((A, R) => /* @__PURE__ */ d(
      "div",
      {
        className: "swiper-slide",
        children: A
      },
      `swiper-slide-${R}`
    )) }),
    /* @__PURE__ */ d(
      "div",
      {
        className: L(
          Ye["swiper__controls-wrapper"],
          E && Ye["swiper__controls-wrapper--navigation-hidden"]
        ),
        children: /* @__PURE__ */ I("div", { className: Ye.swiper__controls, children: [
          /* @__PURE__ */ d(
            "button",
            {
              className: L(Ye["swiper__button-prev-custom"], h && Ye["swiper__button--disabled"]),
              onClick: N,
              disabled: h,
              "aria-disabled": h,
              "aria-label": i,
              type: "button",
              children: /* @__PURE__ */ d("span", { className: Ye["swiper__button-icon-custom"], children: /* @__PURE__ */ d(F, { icon: "chevron-left", height: l, decorative: !0 }) })
            }
          ),
          /* @__PURE__ */ d("div", { className: "swiper-pagination" }),
          /* @__PURE__ */ d(
            "button",
            {
              className: L(Ye["swiper__button-next-custom"], _ && Ye["swiper__button--disabled"]),
              onClick: T,
              disabled: _,
              "aria-disabled": _,
              "aria-label": n,
              type: "button",
              children: /* @__PURE__ */ d("span", { className: Ye["swiper__button-icon-custom"], children: /* @__PURE__ */ d(F, { icon: "chevron-right", height: l, decorative: !0 }) })
            }
          )
        ] })
      }
    )
  ] }) : null;
}, Le = {
  "social-media": "social-media",
  "social-media__overline": "social-media__overline",
  "social-media__links-list": "social-media__links-list",
  "social-media__icon": "social-media__icon",
  "social-media__link-wrapper": "social-media__link-wrapper",
  "social-media__link": "social-media__link",
  "social-media--align-left": "social-media--align-left",
  "social-media--align-center": "social-media--align-center",
  "social-media--align-right": "social-media--align-right"
};
var kt = /* @__PURE__ */ ((e) => (e.DEFAULT = "", e.LEFT = "left", e.CENTER = "center", e.RIGHT = "right", e))(kt || {});
const zp = 24, rf = ({
  overline: e,
  align: t = kt.DEFAULT,
  disableFacebook: n = !1,
  disableTwitter: i = !1,
  disableLinkedin: r = !1,
  mailToSubject: s,
  url: a,
  facebookLabel: o,
  twitterLabel: c,
  linkedinLabel: l,
  copylinkLabel: u,
  copySuccessLabel: p,
  onClick: h
}) => {
  const { refs: g, floatingStyles: _, context: b, arrowRef: E, open: y, setOpen: m } = Vr({ placement: "bottom" }), f = [
    {
      "data-social": "email",
      icon: "mobile",
      href: `mailto:?subject=${s}&body=${a}`,
      type: "link",
      shouldRender: !1
    },
    {
      "data-social": "facebook",
      icon: "facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${a}`,
      type: "link",
      shouldRender: !n,
      ariaLabel: o
    },
    {
      "data-social": "twitter",
      icon: "twitter",
      href: `http://twitter.com/intent/tweet?url=${a}`,
      type: "link",
      shouldRender: !i,
      ariaLabel: c
    },
    {
      "data-social": "linkedin",
      icon: "linkedin",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${a}`,
      type: "link",
      shouldRender: !r,
      ariaLabel: l
    },
    {
      "data-social": "xing",
      icon: "mobile",
      href: `https://www.xing.com/spi/shares/new?url=${a}`,
      type: "link",
      shouldRender: !1
    },
    {
      "data-social": "copy",
      icon: "copy-link",
      href: "#",
      type: "button",
      shouldRender: !0,
      ariaLabel: u
    }
  ], v = async (T) => {
    const N = T.currentTarget.getAttribute("data-social");
    N === "copy" && (T.preventDefault(), await navigator.clipboard.writeText(a), m(!0), setTimeout(() => m(!1), 2200)), N && h && h(T, N);
  }, w = L(
    Le["social-media"],
    t === kt.LEFT && Le["social-media--align-left"],
    t === kt.CENTER && Le["social-media--align-center"],
    t === kt.RIGHT && Le["social-media--align-right"]
  );
  return /* @__PURE__ */ I("div", { className: w, children: [
    e && /* @__PURE__ */ d("p", { className: Le["social-media__overline"], children: e }),
    /* @__PURE__ */ d("ul", { className: Le["social-media__links-list"], children: f.map((T, N) => {
      const { shouldRender: A, icon: R, ariaLabel: S, type: k, ...P } = T;
      if (!A)
        return null;
      const D = T["data-social"], V = D === "copy";
      return (
        // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
        /* @__PURE__ */ I("li", { className: Le["social-media__link-wrapper"], children: [
          /* @__PURE__ */ d("span", { className: Le["social-media__icon"], children: /* @__PURE__ */ d(F, { icon: R, height: `${Ie(zp)}rem`, decorative: !0 }) }),
          k === "button" ? /* @__PURE__ */ d(
            "button",
            {
              className: Le["social-media__link"],
              ref: V ? g.setReference : void 0,
              onClick: v,
              "aria-label": S,
              "data-social": D,
              type: "button"
            }
          ) : (
            // biome-ignore lint/a11y/useAriaPropsSupportedByRole: aria-label is supported by <a> elements!
            /* @__PURE__ */ d(
              "a",
              {
                className: Le["social-media__link"],
                target: "_blank",
                rel: "noreferrer",
                "aria-label": S,
                ...P
              }
            )
          ),
          V && p && /* @__PURE__ */ d(
            $r,
            {
              floatingStyles: _,
              arrowRef: E,
              open: y,
              context: b,
              refs: g,
              children: p
            }
          )
        ] }, N)
      );
    }) })
  ] });
}, Hp = {
  "scale-on-scroll": "scale-on-scroll"
}, Bp = 1864, Fp = (e) => (Math.min(window.innerWidth, Bp) - e) / e, Gp = (e) => {
  const t = e.getAttribute("data-ratio");
  if (!t) return null;
  const [n, i] = t.split(":").map(parseFloat);
  return n && i ? [n, i] : null;
}, Up = ({ children: e }) => {
  const t = G(null), [n, i] = B(1), [r, s] = B("auto"), a = G(null);
  return U(() => {
    const o = t.current;
    if (!o)
      return;
    const c = () => {
      const u = o.querySelector(".image");
      if (!u) {
        a.current = null, s("auto");
        return;
      }
      const p = o.getBoundingClientRect().top + window.scrollY, h = o.getBoundingClientRect().width, g = Fp(h), _ = o.getBoundingClientRect().width, b = Gp(u), E = b ? Math.floor(_ * b[1] / b[0]) : 0;
      a.current = {
        initialSpaceToViewTop: p,
        initialHeight: E,
        widthPercentage: g
      };
      const y = E * (1 + g);
      s(`${y}px`);
    }, l = () => {
      c();
    };
    return window.addEventListener("resize", l), c(), () => {
      window.removeEventListener("resize", l);
    };
  }, []), U(() => {
    const o = t.current;
    if (!o || !a.current) return;
    const c = () => {
      const l = o.getBoundingClientRect().top, u = window.innerHeight;
      if (!(l > u || l < -0.3 * u) && a.current) {
        const { initialSpaceToViewTop: h, widthPercentage: g } = a.current, _ = Math.min(h, u), b = u > h, E = b ? 1 : 0.75, m = _ * (b ? 0.1 : 0.25), f = _ * (1 - E), v = _ - m - f, w = Math.min(
          Math.max((_ - l - m) / v, 0),
          1
        ), T = 1 + g * w;
        i(T);
      }
    };
    return window.addEventListener("scroll", c, { passive: !0 }), () => {
      window.removeEventListener("scroll", c);
    };
  }, [t.current, a.current]), /* @__PURE__ */ d(
    "div",
    {
      ref: t,
      className: Hp["scale-on-scroll"],
      style: {
        "--scale-factor": n,
        height: r
      },
      children: e
    }
  );
}, qp = {
  "stage-home__teasers": "stage-home__teasers"
}, sf = ({
  statement: e,
  Image: t,
  slot: n,
  children: i
}) => {
  const [r, s] = B(!1);
  U(() => {
    s(!0);
  }, []);
  const a = L({
    "stage-home": !0,
    "stage-home--original-branding": e === "Doing now what patients need next",
    "stage-home--heading-visible": r
  });
  return /* @__PURE__ */ I("div", { className: a, slot: n, children: [
    /* @__PURE__ */ d(_r, { headline: e, level: "1" }),
    /* @__PURE__ */ d(Up, { children: t }),
    /* @__PURE__ */ d("div", { className: qp["stage-home__teasers"], children: i })
  ] });
}, Rt = {
  "stage-home-teaser": "stage-home-teaser",
  "stage-home-teaser__title": "stage-home-teaser__title",
  "stage-home-teaser__description": "stage-home-teaser__description",
  "stage-home-teaser__button-wrapper": "stage-home-teaser__button-wrapper"
}, af = ({
  teaserTitle: e,
  teaserDescription: t,
  headingLevel: n = 2,
  children: i
}) => {
  const r = `h${n}`;
  return /* @__PURE__ */ I("div", { className: Rt["stage-home-teaser"], children: [
    /* @__PURE__ */ I("div", { className: Rt["stage-home-teaser__top-wrapper"], children: [
      /* @__PURE__ */ d(r, { className: Rt["stage-home-teaser__title"], children: e }),
      /* @__PURE__ */ d("p", { className: Rt["stage-home-teaser__description"], children: t })
    ] }),
    /* @__PURE__ */ d("div", { className: Rt["stage-home-teaser__button-wrapper"], children: i })
  ] });
};
var wn = /* @__PURE__ */ ((e) => (e.VARIANT_A = "hero--variant-a", e.VARIANT_B = "hero--variant-b", e))(wn || {});
const Wp = "image", Pe = {
  "staging-hero": "staging-hero",
  "staging-hero__background": "staging-hero__background",
  "staging-hero__image": "staging-hero__image",
  image: Wp,
  "staging-hero__wrapper": "staging-hero__wrapper",
  "staging-hero__content": "staging-hero__content",
  "staging-hero__headline": "staging-hero__headline",
  "staging-hero__text": "staging-hero__text",
  "staging-hero__divider": "staging-hero__divider",
  "hero--variant-a": "hero--variant-a",
  "staging-hero__letter": "staging-hero__letter",
  "hero--variant-b": "hero--variant-b"
}, of = ({
  variant: e = wn.VARIANT_A,
  headline: t,
  content: n,
  Image: i,
  slot: r
}) => {
  const s = e === wn.VARIANT_B, a = G(null), o = [Pe["staging-hero"], Pe[e]].filter(Boolean).join(" ");
  U(() => {
    var u;
    const l = (u = a.current) == null ? void 0 : u.closest("roche-grid");
    return l && (l.setAttribute("no-padding", "true"), l.setAttribute("data-staging-hero", e)), () => {
      l && (l.removeAttribute("no-padding"), l.removeAttribute("data-staging-hero"));
    };
  }, [e]);
  const c = s && i;
  return /* @__PURE__ */ I("section", { ref: a, className: o, "data-variant": e, slot: r, children: [
    /* @__PURE__ */ I("div", { className: Pe["staging-hero__wrapper"], children: [
      /* @__PURE__ */ d("div", { className: Pe["staging-hero__background"] }),
      /* @__PURE__ */ I("div", { className: Pe["staging-hero__content"], children: [
        /* @__PURE__ */ d("div", { className: Pe["staging-hero__letter"] }),
        t && /* @__PURE__ */ d("h1", { className: Pe["staging-hero__headline"], children: t }),
        n && /* @__PURE__ */ d("p", { className: Pe["staging-hero__text"], children: n })
      ] }),
      /* @__PURE__ */ d("div", { className: Pe["staging-hero__divider"] })
    ] }),
    c && /* @__PURE__ */ d("div", { className: Pe["staging-hero__image"], children: i })
  ] });
}, rs = 2, ss = (e, t = "", n = rs) => {
  const i = ["-", "", "+"][Math.sign(e) + 1], r = Math.abs(e).toFixed(n);
  return `${i}${t}${r}`;
}, Yp = (e) => `${ss(e, " ")}`, jp = (e) => `(${ss(e)}%)`, ae = {
  "stock-price": "stock-price",
  "stock-price__heading": "stock-price__heading",
  "stock-price__price": "stock-price__price",
  "stock-price__value": "stock-price__value",
  "stock-price__currency": "stock-price__currency",
  "stock-price__unavailable": "stock-price__unavailable",
  "stock-price__daily-change": "stock-price__daily-change",
  "stock-price__difference": "stock-price__difference",
  "stock-price__relative-difference": "stock-price__relative-difference",
  "stock-price__price-difference": "stock-price__price-difference",
  "stock-price__icon": "stock-price__icon",
  "stock-price__icon--down": "stock-price__icon--down",
  "stock-price__icon--equal": "stock-price__icon--equal",
  "stock-price__icon--up": "stock-price__icon--up"
}, lf = ({
  heading: e,
  href: t,
  price: n,
  currency: i,
  change: r,
  relativeChange: s,
  timeIntervalLabel: a,
  unavailableLabel: o
}) => {
  if (!(n !== void 0 && i !== void 0 && r !== void 0 && s !== void 0))
    return /* @__PURE__ */ I("div", { className: ae["stock-price"], children: [
      /* @__PURE__ */ d("h3", { className: ae["stock-price__heading"], children: e }),
      /* @__PURE__ */ d("span", { className: ae["stock-price__unavailable"], children: o })
    ] });
  const l = ["stock-down", "stock-equal", "stock-up"][Math.sign(r) + 1], u = L(ae["stock-price__icon"], {
    [ae["stock-price__icon--down"]]: l === "stock-down",
    [ae["stock-price__icon--equal"]]: l === "stock-equal",
    [ae["stock-price__icon--up"]]: l === "stock-up"
  });
  return /* @__PURE__ */ I("a", { className: ae["stock-price"], href: t, children: [
    /* @__PURE__ */ d("h3", { className: ae["stock-price__heading"], children: e }),
    /* @__PURE__ */ I("div", { className: ae["stock-price__price"], children: [
      /* @__PURE__ */ d("span", { className: ae["stock-price__value"], children: n.toFixed(rs) }),
      /* @__PURE__ */ d("span", { className: ae["stock-price__currency"], children: i })
    ] }),
    /* @__PURE__ */ I("div", { className: ae["stock-price__daily-change"], children: [
      /* @__PURE__ */ d("span", { className: u, "aria-hidden": "true", children: /* @__PURE__ */ d(F, { icon: l, height: "32px" }) }),
      /* @__PURE__ */ I("span", { className: ae["stock-price__difference"], children: [
        /* @__PURE__ */ d("span", { className: ae["stock-price__price-difference"], children: Yp(r) }),
        /* @__PURE__ */ d("span", { className: ae["stock-price__relative-difference"], children: jp(s) })
      ] }),
      /* @__PURE__ */ d("span", { className: ae["stock-price__time-interval"], children: a })
    ] })
  ] });
};
var je = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PODCAST = "podcast", e.SERIES = "series", e.SLIDESHOW = "slideshow", e.VIDEO = "video", e))(je || {}), Xp = /* @__PURE__ */ ((e) => (e.VARIANT_A = "story-teaser--variant-a", e.VARIANT_B = "story-teaser--variant-b", e.VARIANT_C = "story-teaser--variant-c", e))(Xp || {});
const ui = {
  [je.DEFAULT]: null,
  [je.PODCAST]: "podcasts",
  [je.SERIES]: "series",
  [je.SLIDESHOW]: "book",
  [je.VIDEO]: "play"
}, fe = {
  "story-staging-hero": "story-staging-hero",
  "story-staging-hero__background": "story-staging-hero__background",
  "story-staging-hero__wrapper": "story-staging-hero__wrapper",
  "story-staging-hero__content": "story-staging-hero__content",
  "story-staging-hero__header": "story-staging-hero__header",
  "story-staging-hero__headline": "story-staging-hero__headline",
  "story-staging-hero__text": "story-staging-hero__text",
  "story-staging-hero__divider": "story-staging-hero__divider",
  "story-staging-hero__story-type-wrapper": "story-staging-hero__story-type-wrapper",
  "story-staging-hero__story-type": "story-staging-hero__story-type",
  "story-staging-hero__tag-wrapper": "story-staging-hero__tag-wrapper",
  "hero--variant-a": "hero--variant-a",
  "story-staging-hero__letter": "story-staging-hero__letter",
  "story-staging-hero__image": "story-staging-hero__image",
  "hero--variant-b": "hero--variant-b",
  "story-staging-hero__icon": "story-staging-hero__icon"
}, cf = ({
  variant: e,
  storyHeadline: t,
  storyDescription: n,
  storyType: i,
  storyTypeTranslation: r,
  storyTags: s,
  showTags: a,
  Image: o,
  slot: c
}) => {
  const l = e === wn.VARIANT_B, u = G(null), p = [fe["story-staging-hero"], fe[e]].filter(Boolean).join(" "), h = l && a && s && s.length > 0, g = ui[i] ?? "", _ = l && i && i !== je.DEFAULT, b = l && o;
  return /* @__PURE__ */ I("section", { ref: u, className: p, "data-variant": e, slot: c, children: [
    /* @__PURE__ */ I("div", { className: fe["story-staging-hero__wrapper"], children: [
      /* @__PURE__ */ d("div", { className: fe["story-staging-hero__background"] }),
      /* @__PURE__ */ I("div", { className: fe["story-staging-hero__content"], children: [
        /* @__PURE__ */ d("div", { className: fe["story-staging-hero__letter"] }),
        _ && /* @__PURE__ */ I("div", { className: fe["story-staging-hero__story-type-wrapper"], children: [
          /* @__PURE__ */ d("span", { className: fe["story-staging-hero__icon"], children: /* @__PURE__ */ d(F, { icon: g, height: "24px" }) }),
          /* @__PURE__ */ d("span", { className: fe["story-staging-hero__story-type"], children: r })
        ] }),
        /* @__PURE__ */ I("div", { className: fe["story-staging-hero__header"], children: [
          t && /* @__PURE__ */ d("h1", { className: fe["story-staging-hero__headline"], children: t }),
          h && /* @__PURE__ */ d("div", { className: fe["story-staging-hero__tag-wrapper"], children: s })
        ] }),
        !l && /* @__PURE__ */ d("p", { className: fe["story-staging-hero__text"], children: n })
      ] }),
      /* @__PURE__ */ d("div", { className: fe["story-staging-hero__divider"] })
    ] }),
    b && /* @__PURE__ */ d("div", { className: fe["story-staging-hero__image"], children: o })
  ] });
}, Zp = (e) => {
  const [t, n] = B(0);
  return U(() => {
    const i = () => {
      e.current && n(e.current.clientWidth);
    }, r = new ResizeObserver(i);
    return e.current && r.observe(e.current), () => r.disconnect();
  }, [e.current]), { width: t };
}, Kp = "date", Qp = {
  date: Kp
}, as = ({ displayDate: e, dateTimeValue: t }) => /* @__PURE__ */ d("div", { className: Qp.date, children: /* @__PURE__ */ d("time", { dateTime: t, children: e }) }), Jp = "image", eh = "button", Oe = {
  "story-teaser": "story-teaser",
  image: Jp,
  "story-teaser__tag": "story-teaser__tag",
  "story-teaser__media-container": "story-teaser__media-container",
  "video-player": "video-player",
  "story-teaser__details": "story-teaser__details",
  "story-teaser__title": "story-teaser__title",
  "story-teaser__description": "story-teaser__description",
  "story-teaser__date": "story-teaser__date",
  "story-teaser--variant-a": "story-teaser--variant-a",
  "story-teaser__description-container": "story-teaser__description-container",
  "story-teaser--variant-b": "story-teaser--variant-b",
  "story-teaser--variant-c": "story-teaser--variant-c",
  button: eh,
  "story-teaser--unpublished": "story-teaser--unpublished"
}, pr = (e) => (t) => {
  e.forEach((n) => {
    n && (typeof n == "function" ? n(t) : n.current = t);
  });
}, df = bn(
  ({
    layout: e,
    teaserType: t = je.DEFAULT,
    teaserTitle: n,
    teaserDescription: i,
    teaserImage: r,
    teaserVideoId: s,
    teaserImageAlt: a,
    teaserUrl: o,
    teaserDate: c,
    dateTimeValue: l,
    teaserTagLabel: u,
    ctaLabel: p,
    unpublished: h,
    slot: g,
    playLabel: _,
    pauseLabel: b,
    onVideoStateChange: E,
    onTeaserLinkClick: y,
    awsServiceBaseUrl: m,
    imageFit: f = Mn.COVER
  }, v) => {
    const w = G(null), T = G(), { width: N } = Zp(T), [A, R] = B(0), S = Ei(s), k = S !== "", P = !!r, V = (() => {
      switch (e) {
        case "story-teaser--variant-a":
          return { ratio: oe.NORMAL };
        case "story-teaser--variant-b":
          return { ratio: oe.SIXTOFIVE };
        case "story-teaser--variant-c":
          return { ratio: oe.ORIGINAL, forceHeight: 480 };
        default:
          return { ratio: oe.ORIGINAL };
      }
    })(), z = P && /* @__PURE__ */ d(In, { src: r ?? "", alt: a, imageFit: f, ...V }), O = k && /* @__PURE__ */ d(
      Ti,
      {
        awsServiceBaseUrl: m,
        service: "aws",
        videoId: S,
        previewAlt: a ?? "",
        playLabel: _ ?? "",
        pauseLabel: b ?? "",
        videoLoop: !0,
        onVideoStateChange: (H) => {
          E && E(H);
        }
      }
    );
    U(() => {
      e === "story-teaser--variant-a" ? R(N ? N / 4 * 3 : 0) : w.current && R(w.current.clientHeight);
    }, [N, e, i]), U(() => {
      const H = (W) => {
        var re;
        W.key === "Escape" && ((re = T.current) == null || re.blur());
      };
      return window.addEventListener("keydown", H), () => {
        window.removeEventListener("keydown", H);
      };
    }, []);
    const C = (P || k) && /* @__PURE__ */ d("div", { className: Oe["story-teaser__media-container"], children: k ? O : z }), M = /* @__PURE__ */ I("div", { className: Oe["story-teaser__details"], children: [
      t !== je.DEFAULT && /* @__PURE__ */ I("div", { className: Oe["story-teaser__tag"], children: [
        ui[t] && /* @__PURE__ */ d(F, { icon: ui[t], height: `${Ie(20)}rem` }),
        /* @__PURE__ */ d("span", { children: u })
      ] }),
      /* @__PURE__ */ I("div", { className: Oe["story-teaser__description-container"], children: [
        /* @__PURE__ */ d("h3", { className: Oe["story-teaser__title"], children: n }),
        /* @__PURE__ */ d("p", { ref: w, className: Oe["story-teaser__description"], children: i })
      ] }),
      c && l && e === "story-teaser--variant-a" && /* @__PURE__ */ d("div", { className: Oe["story-teaser__date"], children: /* @__PURE__ */ d(as, { displayDate: c, dateTimeValue: l }) }),
      e === "story-teaser--variant-c" && p && /* @__PURE__ */ d(St, { text: p, href: o, onClick: y })
    ] }), $ = L(Oe["story-teaser"], Oe[e], {
      [Oe["story-teaser--unpublished"]]: h
    }), q = /* @__PURE__ */ d(
      "a",
      {
        ref: pr([T, v]),
        className: $,
        "aria-label": n,
        href: o,
        onClick: y,
        style: { "--teaser-hover-offset": `${A}px` },
        slot: g,
        children: /* @__PURE__ */ I("article", { children: [
          C,
          M
        ] })
      }
    ), ie = /* @__PURE__ */ I("article", { ref: pr([T, v]), className: $, slot: g, children: [
      C,
      M
    ] });
    return e === "story-teaser--variant-c" ? ie : q;
  }
), th = "subline", nh = "subline__avatar", ih = "subline__author", rh = "subline__date", Je = {
  subline: th,
  "subline__attribution-phrase": "subline__attribution-phrase",
  "subline__author-container": "subline__author-container",
  subline__avatar: nh,
  "subline__author-description-container": "subline__author-description-container",
  subline__author: ih,
  "subline__author-description": "subline__author-description",
  subline__date: rh
}, uf = ({
  author: e,
  authorDescription: t,
  attributionPhrase: n,
  displayDate: i,
  dateTimeValue: r,
  children: s
}) => /* @__PURE__ */ I("div", { className: Je.subline, children: [
  n && /* @__PURE__ */ d("h3", { className: Je["subline__attribution-phrase"], children: n }),
  /* @__PURE__ */ I("div", { className: Je["subline__author-container"], children: [
    s && /* @__PURE__ */ d("div", { className: Je.subline__avatar, children: s }),
    /* @__PURE__ */ I("div", { className: Je["subline__author-description-container"], children: [
      /* @__PURE__ */ d("p", { className: Je.subline__author, children: e }),
      /* @__PURE__ */ d("p", { className: Je["subline__author-description"], children: t }),
      i && r && /* @__PURE__ */ d("div", { className: Je.subline__date, children: /* @__PURE__ */ d(as, { dateTimeValue: r, displayDate: i }) })
    ] })
  ] })
] }), sh = "tag", ah = {
  tag: sh
}, pf = ({ tag: e, href: t, onClick: n, ariaLabel: i }) => /* @__PURE__ */ d("a", { href: t, className: ah.tag, onClick: n, "aria-label": i, children: e }), oh = "teaser", lh = "teaser__heading", ch = "teaser__overline", dh = "teaser__title", uh = "teaser__icon", ph = "teaser__description", hh = "teaser__border", fh = "teaser__video", ee = {
  teaser: oh,
  "teaser__media-container": "teaser__media-container",
  "teaser__link-wrapper": "teaser__link-wrapper",
  "teaser__image-border": "teaser__image-border",
  teaser__heading: lh,
  teaser__overline: ch,
  "teaser__overline-element": "teaser__overline-element",
  teaser__title: dh,
  "teaser__title--small": "teaser__title--small",
  teaser__icon: uh,
  teaser__description: ph,
  teaser__border: hh,
  "teaser__buttons-wrapper": "teaser__buttons-wrapper",
  "teaser__buttons-wrapper--align-left": "teaser__buttons-wrapper--align-left",
  "teaser--card": "teaser--card",
  "teaser--unpublished": "teaser--unpublished",
  "teaser--in-draft": "teaser--in-draft",
  "teaser__image--loaded": "teaser__image--loaded",
  "teaser__image--reduced-scale": "teaser__image--reduced-scale",
  teaser__video: fh
};
var j = /* @__PURE__ */ ((e) => (e.VARIANT_A = "teaser-variant-a", e.VARIANT_B = "teaser-variant-b", e.VARIANT_C = "teaser-variant-c", e.VARIANT_D = "teaser-variant-d", e.VARIANT_E = "teaser-variant-e", e.VARIANT_E_WITHOUT_DESCRIPTION = "teaser-variant-e-without-description", e.VARIANT_A_WITHOUT_IMAGE = "teaser-variant-a-without-image", e.VARIANT_B_WITHOUT_IMAGE = "teaser-variant-b-without-image", e.VARIANT_C_WITHOUT_IMAGE = "teaser-variant-c-without-image", e.VARIANT_D_WITHOUT_IMAGE = "teaser-variant-d-without-image", e.VARIANT_C_WITHOUT_IMAGE_WITH_DATE = "teaser-variant-c-without-image-with-date", e.CARD_A = "teaser--card-a", e.CARD_B = "teaser--card-b", e.CARD_C = "teaser--card-c", e.PUBMED = "teaser--pubmed", e))(j || {}), on = /* @__PURE__ */ ((e) => (e.DEFAULT = "arrow-right", e.DOWNLOAD = "download", e.EXTERNAL = "external-link", e))(on || {});
const mh = [
  j.VARIANT_A,
  j.VARIANT_A_WITHOUT_IMAGE,
  j.CARD_A,
  j.VARIANT_B,
  j.VARIANT_B_WITHOUT_IMAGE,
  j.CARD_B,
  j.VARIANT_E,
  j.PUBMED
], gh = [
  j.VARIANT_A,
  j.VARIANT_A_WITHOUT_IMAGE,
  j.CARD_A,
  j.VARIANT_C,
  j.VARIANT_C_WITHOUT_IMAGE,
  j.VARIANT_C_WITHOUT_IMAGE_WITH_DATE,
  j.CARD_C,
  j.PUBMED
], _h = [
  j.VARIANT_A,
  j.VARIANT_B,
  j.VARIANT_C,
  j.VARIANT_D,
  j.VARIANT_E,
  j.VARIANT_E_WITHOUT_DESCRIPTION
], vh = [j.CARD_A, j.CARD_B, j.CARD_C], hf = bn(
  ({
    teaserImage: e,
    teaserVideoId: t,
    teaserImageAlt: n,
    teaserTitle: i,
    teaserDescription: r,
    teaserOverline: s,
    teaserOverlineElement: a,
    teaserUrl: o,
    target: c = xn.SELF,
    isExternalLink: l,
    isDownloadLink: u,
    downloadTranslation: p,
    layout: h,
    secondaryButton: g,
    primaryButtonText: _,
    playLabel: b,
    pauseLabel: E,
    onTeaserClick: y,
    onVideoStateChange: m,
    isSearchResult: f,
    unpublished: v,
    isTeaserInDraft: w,
    teaserAuthorDescription: T,
    slot: N,
    loaded: A,
    forceAlignLeft: R,
    awsServiceBaseUrl: S,
    imageFit: k = Mn.COVER
  }, P) => {
    const D = s && s !== "" || a, V = Ei(t), z = V !== "", O = l ? on.EXTERNAL : u ? on.DOWNLOAD : on.DEFAULT, C = Te(() => {
      const Re = h === j.VARIANT_E || h === j.VARIANT_E_WITHOUT_DESCRIPTION, Ke = Re ? oe.VERTICAL : oe.HD, Bt = gh.includes(h), os = mh.includes(h), ls = _h.includes(h), cs = vh.includes(h);
      return {
        isVerticalLayout: Re,
        imageRatio: Ke,
        hasOverline: Bt,
        hasDescription: os,
        hasImage: ls,
        isCard: cs
      };
    }, [h]), { hasImage: M, isVerticalLayout: $, imageRatio: q, hasDescription: ie, hasOverline: H, isCard: W } = C(), re = i && /* @__PURE__ */ I(
      "span",
      {
        className: L(ee.teaser__title, (f || u) && ee["teaser__title--small"]),
        children: [
          i,
          !W && /* @__PURE__ */ d("span", { className: ee.teaser__icon, children: /* @__PURE__ */ d(F, { icon: O, height: `${Ie(24)}rem` }) })
        ]
      }
    ), ue = /* @__PURE__ */ I(ze, { children: [
      M && (e || z) && /* @__PURE__ */ I("div", { className: ee["teaser__media-container"], children: [
        z ? /* @__PURE__ */ d(
          "div",
          {
            className: L(
              ee.teaser__video,
              $ && ee["teaser__image--reduced-scale"],
              A && ee["teaser__image--loaded"]
            ),
            children: /* @__PURE__ */ d(
              Ti,
              {
                awsServiceBaseUrl: S,
                service: "aws",
                videoLoop: !0,
                videoId: V,
                previewAlt: n ?? "",
                playLabel: b ?? "",
                pauseLabel: E ?? "",
                onVideoStateChange: (Re) => {
                  m && m(Re);
                }
              }
            )
          }
        ) : /* @__PURE__ */ d(
          In,
          {
            src: e ?? "",
            alt: n ?? "",
            ratio: q,
            imageFit: k,
            slot: N
          }
        ),
        /* @__PURE__ */ d("div", { className: ee["teaser__image-border"] })
      ] }),
      /* @__PURE__ */ I("h3", { className: ee.teaser__heading, children: [
        re,
        H && D && /* @__PURE__ */ I("span", { className: ee.teaser__overline, children: [
          s,
          a && /* @__PURE__ */ d("span", { className: ee["teaser__overline-element"], children: a })
        ] })
      ] }),
      T && /* @__PURE__ */ d("p", { className: "teaser__author-description", children: T }),
      ie && r && /* @__PURE__ */ d("p", { className: ee.teaser__description, children: r }),
      !M && !W && /* @__PURE__ */ d("div", { className: ee.teaser__border }),
      W && /* @__PURE__ */ I(
        "div",
        {
          className: L(
            ee["teaser__buttons-wrapper"],
            R && ee["teaser__buttons-wrapper--align-left"]
          ),
          children: [
            o && _ && /* @__PURE__ */ d(
              St,
              {
                href: o,
                appearance: Me.SECONDARY,
                text: _,
                onClick: y
              }
            ),
            g
          ]
        }
      )
    ] });
    return /* @__PURE__ */ d(
      "div",
      {
        ref: P,
        slot: N,
        className: L(
          ee.teaser,
          W && ee["teaser--card"],
          v && ee["teaser--unpublished"],
          w && ee["teaser--in-draft"]
        ),
        children: W ? ue : /* @__PURE__ */ d(
          "a",
          {
            target: c,
            href: o,
            "aria-label": u ? `${p} ${i}` : i,
            onClick: y,
            className: ee["teaser__link-wrapper"],
            children: ue
          }
        )
      }
    );
  }
), et = {
  "icon-button": "icon-button",
  "icon-button--default": "icon-button--default",
  "icon-button--disabled": "icon-button--disabled",
  "icon-button--primary": "icon-button--primary",
  "icon-button--secondary": "icon-button--secondary",
  "icon-button--tertiary": "icon-button--tertiary",
  "icon-button--success": "icon-button--success",
  "icon-button--error": "icon-button--error"
};
var tt = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PRIMARY = "primary", e.SECONDARY = "secondary", e.TERTIARY = "tertiary", e.SUCCESS = "success", e.ERROR = "error", e))(tt || {});
const wh = 24, bh = ({
  icon: e,
  ariaLabel: t,
  appearance: n = tt.DEFAULT,
  type: i = $t.BUTTON,
  disabled: r = !1,
  onClick: s,
  ...a
}) => {
  const o = L(
    et["icon-button"],
    r && et["icon-button--disabled"],
    n === tt.DEFAULT && et["icon-button--default"],
    n === tt.PRIMARY && et["icon-button--primary"],
    n === tt.SECONDARY && et["icon-button--secondary"],
    n === tt.TERTIARY && et["icon-button--tertiary"],
    n === tt.SUCCESS && et["icon-button--success"],
    n === tt.ERROR && et["icon-button--error"]
  );
  return /* @__PURE__ */ d(
    "button",
    {
      className: o,
      type: i,
      disabled: r,
      onClick: s,
      "aria-label": t,
      ...a,
      children: /* @__PURE__ */ d(F, { icon: e, height: `${Ie(wh)}rem` })
    }
  );
}, yh = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])'
].join(", ");
function xh(e) {
  const t = G(null);
  return U(() => {
    if (!e) return;
    const n = t.current;
    if (!n) return;
    const i = (r) => {
      if (r.key !== "Tab") return;
      const s = n.querySelectorAll(yh);
      if (s.length === 0) return;
      const a = s[0], o = s[s.length - 1];
      if (r.shiftKey && document.activeElement === a) {
        r.preventDefault(), o.focus();
        return;
      }
      if (!r.shiftKey && document.activeElement === o) {
        r.preventDefault(), a.focus();
        return;
      }
      n.contains(document.activeElement) || (r.preventDefault(), a.focus());
    };
    return document.addEventListener("keydown", i), () => {
      document.removeEventListener("keydown", i);
    };
  }, [e]), t;
}
const Eh = "overlay", Sh = "overlay__header", Th = "overlay__title", Nh = "overlay__container", lt = {
  overlay: Eh,
  "overlay--open": "overlay--open",
  "overlay__sticky-header": "overlay__sticky-header",
  overlay__header: Sh,
  overlay__title: Th,
  overlay__container: Nh
}, ff = ({
  title: e,
  icon: t,
  closeButtonAriaLabel: n,
  isOpen: i,
  onClose: r,
  children: s
}) => {
  const a = xh(i);
  return En(i), Tt(r, i), U(() => {
    var o;
    i && ((o = a.current) == null || o.scrollTo({ top: 0, left: 0, behavior: "auto" }));
  }, [i]), /* @__PURE__ */ I(
    "div",
    {
      ref: a,
      className: `${lt.overlay} ${i ? lt["overlay--open"] : ""}`,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "overlay-title",
      children: [
        /* @__PURE__ */ d("div", { className: lt["overlay__sticky-header"], children: /* @__PURE__ */ d(wt, { layout: "12", noPadding: !0, children: /* @__PURE__ */ I("div", { className: lt.overlay__header, slot: "full", children: [
          /* @__PURE__ */ I("p", { className: lt.overlay__title, id: "overlay-title", children: [
            t && /* @__PURE__ */ d(F, { icon: t, width: "24" }),
            e
          ] }),
          r && /* @__PURE__ */ d(bh, { icon: "close", ariaLabel: n, onClick: r })
        ] }) }) }),
        /* @__PURE__ */ d("div", { className: lt.overlay__container, children: /* @__PURE__ */ d("div", { className: lt.overlay__content, children: s }) })
      ]
    }
  );
};
export {
  ne as Breakpoints,
  Zn as ContainerColor,
  xn as LinkTarget,
  Ih as RocheUIAccordion,
  Rh as RocheUIAddToCalendar,
  kh as RocheUIAnimatedWords,
  Lh as RocheUIAvatar,
  Ph as RocheUIBackToBranch,
  lo as RocheUIBreadcrumbs,
  St as RocheUIButton,
  Me as RocheUIButtonAppearance,
  yn as RocheUIButtonTarget,
  $t as RocheUIButtonType,
  Oh as RocheUIContactPerson,
  Qt as RocheUIContactPersonLayout,
  uo as RocheUIContainer,
  Dh as RocheUIDialog,
  Qn as RocheUIDialogPosition,
  Vh as RocheUIDrawer,
  vr as RocheUIDrawerDirection,
  $h as RocheUIDropdown,
  zh as RocheUIFooter,
  Hh as RocheUIFormWrapper,
  wt as RocheUIGrid,
  Bh as RocheUIHeader,
  _r as RocheUIHeadline,
  Fh as RocheUIHeroTeaser,
  wn as RocheUIHeroVariant,
  Gh as RocheUIHighlightBox,
  Uh as RocheUIHorizontalCenter,
  F as RocheUIIcon,
  bh as RocheUIIconButton,
  In as RocheUIImage,
  Mn as RocheUIImageFit,
  Bc as RocheUIImageLoading,
  oe as RocheUIImageRatio,
  hd as RocheUIInput,
  en as RocheUIInputType,
  Ur as RocheUILanguageSwitch,
  An as RocheUILanguageSwitchLayoutType,
  qh as RocheUILeadText,
  gd as RocheUILoadingSpinner,
  Wh as RocheUIMagnet,
  Yh as RocheUIMarketo,
  fc as RocheUIMessage,
  Nc as RocheUIMobileNavigation,
  ff as RocheUIOverlay,
  no as RocheUIOverline,
  Rd as RocheUIPagination,
  jh as RocheUIPodcast,
  Xh as RocheUIPublishedDate,
  Zh as RocheUIQuote,
  si as RocheUIQuoteLayout,
  ri as RocheUIQuoteSize,
  Kh as RocheUIResponsiveTable,
  Qh as RocheUIRichText,
  Jh as RocheUISearch,
  jd as RocheUISearchInput,
  nn as RocheUISearchTrigger,
  ef as RocheUISelect,
  tf as RocheUISideBySide,
  rn as RocheUISideBySideHorizontalAlignment,
  sn as RocheUISideBySideVerticalAlignment,
  at as RocheUISlideAnimation,
  nf as RocheUISlider,
  rf as RocheUISocialMedia,
  kt as RocheUISocialMediaAlignment,
  sf as RocheUIStageHome,
  af as RocheUIStageHomeTeaser,
  of as RocheUIStagingHero,
  lf as RocheUIStockPrice,
  cf as RocheUIStoryStagingHero,
  df as RocheUIStoryTeaser,
  Xp as RocheUIStoryTeaserLayout,
  je as RocheUIStoryType,
  uf as RocheUISubline,
  zn as RocheUITabs,
  pf as RocheUITag,
  hf as RocheUITeaser,
  j as RocheUITeaserLayout,
  Lt as RocheUITextLink,
  io as RocheUITextLinkIconSize,
  yt as RocheUITextLinkType,
  xi as RocheUITooltip,
  $r as RocheUITooltipContent,
  Ti as RocheUIVideoPlayer,
  Tt as useEscapeKey,
  Vr as useFloatingTooltip,
  Br as useFocusOutside
};
